import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
const bubbleData = [
  {
    "x": "1972-03-13",
    "y1": 0.25449955931944,
    "y2": 0.401477887342513,
    "y3": 0.319005306606783
  },
  {
    "x": "1972-03-20",
    "y1": 0.250906156657013,
    "y2": 0.491016373789511,
    "y3": 0.323904483380845
  },
  {
    "x": "1972-03-27",
    "y1": 0.255531764840269,
    "y2": 0.445021760020186,
    "y3": 0.331351250519931
  },
  {
    "x": "1972-04-03",
    "y1": 0.284094303310244,
    "y2": 0.454893607709866,
    "y3": 0.342814536146005
  },
  {
    "x": "1972-04-10",
    "y1": 0.299875803939177,
    "y2": 0.479947242186734,
    "y3": 0.356533548123755
  },
  {
    "x": "1972-04-17",
    "y1": 0.293377369936743,
    "y2": 0.448653438620519,
    "y3": 0.363042137562716
  },
  {
    "x": "1972-04-24",
    "y1": 0.280746795204294,
    "y2": 0.423597867762293,
    "y3": 0.371820874561268
  },
  {
    "x": "1972-05-01",
    "y1": 0.266279353425699,
    "y2": 0.492197311298193,
    "y3": 0.385032628364449
  },
  {
    "x": "1972-05-08",
    "y1": 0.266356690721469,
    "y2": 0.476135437775226,
    "y3": 0.397114824532591
  },
  {
    "x": "1972-05-15",
    "y1": 0.287370296789148,
    "y2": 0.463275402742442,
    "y3": 0.408311109457965
  },
  {
    "x": "1972-05-22",
    "y1": 0.300914434474777,
    "y2": 0.364318602740598,
    "y3": 0.411527272016848
  },
  {
    "x": "1972-05-29",
    "y1": 0.297704336038213,
    "y2": 0.356074677373012,
    "y3": 0.418290540137593
  },
  {
    "x": "1972-06-05",
    "y1": 0.275610291297005,
    "y2": 0.284510515208087,
    "y3": 0.418258521994072
  },
  {
    "x": "1972-06-12",
    "y1": 0.281047921803642,
    "y2": 0.399104572513312,
    "y3": 0.424220445130767
  },
  {
    "x": "1972-06-19",
    "y1": 0.272973595413864,
    "y2": 0.399104572513312,
    "y3": 0.422058449600058
  },
  {
    "x": "1972-06-26",
    "y1": 0.271898496440311,
    "y2": 0.399104572513312,
    "y3": 0.42589416105229
  },
  {
    "x": "1972-07-03",
    "y1": 0.282814841373866,
    "y2": 0.310444236420735,
    "y3": 0.421133036309436
  },
  {
    "x": "1972-07-10",
    "y1": 0.266693205501718,
    "y2": 0.284510515208087,
    "y3": 0.41663991568426
  },
  {
    "x": "1972-07-17",
    "y1": 0.253167099740789,
    "y2": 0.399104572513312,
    "y3": 0.414696259662628
  },
  {
    "x": "1972-07-24",
    "y1": 0.257241350733946,
    "y2": 0.452978938833176,
    "y3": 0.411273605254221
  },
  {
    "x": "1972-07-31",
    "y1": 0.27901278013546,
    "y2": 0.452978938833176,
    "y3": 0.413848657828755
  },
  {
    "x": "1972-08-07",
    "y1": 0.284664148858369,
    "y2": 0.523015955679112,
    "y3": 0.415448636923235
  },
  {
    "x": "1972-08-14",
    "y1": 0.282765606832964,
    "y2": 0.491722152112897,
    "y3": 0.41778365652787
  },
  {
    "x": "1972-08-21",
    "y1": 0.274243997005668,
    "y2": 0.46666658125467,
    "y3": 0.41837230520511
  },
  {
    "x": "1972-08-28",
    "y1": 0.277236855550332,
    "y2": 0.452978938833176,
    "y3": 0.417023890037432
  },
  {
    "x": "1972-09-04",
    "y1": 0.265224674203064,
    "y2": 0.373170851300665,
    "y3": 0.41324976067144
  },
  {
    "x": "1972-09-11",
    "y1": 0.253918187262308,
    "y2": 0.346065891669754,
    "y3": 0.409373161866813
  },
  {
    "x": "1972-09-18",
    "y1": 0.25227332874046,
    "y2": 0.302808506769003,
    "y3": 0.399903721640353
  },
  {
    "x": "1972-09-25",
    "y1": 0.269141377864279,
    "y2": 0.302808506769003,
    "y3": 0.391237375090042
  },
  {
    "x": "1972-10-02",
    "y1": 0.257722538881411,
    "y2": 0.205422971334261,
    "y3": 0.378344753519633
  },
  {
    "x": "1972-10-09",
    "y1": 0.250386221035595,
    "y2": 0.205422971334261,
    "y3": 0.370399971949316
  },
  {
    "x": "1972-10-16",
    "y1": 0.256754626909059,
    "y2": 0.294083307426838,
    "y3": 0.367300403452007
  },
  {
    "x": "1972-10-23",
    "y1": 0.268707742372316,
    "y2": 0.294083307426838,
    "y3": 0.367779043062945
  },
  {
    "x": "1972-10-30",
    "y1": 0.298121759159929,
    "y2": 0.223141196189608,
    "y3": 0.35898087424676
  },
  {
    "x": "1972-11-06",
    "y1": 0.296471832455674,
    "y2": 0.205422971334261,
    "y3": 0.349296794187807
  },
  {
    "x": "1972-11-13",
    "y1": 0.290537387480392,
    "y2": 0.178702479215845,
    "y3": 0.338276689522934
  },
  {
    "x": "1972-11-20",
    "y1": 0.295751642992057,
    "y2": 0.267362815308422,
    "y3": 0.336122618467318
  },
  {
    "x": "1972-11-27",
    "y1": 0.302667882199664,
    "y2": 0.244771662607627,
    "y3": 0.334135675837295
  },
  {
    "x": "1972-12-04",
    "y1": 0.311701714012587,
    "y2": 0.244771662607627,
    "y3": 0.326419030342011
  },
  {
    "x": "1972-12-11",
    "y1": 0.299715068135057,
    "y2": 0.15611132651505,
    "y3": 0.311575649726105
  },
  {
    "x": "1972-12-18",
    "y1": 0.282864921946418,
    "y2": 0.179119045104032,
    "y3": 0.297882655039647
  },
  {
    "x": "1972-12-25",
    "y1": 0.30152729984879,
    "y2": 0.246943412210469,
    "y3": 0.284079027866215
  },
  {
    "x": "1973-01-01",
    "y1": 0.317828862730852,
    "y2": 0.179119045104032,
    "y3": 0.268448872515772
  },
  {
    "x": "1973-01-08",
    "y1": 0.318564576379827,
    "y2": 0.133716093912205,
    "y3": 0.251801348148649
  },
  {
    "x": "1973-01-15",
    "y1": 0.302830443036113,
    "y2": 0.133716093912205,
    "y3": 0.2358382059026
  },
  {
    "x": "1973-01-22",
    "y1": 0.272129010599712,
    "y2": 0.183509731697804,
    "y3": 0.226355149922457
  },
  {
    "x": "1973-01-29",
    "y1": 0.246851642468123,
    "y2": 0.183509731697804,
    "y3": 0.21822734192386
  },
  {
    "x": "1973-02-05",
    "y1": 0.24194966009837,
    "y2": 0.183509731697804,
    "y3": 0.2122624031703
  },
  {
    "x": "1973-02-12",
    "y1": 0.231541289271729,
    "y2": 0.127468802006589,
    "y3": 0.203495417932179
  },
  {
    "x": "1973-02-19",
    "y1": 0.213797357840841,
    "y2": 0.0728386305148765,
    "y3": 0.19686620089121
  },
  {
    "x": "1973-02-26",
    "y1": 0.195569502729746,
    "y2": 0.0728386305148765,
    "y3": 0.190236983850241
  },
  {
    "x": "1973-03-05",
    "y1": 0.211221798490836,
    "y2": 0.0869500632806879,
    "y3": 0.179880321642933
  },
  {
    "x": "1973-03-12",
    "y1": 0.204909833112115,
    "y2": 0.0869500632806879,
    "y3": 0.169523659435626
  },
  {
    "x": "1973-03-19",
    "y1": 0.157475416826876,
    "y2": 0.0728386305148765,
    "y3": 0.162008531151889
  },
  {
    "x": "1973-03-26",
    "y1": 0.174709311715004,
    "y2": 0.161498966607454,
    "y3": 0.159812330915549
  },
  {
    "x": "1973-04-02",
    "y1": 0.139037572620293,
    "y2": 0.0646686958743536,
    "y3": 0.154110641748474
  },
  {
    "x": "1973-04-09",
    "y1": 0.156253116324964,
    "y2": 0.163670716210296,
    "y3": 0.148926036793568
  },
  {
    "x": "1973-04-16",
    "y1": 0.146966536881395,
    "y2": 0.0750103801177183,
    "y3": 0.140437972669072
  },
  {
    "x": "1973-04-23",
    "y1": 0.0965942204281498,
    "y2": 0.0599589688462875,
    "y3": 0.131197337981005
  },
  {
    "x": "1973-04-30",
    "y1": 0.119564680102683,
    "y2": 0.148619304938865,
    "y3": 0.130822736902196
  },
  {
    "x": "1973-05-07",
    "y1": 0.103422548933238,
    "y2": 0.0599589688462875,
    "y3": 0.124864733089309
  },
  {
    "x": "1973-05-14",
    "y1": 0.0465022998835031,
    "y2": 0.137565863954628,
    "y3": 0.119395855676517
  },
  {
    "x": "1973-05-21",
    "y1": 0.0686618760602165,
    "y2": 0.144831808098031,
    "y3": 0.117681493826217
  },
  {
    "x": "1973-05-28",
    "y1": 0.0413727711143636,
    "y2": 0.0489055278620507,
    "y3": 0.113440965523709
  },
  {
    "x": "1973-06-04",
    "y1": 0.0552534957144094,
    "y2": 0.147544270961116,
    "y3": 0.114132374376155
  },
  {
    "x": "1973-06-11",
    "y1": 0.0411771452777574,
    "y2": 0.0588839348685388,
    "y3": 0.107901084534692
  },
  {
    "x": "1973-06-18",
    "y1": 0.0287577804632613,
    "y2": 0.0588839348685388,
    "y3": 0.101669794693228
  },
  {
    "x": "1973-06-25",
    "y1": 0.0286588151493953,
    "y2": 0.137565863954628,
    "y3": 0.0993726013060695
  },
  {
    "x": "1973-07-02",
    "y1": 0.0138043890240767,
    "y2": 0.0489055278620507,
    "y3": 0.0954444375988426
  },
  {
    "x": "1973-07-09",
    "y1": 0.0494899067419033,
    "y2": 0.155163352966194,
    "y3": 0.0995606737214085
  },
  {
    "x": "1973-07-16",
    "y1": 0.0946224077704608,
    "y2": 0.115748004042841,
    "y3": 0.101706142397807
  },
  {
    "x": "1973-07-23",
    "y1": 0.110224193621264,
    "y2": 0.115748004042841,
    "y3": 0.103146039435914
  },
  {
    "x": "1973-07-30",
    "y1": 0.0869981429505315,
    "y2": 0.066503016873616,
    "y3": 0.102123687115561
  },
  {
    "x": "1973-08-06",
    "y1": 0.072955828737038,
    "y2": 0.155163352966194,
    "y3": 0.106239923238127
  },
  {
    "x": "1973-08-13",
    "y1": 0.0576690777399183,
    "y2": 0.155163352966194,
    "y3": 0.105923142556064
  },
  {
    "x": "1973-08-20",
    "y1": 0.0450377252169394,
    "y2": 0.137565863954628,
    "y3": 0.109568000960077
  },
  {
    "x": "1973-08-27",
    "y1": 0.0691588305284356,
    "y2": 0.111905968065443,
    "y3": 0.106979763552835
  },
  {
    "x": "1973-09-03",
    "y1": 0.0896603451672771,
    "y2": 0.0622717355496063,
    "y3": 0.106342831324429
  },
  {
    "x": "1973-09-10",
    "y1": 0.0807835279551571,
    "y2": 0.0622717355496063,
    "y3": 0.106458469659595
  },
  {
    "x": "1973-09-17",
    "y1": 0.112743548690539,
    "y2": 0.151870770122486,
    "y3": 0.106621042918776
  },
  {
    "x": "1973-09-24",
    "y1": 0.128639747103867,
    "y2": 0.131809877565808,
    "y3": 0.110213588354752
  },
  {
    "x": "1973-10-01",
    "y1": 0.140869968755623,
    "y2": 0.204408340135419,
    "y3": 0.113555712163792
  },
  {
    "x": "1973-10-08",
    "y1": 0.154551569225858,
    "y2": 0.120606193865405,
    "y3": 0.11234443145216
  },
  {
    "x": "1973-10-15",
    "y1": 0.14710197689029,
    "y2": 0.230648096430341,
    "y3": 0.121431559880575
  },
  {
    "x": "1973-10-22",
    "y1": 0.143040174819891,
    "y2": 0.270296404101357,
    "y3": 0.127569166537587
  },
  {
    "x": "1973-10-29",
    "y1": 0.108817277585921,
    "y2": 0.24524083324313,
    "y3": 0.136887011456316
  },
  {
    "x": "1973-11-05",
    "y1": 0.0798077884345721,
    "y2": 0.173007915825783,
    "y3": 0.142593210504179
  },
  {
    "x": "1973-11-12",
    "y1": 0.0383026401980359,
    "y2": 0.166407367708951,
    "y3": 0.144035285691895
  },
  {
    "x": "1973-11-19",
    "y1": -0.00194192788437867,
    "y2": 0.144831808098031,
    "y3": 0.148831599703694
  },
  {
    "x": "1973-11-26",
    "y1": -0.0408936318582345,
    "y2": 0.0943084790538781,
    "y3": 0.145788856008078
  },
  {
    "x": "1973-12-03",
    "y1": -0.0536195693432171,
    "y2": 0.0943084790538781,
    "y3": 0.14471687975863
  },
  {
    "x": "1973-12-10",
    "y1": -0.0827573775136937,
    "y2": 0.0449647358589749,
    "y3": 0.141177716349437
  },
  {
    "x": "1973-12-17",
    "y1": -0.0839846520168999,
    "y2": 0.0510772774648924,
    "y3": 0.140406429379
  },
  {
    "x": "1973-12-24",
    "y1": -0.0598559238767311,
    "y2": 0.0510772774648924,
    "y3": 0.135202125603935
  },
  {
    "x": "1973-12-31",
    "y1": -0.0334597833783688,
    "y2": 0.0843475797332054,
    "y3": 0.131661336942286
  },
  {
    "x": "1974-01-07",
    "y1": -0.0533322079002648,
    "y2": 0.0717877851726977,
    "y3": 0.128372433003189
  },
  {
    "x": "1974-01-14",
    "y1": -0.0198290503005386,
    "y2": 0.110309729956139,
    "y3": 0.128292621097724
  },
  {
    "x": "1974-01-21",
    "y1": -0.0189897528675674,
    "y2": 0.238818031070864,
    "y3": 0.137119935873787
  },
  {
    "x": "1974-01-28",
    "y1": -0.0320924780248716,
    "y2": 0.24524083324313,
    "y3": 0.146268390758463
  },
  {
    "x": "1974-02-04",
    "y1": -0.0528041566869344,
    "y2": 0.18125184119337,
    "y3": 0.147737444312007
  },
  {
    "x": "1974-02-11",
    "y1": -0.0660361917377973,
    "y2": 0.27846633874188,
    "y3": 0.155070267370811
  },
  {
    "x": "1974-02-18",
    "y1": -0.0446029440317938,
    "y2": 0.253410767883653,
    "y3": 0.157520388758223
  },
  {
    "x": "1974-02-25",
    "y1": -0.032550832303568,
    "y2": 0.230327026515401,
    "y3": 0.163006430390722
  },
  {
    "x": "1974-03-04",
    "y1": -0.0206423253301962,
    "y2": 0.199033222949186,
    "y3": 0.161425686716665
  },
  {
    "x": "1974-03-11",
    "y1": -0.00635210113646135,
    "y2": 0.17397765209096,
    "y3": 0.156609749116145
  },
  {
    "x": "1974-03-18",
    "y1": -0.0175403518845419,
    "y2": 0.153916759534282,
    "y3": 0.152043545430702
  },
  {
    "x": "1974-03-25",
    "y1": -0.0508562283313494,
    "y2": 0.185887577494372,
    "y3": 0.152687528514132
  },
  {
    "x": "1974-04-01",
    "y1": -0.0678715068828111,
    "y2": 0.17928702937754,
    "y3": 0.153331511597561
  },
  {
    "x": "1974-04-08",
    "y1": -0.0779045395546218,
    "y2": 0.161601045113926,
    "y3": 0.154169973448356
  },
  {
    "x": "1974-04-15",
    "y1": -0.0721132862105484,
    "y2": 0.105361920038115,
    "y3": 0.154722645497568
  },
  {
    "x": "1974-04-22",
    "y1": -0.117180275523482,
    "y2": 0.053999722402612,
    "y3": 0.152707207665005
  },
  {
    "x": "1974-04-29",
    "y1": -0.102917713053611,
    "y2": 0.107533669640957,
    "y3": 0.155835654354104
  },
  {
    "x": "1974-05-06",
    "y1": -0.139158688527554,
    "y2": 0.053999722402612,
    "y3": 0.15598177660099
  },
  {
    "x": "1974-05-13",
    "y1": -0.167272599094401,
    "y2": 0.14266005849519,
    "y3": 0.160560915652505
  },
  {
    "x": "1974-05-20",
    "y1": -0.173131299877333,
    "y2": 0.14266005849519,
    "y3": 0.163476539590604
  },
  {
    "x": "1974-05-27",
    "y1": -0.188478139003605,
    "y2": 0.0489055278620507,
    "y3": 0.162332426725071
  },
  {
    "x": "1974-06-03",
    "y1": -0.14471252466704,
    "y2": 0.137565863954628,
    "y3": 0.163695233424996
  },
  {
    "x": "1974-06-10",
    "y1": -0.156061192193407,
    "y2": 0.0489055278620507,
    "y3": 0.154199608264555
  },
  {
    "x": "1974-06-17",
    "y1": -0.200164641101863,
    "y2": 0.0427540476621275,
    "y3": 0.144075268985505
  },
  {
    "x": "1974-06-24",
    "y1": -0.239982635054283,
    "y2": 0.129780396826601,
    "y3": 0.141501696767167
  },
  {
    "x": "1974-07-01",
    "y1": -0.271446555781699,
    "y2": 0.127761942386001,
    "y3": 0.133966476949373
  },
  {
    "x": "1974-07-08",
    "y1": -0.297136366811851,
    "y2": 0.126320189214144,
    "y3": 0.127611948015897
  },
  {
    "x": "1974-07-15",
    "y1": -0.273140814169828,
    "y2": 0.0866763070880924,
    "y3": 0.120429412044532
  },
  {
    "x": "1974-07-22",
    "y1": -0.280906477425615,
    "y2": 0.041273355896265,
    "y3": 0.112541418691886
  },
  {
    "x": "1974-07-29",
    "y1": -0.328002457364382,
    "y2": 0.0376598531215662,
    "y3": 0.105725528743416
  },
  {
    "x": "1974-08-05",
    "y1": -0.309414548327431,
    "y2": 0.147568459596686,
    "y3": 0.105408113746536
  },
  {
    "x": "1974-08-12",
    "y1": -0.377741067838562,
    "y2": 0.0617040436146973,
    "y3": 0.0991989370525525
  },
  {
    "x": "1974-08-19",
    "y1": -0.427695530107581,
    "y2": 0.132646154851928,
    "y3": 0.0968668933262719
  },
  {
    "x": "1974-08-26",
    "y1": -0.430891962326135,
    "y2": 0.162412933081105,
    "y3": 0.0969074877246309
  },
  {
    "x": "1974-09-02",
    "y1": -0.457667626869101,
    "y2": 0.04398581875935,
    "y3": 0.0938386826606926
  },
  {
    "x": "1974-09-09",
    "y1": -0.52422447801817,
    "y2": 0.0830628043133937,
    "y3": 0.0952918367562317
  },
  {
    "x": "1974-09-16",
    "y1": -0.467041250217389,
    "y2": 0.0969090959305769,
    "y3": 0.0947606080707127
  },
  {
    "x": "1974-09-23",
    "y1": -0.513451976814668,
    "y2": 0.0376598531215662,
    "y3": 0.0939436146066605
  },
  {
    "x": "1974-09-30",
    "y1": -0.547765686918373,
    "y2": 0.123340565992306,
    "y3": 0.0929776399815163
  },
  {
    "x": "1974-10-07",
    "y1": -0.452406761318594,
    "y2": 0.0746078939188562,
    "y3": 0.0895750317526996
  },
  {
    "x": "1974-10-14",
    "y1": -0.413843340238382,
    "y2": 0.0516049007644272,
    "y3": 0.0897100003978184
  },
  {
    "x": "1974-10-21",
    "y1": -0.411771610069215,
    "y2": 0.0516049007644272,
    "y3": 0.0854119522383084
  },
  {
    "x": "1974-10-28",
    "y1": -0.377102455275197,
    "y2": 0.191015223362768,
    "y3": 0.0925174370133442
  },
  {
    "x": "1974-11-04",
    "y1": -0.354815264496703,
    "y2": 0.210944136414962,
    "y3": 0.100926941450986
  },
  {
    "x": "1974-11-11",
    "y1": -0.386389439908992,
    "y2": 0.223326185030904,
    "y3": 0.105604230861201
  },
  {
    "x": "1974-11-18",
    "y1": -0.422719261896904,
    "y2": 0.172709396990371,
    "y3": 0.10785160359142
  },
  {
    "x": "1974-11-25",
    "y1": -0.408541703133542,
    "y2": 0.162412933081105,
    "y3": 0.109656240784768
  },
  {
    "x": "1974-12-02",
    "y1": -0.483839584325266,
    "y2": 0.128491938816986,
    "y3": 0.111747022371212
  },
  {
    "x": "1974-12-09",
    "y1": -0.46648857673008,
    "y2": 0.128491938816986,
    "y3": 0.116107951517248
  },
  {
    "x": "1974-12-16",
    "y1": -0.475776030975615,
    "y2": 0.039831602724408,
    "y3": 0.116216538997391
  },
  {
    "x": "1974-12-23",
    "y1": -0.474582857092775,
    "y2": 0.0568896690635089,
    "y3": 0.111682599470732
  },
  {
    "x": "1974-12-30",
    "y1": -0.432192700596026,
    "y2": 0.0840490608977932,
    "y3": 0.112799850334886
  },
  {
    "x": "1975-01-06",
    "y1": -0.392016331122501,
    "y2": 0.114604956381648,
    "y3": 0.111897790411372
  },
  {
    "x": "1975-01-13",
    "y1": -0.380868538463071,
    "y2": 0.1619321079934,
    "y3": 0.111873749156987
  },
  {
    "x": "1975-01-20",
    "y1": -0.36565121386184,
    "y2": 0.214884928418038,
    "y3": 0.120418704639922
  },
  {
    "x": "1975-01-27",
    "y1": -0.298352319540628,
    "y2": 0.29092123419583,
    "y3": 0.130811626134043
  },
  {
    "x": "1975-02-03",
    "y1": -0.279149052261656,
    "y2": 0.230648096430341,
    "y3": 0.137498576159032
  },
  {
    "x": "1975-02-10",
    "y1": -0.24905907325429,
    "y2": 0.238818031070864,
    "y3": 0.147556485056496
  },
  {
    "x": "1975-02-17",
    "y1": -0.241824582893352,
    "y2": 0.230327026515401,
    "y3": 0.152905808082651
  },
  {
    "x": "1975-02-24",
    "y1": -0.25253065289912,
    "y2": 0.287693559041764,
    "y3": 0.163560091338797
  },
  {
    "x": "1975-03-03",
    "y1": -0.233352549804889,
    "y2": 0.233349875326975,
    "y3": 0.172647340066924
  },
  {
    "x": "1975-03-10",
    "y1": -0.210906338317051,
    "y2": 0.219380603282787,
    "y3": 0.181036125192842
  },
  {
    "x": "1975-03-17",
    "y1": -0.212878226400142,
    "y2": 0.288513522497694,
    "y3": 0.185911040149588
  },
  {
    "x": "1975-03-24",
    "y1": -0.209453540645383,
    "y2": 0.281977269612845,
    "y3": 0.189462696809482
  },
  {
    "x": "1975-03-31",
    "y1": -0.228487367666039,
    "y2": 0.30437250221569,
    "y3": 0.193515012668722
  },
  {
    "x": "1975-04-07",
    "y1": -0.207344665529206,
    "y2": 0.442344483127479,
    "y3": 0.206996766975577
  },
  {
    "x": "1975-04-14",
    "y1": -0.184149745740329,
    "y2": 0.411050679561264,
    "y3": 0.219428654299585
  },
  {
    "x": "1975-04-21",
    "y1": -0.176977646028992,
    "y2": 0.297334772610459,
    "y3": 0.227870795989259
  },
  {
    "x": "1975-04-28",
    "y1": -0.156504596399702,
    "y2": 0.432771690908727,
    "y3": 0.243084783593846
  },
  {
    "x": "1975-05-05",
    "y1": -0.124479678084136,
    "y2": 0.42741160855516,
    "y3": 0.262463783885383
  },
  {
    "x": "1975-05-12",
    "y1": -0.129067908642192,
    "y2": 0.540734180534459,
    "y3": 0.286656009458931
  },
  {
    "x": "1975-05-19",
    "y1": -0.126884498891522,
    "y2": 0.651539417407575,
    "y3": 0.31503052728442
  },
  {
    "x": "1975-05-26",
    "y1": -0.121074819496917,
    "y2": 0.62024561384136,
    "y3": 0.340312560157406
  },
  {
    "x": "1975-06-02",
    "y1": -0.100978571607509,
    "y2": 0.692471746915018,
    "y3": 0.366839542103486
  },
  {
    "x": "1975-06-09",
    "y1": -0.116786008093945,
    "y2": 0.652962920261096,
    "y3": 0.388743441695639
  },
  {
    "x": "1975-06-16",
    "y1": -0.095091203443663,
    "y2": 0.592864987589826,
    "y3": 0.403840629365339
  },
  {
    "x": "1975-06-23",
    "y1": -0.0803093854262083,
    "y2": 0.644042498748318,
    "y3": 0.424510349481238
  },
  {
    "x": "1975-06-30",
    "y1": -0.083777628799131,
    "y2": 0.612748695182103,
    "y3": 0.4432068826868
  },
  {
    "x": "1975-07-07",
    "y1": -0.0721767003141748,
    "y2": 0.587139571378148,
    "y3": 0.461047509929937
  },
  {
    "x": "1975-07-14",
    "y1": -0.0742409240696254,
    "y2": 0.453017454556289,
    "y3": 0.469313704705664
  },
  {
    "x": "1975-07-21",
    "y1": -0.113542214587634,
    "y2": 0.515781536177938,
    "y3": 0.483435287748212
  },
  {
    "x": "1975-07-28",
    "y1": -0.137226374440245,
    "y2": 0.468299328536976,
    "y3": 0.495881224010921
  },
  {
    "x": "1975-08-04",
    "y1": -0.162587800869637,
    "y2": 0.399104572513312,
    "y3": 0.501410776511702
  },
  {
    "x": "1975-08-11",
    "y1": -0.174781404684737,
    "y2": 0.422518152181514,
    "y3": 0.508437820640136
  },
  {
    "x": "1975-08-18",
    "y1": -0.201887600067526,
    "y2": 0.379260767280763,
    "y3": 0.512182233893389
  },
  {
    "x": "1975-08-25",
    "y1": -0.168401592347716,
    "y2": 0.383026793125466,
    "y3": 0.509216349393289
  },
  {
    "x": "1975-09-01",
    "y1": -0.183969284078856,
    "y2": 0.432405968384442,
    "y3": 0.510284113834447
  },
  {
    "x": "1975-09-08",
    "y1": -0.223310986401025,
    "y2": 0.383026793125466,
    "y3": 0.514568714860198
  },
  {
    "x": "1975-09-15",
    "y1": -0.200960904205328,
    "y2": 0.497895999160966,
    "y3": 0.51782493027281
  },
  {
    "x": "1975-09-22",
    "y1": -0.20423358390159,
    "y2": 0.400745017980813,
    "y3": 0.516491600744093
  },
  {
    "x": "1975-09-29",
    "y1": -0.212639144642052,
    "y2": 0.422518152181514,
    "y3": 0.510580799326445
  },
  {
    "x": "1975-10-06",
    "y1": -0.193301408423872,
    "y2": 0.333857816088936,
    "y3": 0.494696719260513
  },
  {
    "x": "1975-10-13",
    "y1": -0.184595610906776,
    "y2": 0.333857816088936,
    "y3": 0.480377329372892
  },
  {
    "x": "1975-10-20",
    "y1": -0.171842737942833,
    "y2": 0.399104572513312,
    "y3": 0.465708970652807
  },
  {
    "x": "1975-10-27",
    "y1": -0.192575437330628,
    "y2": 0.205422971334261,
    "y3": 0.443331973206465
  },
  {
    "x": "1975-11-03",
    "y1": -0.189717907433142,
    "y2": 0.294083307426838,
    "y3": 0.428392889198316
  },
  {
    "x": "1975-11-10",
    "y1": -0.166793360179561,
    "y2": 0.294083307426838,
    "y3": 0.410894929632242
  },
  {
    "x": "1975-11-17",
    "y1": -0.18249360632364,
    "y2": 0.178702479215845,
    "y3": 0.389192618833929
  },
  {
    "x": "1975-11-24",
    "y1": -0.168858344976633,
    "y2": 0.29625505702968,
    "y3": 0.374648393116505
  },
  {
    "x": "1975-12-01",
    "y1": -0.220635015954359,
    "y2": 0.133716093912205,
    "y3": 0.358683325084301
  },
  {
    "x": "1975-12-08",
    "y1": -0.218092156769373,
    "y2": 0.183509731697804,
    "y3": 0.342069734860294
  },
  {
    "x": "1975-12-15",
    "y1": -0.204609384676721,
    "y2": 0.224548179607624,
    "y3": 0.329882177413827
  },
  {
    "x": "1975-12-22",
    "y1": -0.188671567057442,
    "y2": 0.135887843515046,
    "y3": 0.316721340963913
  },
  {
    "x": "1975-12-29",
    "y1": -0.176613997521685,
    "y2": 0.168614620986054,
    "y3": 0.304026164404141
  },
  {
    "x": "1976-01-05",
    "y1": -0.122168697330511,
    "y2": 0.229811582221178,
    "y3": 0.296553705151161
  },
  {
    "x": "1976-01-12",
    "y1": -0.0979917376392235,
    "y2": 0.229811582221178,
    "y3": 0.288892944605947
  },
  {
    "x": "1976-01-19",
    "y1": -0.0866038485559545,
    "y2": 0.247529807076526,
    "y3": 0.279649136540551
  },
  {
    "x": "1976-01-26",
    "y1": -0.0656092336054735,
    "y2": 0.247529807076526,
    "y3": 0.272874287238104
  },
  {
    "x": "1976-02-02",
    "y1": -0.0633117385884627,
    "y2": 0.279866109779426,
    "y3": 0.261972792769027
  },
  {
    "x": "1976-02-09",
    "y1": -0.0437128952134179,
    "y2": 0.326715843681343,
    "y3": 0.258271334054053
  },
  {
    "x": "1976-02-16",
    "y1": -0.0205564475988259,
    "y2": 0.326715843681343,
    "y3": 0.253481218629045
  },
  {
    "x": "1976-02-23",
    "y1": -0.0289062007834612,
    "y2": 0.229811582221178,
    "y3": 0.248278906935657
  },
  {
    "x": "1976-03-01",
    "y1": -0.0376587035181164,
    "y2": 0.279866109779426,
    "y3": 0.245579321620182
  },
  {
    "x": "1976-03-08",
    "y1": -0.0206698064316292,
    "y2": 0.318471918313756,
    "y3": 0.241547688910204
  },
  {
    "x": "1976-03-15",
    "y1": -0.0366055903890388,
    "y2": 0.249655875073554,
    "y3": 0.243759334097168
  },
  {
    "x": "1976-03-22",
    "y1": -0.0215285470529024,
    "y2": 0.269534564911264,
    "y3": 0.24253189697139
  },
  {
    "x": "1976-03-29",
    "y1": -0.0243891713017357,
    "y2": 0.178702479215845,
    "y3": 0.23676285556084
  },
  {
    "x": "1976-04-05",
    "y1": -0.0435880890607662,
    "y2": 0.133716093912205,
    "y3": 0.234513536295658
  },
  {
    "x": "1976-04-12",
    "y1": -0.0404381421463838,
    "y2": 0.222376430004782,
    "y3": 0.230819604944413
  },
  {
    "x": "1976-04-19",
    "y1": -0.0244013547230349,
    "y2": 0.238055507588765,
    "y3": 0.236036575628241
  },
  {
    "x": "1976-04-26",
    "y1": -0.0301408321162375,
    "y2": 0.238055507588765,
    "y3": 0.238763864422789
  },
  {
    "x": "1976-05-03",
    "y1": -0.0308069642961727,
    "y2": 0.405666731277816,
    "y3": 0.247819792006299
  },
  {
    "x": "1976-05-10",
    "y1": -0.0334730148707037,
    "y2": 0.374372927711601,
    "y3": 0.259744046216127
  },
  {
    "x": "1976-05-17",
    "y1": -0.0378169600138437,
    "y2": 0.521432027001305,
    "y3": 0.277384916516889
  },
  {
    "x": "1976-05-24",
    "y1": -0.0529193034900584,
    "y2": 0.318471918313756,
    "y3": 0.281817933321518
  },
  {
    "x": "1976-05-31",
    "y1": -0.0562132711469374,
    "y2": 0.417916800389274,
    "y3": 0.291223194229923
  },
  {
    "x": "1976-06-07",
    "y1": -0.0566691220361379,
    "y2": 0.49013822343509,
    "y3": 0.303353615047851
  },
  {
    "x": "1976-06-14",
    "y1": -0.029990248570052,
    "y2": 0.376422316484286,
    "y3": 0.309798240518239
  },
  {
    "x": "1976-06-21",
    "y1": -0.029990248570052,
    "y2": 0.356361423927608,
    "y3": 0.313623006225648
  },
  {
    "x": "1976-06-28",
    "y1": -0.020773211662423,
    "y2": 0.366233271617288,
    "y3": 0.315598877622445
  },
  {
    "x": "1976-07-05",
    "y1": -0.0141710316266719,
    "y2": 0.371091461439852,
    "y3": 0.317817658510371
  },
  {
    "x": "1976-07-12",
    "y1": -0.00411420898581899,
    "y2": 0.431737108767817,
    "y3": 0.327913934837703
  },
  {
    "x": "1976-07-19",
    "y1": -0.0127722505285321,
    "y2": 0.397559462187583,
    "y3": 0.333798602458111
  },
  {
    "x": "1976-07-26",
    "y1": -0.0161565034079831,
    "y2": 0.416892635283398,
    "y3": 0.338719638306593
  },
  {
    "x": "1976-08-02",
    "y1": -0.0123225843521058,
    "y2": 0.411607866984316,
    "y3": 0.346817237902131
  },
  {
    "x": "1976-08-09",
    "y1": -0.0104675192050351,
    "y2": 0.338185479546909,
    "y3": 0.350249783633913
  },
  {
    "x": "1976-08-16",
    "y1": -0.0281126031857161,
    "y2": 0.304980256371845,
    "y3": 0.356563672491713
  },
  {
    "x": "1976-08-23",
    "y1": -0.0397547256309391,
    "y2": 0.304980256371845,
    "y3": 0.365126880614695
  },
  {
    "x": "1976-08-30",
    "y1": -0.0186643367338051,
    "y2": 0.568607578279312,
    "y3": 0.382438438028422
  },
  {
    "x": "1976-09-06",
    "y1": -0.016796551580983,
    "y2": 0.448653438620519,
    "y3": 0.392968334580009
  },
  {
    "x": "1976-09-13",
    "y1": -0.0121908036075121,
    "y2": 0.315328448886661,
    "y3": 0.396831981644904
  },
  {
    "x": "1976-09-20",
    "y1": -0.00454974975336451,
    "y2": 0.315328448886661,
    "y3": 0.392315067525346
  },
  {
    "x": "1976-09-27",
    "y1": -0.0248075242809884,
    "y2": 0.257405555577176,
    "y3": 0.386466698918625
  },
  {
    "x": "1976-10-04",
    "y1": -0.0365280589932141,
    "y2": 0.294083307426838,
    "y3": 0.375099262939902
  },
  {
    "x": "1976-10-11",
    "y1": -0.0401082749772997,
    "y2": 0.244771662607627,
    "y3": 0.371414250154595
  },
  {
    "x": "1976-10-18",
    "y1": -0.0378625464446313,
    "y2": 0.244771662607627,
    "y3": 0.362756993265513
  },
  {
    "x": "1976-10-25",
    "y1": -0.0256510708474534,
    "y2": 0.15611132651505,
    "y3": 0.346055648419511
  },
  {
    "x": "1976-11-01",
    "y1": -0.0353909409999695,
    "y2": 0.133716093912205,
    "y3": 0.333920337290907
  },
  {
    "x": "1976-11-08",
    "y1": -0.0507033667056821,
    "y2": 0.0948493956052264,
    "y3": 0.320844735874788
  },
  {
    "x": "1976-11-15",
    "y1": -0.0294774554801406,
    "y2": 0.183509731697804,
    "y3": 0.311708558878814
  },
  {
    "x": "1976-11-22",
    "y1": -0.0133610063463317,
    "y2": 0.156318531233479,
    "y3": 0.300969912368495
  },
  {
    "x": "1976-11-29",
    "y1": -0.00362572514446922,
    "y2": 0.138600306378131,
    "y3": 0.286313072249011
  },
  {
    "x": "1976-12-06",
    "y1": 0.0213987061098162,
    "y2": 0.173899389285135,
    "y3": 0.275130068603888
  },
  {
    "x": "1976-12-13",
    "y1": 0.0216100424286278,
    "y2": 0.173899389285135,
    "y3": 0.262980406303975
  },
  {
    "x": "1976-12-20",
    "y1": 0.0277385487134464,
    "y2": 0.262559725377713,
    "y3": 0.255527999223645
  },
  {
    "x": "1976-12-27",
    "y1": 0.0556738143993756,
    "y2": 0.385995108703037,
    "y3": 0.257918480681451
  },
  {
    "x": "1977-01-03",
    "y1": 0.0520980227775703,
    "y2": 0.315052997465807,
    "y3": 0.25842211773615
  },
  {
    "x": "1977-01-10",
    "y1": 0.0487144296761138,
    "y2": 0.385995108703037,
    "y3": 0.262472860352709
  },
  {
    "x": "1977-01-17",
    "y1": 0.0499490258731274,
    "y2": 0.241893493177758,
    "y3": 0.246137156097631
  },
  {
    "x": "1977-01-24",
    "y1": 0.0335084331980517,
    "y2": 0.285150878078508,
    "y3": 0.237962028070531
  },
  {
    "x": "1977-01-31",
    "y1": 0.0441644782258258,
    "y2": 0.285150878078508,
    "y3": 0.236453149530123
  },
  {
    "x": "1977-02-07",
    "y1": 0.0374454215767421,
    "y2": 0.191205773686849,
    "y3": 0.230247015770133
  },
  {
    "x": "1977-02-14",
    "y1": 0.0404634351741991,
    "y2": 0.277273880053781,
    "y3": 0.231240431993963
  },
  {
    "x": "1977-02-21",
    "y1": 0.0251075961026579,
    "y2": 0.261212006530815,
    "y3": 0.229596866949162
  },
  {
    "x": "1977-02-28",
    "y1": 0.0374363437331441,
    "y2": 0.293754922689858,
    "y3": 0.232046029953273
  },
  {
    "x": "1977-03-07",
    "y1": 0.0374363437331441,
    "y2": 0.326715843681343,
    "y3": 0.236143239006959
  },
  {
    "x": "1977-03-14",
    "y1": 0.0412877307192728,
    "y2": 0.178702479215845,
    "y3": 0.237272796641999
  },
  {
    "x": "1977-03-21",
    "y1": 0.0292594889861377,
    "y2": 0.178702479215845,
    "y3": 0.239522115907181
  },
  {
    "x": "1977-03-28",
    "y1": 0.0214929286035789,
    "y2": 0.244771662607627,
    "y3": 0.247018229257301
  },
  {
    "x": "1977-04-04",
    "y1": 0.0160983640669638,
    "y2": 0.222376430004782,
    "y3": 0.24896156417265
  },
  {
    "x": "1977-04-11",
    "y1": 0.0398142354472002,
    "y2": 0.246943412210469,
    "y3": 0.253492808221499
  },
  {
    "x": "1977-04-18",
    "y1": 0.0279713166403309,
    "y2": 0.158283076117891,
    "y3": 0.254476946708487
  },
  {
    "x": "1977-04-25",
    "y1": 0.0317560159670401,
    "y2": 0.158283076117891,
    "y3": 0.253696131050125
  },
  {
    "x": "1977-05-02",
    "y1": 0.0466282208164359,
    "y2": 0.180874228818686,
    "y3": 0.254044873026803
  },
  {
    "x": "1977-05-09",
    "y1": 0.0518914006740158,
    "y2": 0.180874228818686,
    "y3": 0.249960598198851
  },
  {
    "x": "1977-05-16",
    "y1": 0.0579482358624958,
    "y2": 0.349872342623392,
    "y3": 0.248154459894869
  },
  {
    "x": "1977-05-23",
    "y1": 0.0365196800041172,
    "y2": 0.180874228818686,
    "y3": 0.241445521462513
  },
  {
    "x": "1977-05-30",
    "y1": 0.0395436728186438,
    "y2": 0.246943412210469,
    "y3": 0.234492936637885
  },
  {
    "x": "1977-06-06",
    "y1": 0.0486922041741141,
    "y2": 0.269534564911264,
    "y3": 0.23587499022456
  },
  {
    "x": "1977-06-13",
    "y1": 0.0645570534619364,
    "y2": 0.180874228818686,
    "y3": 0.230661157761569
  },
  {
    "x": "1977-06-20",
    "y1": 0.0752050916452724,
    "y2": 0.322390343468686,
    "y3": 0.232523131031078
  },
  {
    "x": "1977-06-27",
    "y1": 0.077613257960249,
    "y2": 0.297334772610459,
    "y3": 0.237829580977258
  },
  {
    "x": "1977-07-04",
    "y1": 0.086722327217662,
    "y2": 0.423384956133164,
    "y3": 0.245135134781227
  },
  {
    "x": "1977-07-11",
    "y1": 0.0926741784035214,
    "y2": 0.463033263804179,
    "y3": 0.255226197644896
  },
  {
    "x": "1977-07-18",
    "y1": 0.109437780482725,
    "y2": 0.437977692945952,
    "y3": 0.2624373361577
  },
  {
    "x": "1977-07-25",
    "y1": 0.0855797737917066,
    "y2": 0.238055507588765,
    "y3": 0.258004319353071
  },
  {
    "x": "1977-08-01",
    "y1": 0.0876662028159397,
    "y2": 0.417916800389274,
    "y3": 0.269965035411743
  },
  {
    "x": "1977-08-08",
    "y1": 0.0866747446212543,
    "y2": 0.401854926866308,
    "y3": 0.281122657794266
  },
  {
    "x": "1977-08-15",
    "y1": 0.0875679198493465,
    "y2": 0.388994891833524,
    "y3": 0.288333819255561
  },
  {
    "x": "1977-08-22",
    "y1": 0.0780488410293403,
    "y2": 0.263329216997092,
    "y3": 0.290381458605176
  },
  {
    "x": "1977-08-29",
    "y1": 0.0874592169143128,
    "y2": 0.213694984481255,
    "y3": 0.288719037218716
  },
  {
    "x": "1977-09-05",
    "y1": 0.0882526497180606,
    "y2": 0.178702479215845,
    "y3": 0.289740007373613
  },
  {
    "x": "1977-09-12",
    "y1": 0.0865679228112104,
    "y2": 0.178702479215845,
    "y3": 0.290760977528511
  },
  {
    "x": "1977-09-19",
    "y1": 0.0749538847552689,
    "y2": 0.173829551370397,
    "y3": 0.290408743656096
  },
  {
    "x": "1977-09-26",
    "y1": 0.0878091502290059,
    "y2": 0.222376430004782,
    "y3": 0.292483853715401
  },
  {
    "x": "1977-10-03",
    "y1": 0.095444294345131,
    "y2": 0.246943412210469,
    "y3": 0.287337407194755
  },
  {
    "x": "1977-10-10",
    "y1": 0.0701540008461906,
    "y2": 0.133716093912205,
    "y3": 0.284979500449431
  },
  {
    "x": "1977-10-17",
    "y1": 0.0650050647480869,
    "y2": 0.222376430004782,
    "y3": 0.283751151339147
  },
  {
    "x": "1977-10-24",
    "y1": 0.0543494625357639,
    "y2": 0.222376430004782,
    "y3": 0.281393244593823
  },
  {
    "x": "1977-10-31",
    "y1": 0.051477385549075,
    "y2": 0.222376430004782,
    "y3": 0.283468354653127
  },
  {
    "x": "1977-11-07",
    "y1": 0.0898479584537437,
    "y2": 0.219302340476963,
    "y3": 0.278313954503541
  },
  {
    "x": "1977-11-14",
    "y1": 0.102528746529214,
    "y2": 0.19649054198593,
    "y3": 0.273271742972315
  },
  {
    "x": "1977-11-21",
    "y1": 0.123170505335261,
    "y2": 0.297334772610459,
    "y3": 0.26696923379618
  },
  {
    "x": "1977-11-28",
    "y1": 0.120965929921699,
    "y2": 0.297334772610459,
    "y3": 0.258684309236494
  },
  {
    "x": "1977-12-05",
    "y1": 0.115874683167948,
    "y2": 0.385995108703037,
    "y3": 0.256085180024348
  },
  {
    "x": "1977-12-12",
    "y1": 0.120509262277226,
    "y2": 0.365934216146359,
    "y3": 0.262479115452227
  },
  {
    "x": "1977-12-19",
    "y1": 0.119452072396156,
    "y2": 0.349872342623392,
    "y3": 0.259076892563933
  },
  {
    "x": "1977-12-26",
    "y1": 0.130131316039405,
    "y2": 0.337012307590609,
    "y3": 0.255834761600148
  },
  {
    "x": "1978-01-02",
    "y1": 0.0978609753333872,
    "y2": 0.238055507588765,
    "y3": 0.24828779238791
  },
  {
    "x": "1978-01-09",
    "y1": 0.0792695239173035,
    "y2": 0.257274957078631,
    "y3": 0.247985079391987
  },
  {
    "x": "1978-01-16",
    "y1": 0.0878893559237964,
    "y2": 0.275634828455417,
    "y3": 0.251082071590695
  },
  {
    "x": "1978-01-23",
    "y1": 0.0877900365646711,
    "y2": 0.206398490172804,
    "y3": 0.252466872138543
  },
  {
    "x": "1978-01-30",
    "y1": 0.103691432216098,
    "y2": 0.158283076117891,
    "y3": 0.251445901983646
  },
  {
    "x": "1978-02-06",
    "y1": 0.116996075085503,
    "y2": 0.178702479215845,
    "y3": 0.251689548375918
  },
  {
    "x": "1978-02-13",
    "y1": 0.104155740971356,
    "y2": 0.15611132651505,
    "y3": 0.248376293201432
  },
  {
    "x": "1978-02-20",
    "y1": 0.108556689120424,
    "y2": 0.267362815308422,
    "y3": 0.249397263356329
  },
  {
    "x": "1978-02-27",
    "y1": 0.101253865144899,
    "y2": 0.267362815308422,
    "y3": 0.25607959942614
  },
  {
    "x": "1978-03-06",
    "y1": 0.115672710311215,
    "y2": 0.267362815308422,
    "y3": 0.258328918691322
  },
  {
    "x": "1978-03-13",
    "y1": 0.130370102492347,
    "y2": 0.178702479215845,
    "y3": 0.256145221151875
  },
  {
    "x": "1978-03-20",
    "y1": 0.13465823797713,
    "y2": 0.178702479215845,
    "y3": 0.253961523612428
  },
  {
    "x": "1978-03-27",
    "y1": 0.142343953541081,
    "y2": 0.178702479215845,
    "y3": 0.251931530549372
  },
  {
    "x": "1978-04-03",
    "y1": 0.161458892025314,
    "y2": 0.178702479215845,
    "y3": 0.251042127410868
  },
  {
    "x": "1978-04-10",
    "y1": 0.189731990645685,
    "y2": 0.371402371890248,
    "y3": 0.254745507374858
  },
  {
    "x": "1978-04-17",
    "y1": 0.207972612108504,
    "y2": 0.322390343468686,
    "y3": 0.255998285917769
  },
  {
    "x": "1978-04-24",
    "y1": 0.224386313267705,
    "y2": 0.405666731277816,
    "y3": 0.256981867046508
  },
  {
    "x": "1978-05-01",
    "y1": 0.242531792798466,
    "y2": 0.392091152566949,
    "y3": 0.258289713867537
  },
  {
    "x": "1978-05-08",
    "y1": 0.260695048053734,
    "y2": 0.521432027001305,
    "y3": 0.266867698086433
  },
  {
    "x": "1978-05-15",
    "y1": 0.278869236841119,
    "y2": 0.516071944647738,
    "y3": 0.27582067993929
  },
  {
    "x": "1978-05-22",
    "y1": 0.264803274113758,
    "y2": 0.420074262552281,
    "y3": 0.284921617687465
  },
  {
    "x": "1978-05-29",
    "y1": 0.274564647073774,
    "y2": 0.470955481232833,
    "y3": 0.295605643895175
  },
  {
    "x": "1978-06-05",
    "y1": 0.302491647957051,
    "y2": 0.568607578279312,
    "y3": 0.31025428138637
  },
  {
    "x": "1978-06-12",
    "y1": 0.296704322183324,
    "y2": 0.448653438620519,
    "y3": 0.322367028808756
  },
  {
    "x": "1978-06-19",
    "y1": 0.272854338195862,
    "y2": 0.46900081895412,
    "y3": 0.337902915950567
  },
  {
    "x": "1978-06-26",
    "y1": 0.269210186963491,
    "y2": 0.42349318340023,
    "y3": 0.350142451159787
  },
  {
    "x": "1978-07-03",
    "y1": 0.259733883050532,
    "y2": 0.390958914070751,
    "y3": 0.361884830537572
  },
  {
    "x": "1978-07-10",
    "y1": 0.280042695525961,
    "y2": 0.492197311298193,
    "y3": 0.37312655533706
  },
  {
    "x": "1978-07-17",
    "y1": 0.296657242430421,
    "y2": 0.387475101682648,
    "y3": 0.379132169655771
  },
  {
    "x": "1978-07-24",
    "y1": 0.313000319270215,
    "y2": 0.523015955679112,
    "y3": 0.391914826674306
  },
  {
    "x": "1978-07-31",
    "y1": 0.345558859931419,
    "y2": 0.562879081314997,
    "y3": 0.411123656779264
  },
  {
    "x": "1978-08-07",
    "y1": 0.363213575586352,
    "y2": 0.501814424315896,
    "y3": 0.427279254034266
  },
  {
    "x": "1978-08-14",
    "y1": 0.383743929479286,
    "y2": 0.494477078313017,
    "y3": 0.443067983989125
  },
  {
    "x": "1978-08-21",
    "y1": 0.392132241911216,
    "y2": 0.448262040030373,
    "y3": 0.456545962029851
  },
  {
    "x": "1978-08-28",
    "y1": 0.388525128781176,
    "y2": 0.50634411623482,
    "y3": 0.46329304924708
  },
  {
    "x": "1978-09-04",
    "y1": 0.410763727754966,
    "y2": 0.575129150426455,
    "y3": 0.475929989594968
  },
  {
    "x": "1978-09-11",
    "y1": 0.403536205381529,
    "y2": 0.486039038569852,
    "y3": 0.47994860495957
  },
  {
    "x": "1978-09-18",
    "y1": 0.366698716038853,
    "y2": 0.481203178841135,
    "y3": 0.484404206273279
  },
  {
    "x": "1978-09-25",
    "y1": 0.371158249858061,
    "y2": 0.475918410542053,
    "y3": 0.482128525450317
  },
  {
    "x": "1978-10-02",
    "y1": 0.379511027459458,
    "y2": 0.473179003537068,
    "y3": 0.479983878394783
  },
  {
    "x": "1978-10-09",
    "y1": 0.391302085900165,
    "y2": 0.614049045194252,
    "y3": 0.489682617526882
  },
  {
    "x": "1978-10-16",
    "y1": 0.304563614315804,
    "y2": 0.331686066486094,
    "y3": 0.482719146789545
  },
  {
    "x": "1978-10-23",
    "y1": 0.235350242356941,
    "y2": 0.346065891669754,
    "y3": 0.471592062459067
  },
  {
    "x": "1978-10-30",
    "y1": 0.237432653322403,
    "y2": 0.346065891669754,
    "y3": 0.466462685111529
  },
  {
    "x": "1978-11-06",
    "y1": 0.231804447088945,
    "y2": 0.294083307426838,
    "y3": 0.457716809535165
  },
  {
    "x": "1978-11-13",
    "y1": 0.221790567489883,
    "y2": 0.259577305180018,
    "y3": 0.449521015624154
  },
  {
    "x": "1978-11-20",
    "y1": 0.243604233373277,
    "y2": 0.259577305180018,
    "y3": 0.442951935179617
  },
  {
    "x": "1978-11-27",
    "y1": 0.243776431641128,
    "y2": 0.259577305180018,
    "y3": 0.431320934873709
  },
  {
    "x": "1978-12-04",
    "y1": 0.265981390307527,
    "y2": 0.277295530035365,
    "y3": 0.425811956291344
  },
  {
    "x": "1978-12-11",
    "y1": 0.254530746042173,
    "y2": 0.277295530035365,
    "y3": 0.413525935009157
  },
  {
    "x": "1978-12-18",
    "y1": 0.250442479778976,
    "y2": 0.294083307426838,
    "y3": 0.400086146314749
  },
  {
    "x": "1978-12-25",
    "y1": 0.259422237317823,
    "y2": 0.35095010413568,
    "y3": 0.392542930305738
  },
  {
    "x": "1979-01-01",
    "y1": 0.293919606185588,
    "y2": 0.35095010413568,
    "y3": 0.385366581596871
  },
  {
    "x": "1979-01-08",
    "y1": 0.307766347437163,
    "y2": 0.262289768043103,
    "y3": 0.376067967997508
  },
  {
    "x": "1979-01-15",
    "y1": 0.315120506785956,
    "y2": 0.205422971334261,
    "y3": 0.36102191075248
  },
  {
    "x": "1979-01-22",
    "y1": 0.334294187976422,
    "y2": 0.205422971334261,
    "y3": 0.34253660179787
  },
  {
    "x": "1979-01-29",
    "y1": 0.324690903877627,
    "y2": 0.294083307426838,
    "y3": 0.33293881524072
  },
  {
    "x": "1979-02-05",
    "y1": 0.308318327470138,
    "y2": 0.244771662607627,
    "y3": 0.321117239429044
  },
  {
    "x": "1979-02-12",
    "y1": 0.322943388292303,
    "y2": 0.244771662607627,
    "y3": 0.309559902032323
  },
  {
    "x": "1979-02-19",
    "y1": 0.318722644638684,
    "y2": 0.201514277706877,
    "y3": 0.295976665740813
  },
  {
    "x": "1979-02-26",
    "y1": 0.307766128831334,
    "y2": 0.179119045104032,
    "y3": 0.274230165736302
  },
  {
    "x": "1979-03-05",
    "y1": 0.336714150858181,
    "y2": 0.133716093912205,
    "y3": 0.264331667107608
  },
  {
    "x": "1979-03-12",
    "y1": 0.346930284860207,
    "y2": 0.160995538980976,
    "y3": 0.255078149473169
  },
  {
    "x": "1979-03-19",
    "y1": 0.362721795798402,
    "y2": 0.229811582221178,
    "y3": 0.24926543400074
  },
  {
    "x": "1979-03-26",
    "y1": 0.371758345493875,
    "y2": 0.229811582221178,
    "y3": 0.246051847740457
  },
  {
    "x": "1979-04-02",
    "y1": 0.386861605786291,
    "y2": 0.367035581708722,
    "y3": 0.251424761566893
  },
  {
    "x": "1979-04-09",
    "y1": 0.385291462131209,
    "y2": 0.318471918313756,
    "y3": 0.254369492223579
  },
  {
    "x": "1979-04-16",
    "y1": 0.386264989833386,
    "y2": 0.318471918313756,
    "y3": 0.257314222880266
  },
  {
    "x": "1979-04-23",
    "y1": 0.391501744212311,
    "y2": 0.318471918313756,
    "y3": 0.259373042294186
  },
  {
    "x": "1979-04-30",
    "y1": 0.386664400161524,
    "y2": 0.249655875073554,
    "y3": 0.257991059546095
  },
  {
    "x": "1979-05-07",
    "y1": 0.35652680860822,
    "y2": 0.183509731697804,
    "y3": 0.252462380759644
  },
  {
    "x": "1979-05-14",
    "y1": 0.366704864283915,
    "y2": 0.183509731697804,
    "y3": 0.24409036213775
  },
  {
    "x": "1979-05-21",
    "y1": 0.379451969382513,
    "y2": 0.140252346797054,
    "y3": 0.233555474270819
  },
  {
    "x": "1979-05-28",
    "y1": 0.372518006315501,
    "y2": 0.0948493956052264,
    "y3": 0.225183455648925
  },
  {
    "x": "1979-06-04",
    "y1": 0.396804681637617,
    "y2": 0.0948493956052264,
    "y3": 0.219654776862473
  },
  {
    "x": "1979-06-11",
    "y1": 0.406363019085449,
    "y2": 0.15150415668229,
    "y3": 0.216958836129875
  },
  {
    "x": "1979-06-18",
    "y1": 0.413629114448121,
    "y2": 0.198218162257315,
    "y3": 0.212165578871398
  },
  {
    "x": "1979-06-25",
    "y1": 0.420114099540115,
    "y2": 0.198218162257315,
    "y3": 0.209837903853883
  },
  {
    "x": "1979-07-02",
    "y1": 0.423806233680475,
    "y2": 0.198218162257315,
    "y3": 0.207510228836367
  },
  {
    "x": "1979-07-09",
    "y1": 0.422940717828515,
    "y2": 0.240164492774868,
    "y3": 0.209442739589767
  },
  {
    "x": "1979-07-16",
    "y1": 0.419042302233179,
    "y2": 0.385995108703037,
    "y3": 0.219786542769717
  },
  {
    "x": "1979-07-23",
    "y1": 0.433827116032928,
    "y2": 0.568607578279312,
    "y3": 0.241531116988072
  },
  {
    "x": "1979-07-30",
    "y1": 0.45246731408115,
    "y2": 0.448653438620519,
    "y3": 0.255914011970049
  },
  {
    "x": "1979-08-06",
    "y1": 0.469574531061273,
    "y2": 0.523015955679112,
    "y3": 0.270574230642946
  },
  {
    "x": "1979-08-13",
    "y1": 0.488668684737581,
    "y2": 0.491722152112897,
    "y3": 0.283669759137532
  },
  {
    "x": "1979-08-20",
    "y1": 0.499220616537068,
    "y2": 0.46666658125467,
    "y3": 0.288651309114829
  },
  {
    "x": "1979-08-27",
    "y1": 0.506181852061899,
    "y2": 0.53526602479057,
    "y3": 0.29949101443867
  },
  {
    "x": "1979-09-03",
    "y1": 0.490428095888501,
    "y2": 0.452978938833176,
    "y3": 0.306216365464641
  },
  {
    "x": "1979-09-10",
    "y1": 0.507244399739441,
    "y2": 0.519204151267603,
    "y3": 0.316252977112333
  },
  {
    "x": "1979-09-17",
    "y1": 0.50784214375744,
    "y2": 0.50634411623482,
    "y3": 0.329087389170397
  },
  {
    "x": "1979-09-24",
    "y1": 0.50339476110832,
    "y2": 0.452790267424804,
    "y3": 0.342551415956747
  },
  {
    "x": "1979-10-01",
    "y1": 0.518796798876011,
    "y2": 0.385361030824916,
    "y3": 0.352643980913102
  },
  {
    "x": "1979-10-08",
    "y1": 0.442757747836667,
    "y2": 0.262289768043103,
    "y3": 0.358745851975405
  },
  {
    "x": "1979-10-15",
    "y1": 0.413477595897263,
    "y2": 0.294083307426838,
    "y3": 0.368707547566485
  },
  {
    "x": "1979-10-22",
    "y1": 0.392685470455915,
    "y2": 0.244771662607627,
    "y3": 0.376203660916605
  },
  {
    "x": "1979-10-29",
    "y1": 0.416087376121803,
    "y2": 0.29625505702968,
    "y3": 0.383441205933975
  },
  {
    "x": "1979-11-05",
    "y1": 0.408635562591155,
    "y2": 0.207594720937102,
    "y3": 0.383910033867964
  },
  {
    "x": "1979-11-12",
    "y1": 0.432262875261892,
    "y2": 0.207594720937102,
    "y3": 0.384378861801954
  },
  {
    "x": "1979-11-19",
    "y1": 0.43787155246199,
    "y2": 0.275193618347262,
    "y3": 0.388227634606451
  },
  {
    "x": "1979-11-26",
    "y1": 0.469405254362983,
    "y2": 0.334861276317939,
    "y3": 0.392962473783604
  },
  {
    "x": "1979-12-03",
    "y1": 0.491795460305872,
    "y2": 0.292911843202609,
    "y3": 0.388308310508583
  },
  {
    "x": "1979-12-10",
    "y1": 0.509016920686457,
    "y2": 0.345157740227205,
    "y3": 0.377135818605978
  },
  {
    "x": "1979-12-17",
    "y1": 0.509950063329845,
    "y2": 0.292911843202609,
    "y3": 0.369348738835082
  },
  {
    "x": "1979-12-24",
    "y1": 0.514345106748351,
    "y2": 0.363853954439839,
    "y3": 0.361390638773119
  },
  {
    "x": "1979-12-31",
    "y1": 0.495714877188709,
    "y2": 0.29625505702968,
    "y3": 0.351617284018958
  },
  {
    "x": "1980-01-07",
    "y1": 0.53523650045497,
    "y2": 0.370454502556672,
    "y3": 0.346806680084058
  },
  {
    "x": "1980-01-14",
    "y1": 0.54998924201925,
    "y2": 0.376422316484286,
    "y3": 0.338864494668744
  },
  {
    "x": "1980-01-21",
    "y1": 0.572789277708438,
    "y2": 0.382295145140255,
    "y3": 0.335330304984098
  },
  {
    "x": "1980-01-28",
    "y1": 0.589069842224405,
    "y2": 0.479947242186734,
    "y3": 0.333367459530054
  },
  {
    "x": "1980-02-04",
    "y1": 0.607246039961761,
    "y2": 0.523015955679112,
    "y3": 0.334201051502269
  },
  {
    "x": "1980-02-11",
    "y1": 0.590967659075793,
    "y2": 0.51225820385487,
    "y3": 0.337174448323772
  },
  {
    "x": "1980-02-18",
    "y1": 0.575711779617224,
    "y2": 0.492197311298193,
    "y3": 0.342516262347436
  },
  {
    "x": "1980-02-25",
    "y1": 0.562905663748227,
    "y2": 0.416892635283398,
    "y3": 0.350246405709451
  },
  {
    "x": "1980-03-03",
    "y1": 0.487983203270161,
    "y2": 0.294083307426838,
    "y3": 0.350246405709451
  },
  {
    "x": "1980-03-10",
    "y1": 0.476012480438404,
    "y2": 0.267362815308422,
    "y3": 0.35137596334449
  },
  {
    "x": "1980-03-17",
    "y1": 0.436965130020805,
    "y2": 0.179119045104032,
    "y3": 0.345519162748208
  },
  {
    "x": "1980-03-24",
    "y1": 0.368161074964721,
    "y2": 0.127468802006589,
    "y3": 0.341512866801682
  },
  {
    "x": "1980-03-31",
    "y1": 0.420462773276797,
    "y2": 0.142424096399896,
    "y3": 0.338254335574822
  },
  {
    "x": "1980-04-07",
    "y1": 0.433255991153713,
    "y2": 0.138600306378131,
    "y3": 0.331424669976365
  },
  {
    "x": "1980-04-14",
    "y1": 0.410824075815125,
    "y2": 0.0970211452080681,
    "y3": 0.319532663420872
  },
  {
    "x": "1980-04-21",
    "y1": 0.435033153627241,
    "y2": 0.141988107059199,
    "y3": 0.311986476613701
  },
  {
    "x": "1980-04-28",
    "y1": 0.451927018635857,
    "y2": 0.0970211452080681,
    "y3": 0.299579646862745
  },
  {
    "x": "1980-05-05",
    "y1": 0.471962651852212,
    "y2": 0.234879724475786,
    "y3": 0.296678040926403
  },
  {
    "x": "1980-05-12",
    "y1": 0.501181217530282,
    "y2": 0.163937613238556,
    "y3": 0.286682223866339
  },
  {
    "x": "1980-05-19",
    "y1": 0.516394407905224,
    "y2": 0.146219388383209,
    "y3": 0.279180440434016
  },
  {
    "x": "1980-05-26",
    "y1": 0.522883578686785,
    "y2": 0.234879724475786,
    "y3": 0.272401701529971
  },
  {
    "x": "1980-06-02",
    "y1": 0.537705750656029,
    "y2": 0.336683463883826,
    "y3": 0.270414758899948
  },
  {
    "x": "1980-06-09",
    "y1": 0.563314892977724,
    "y2": 0.336683463883826,
    "y3": 0.268134174837127
  },
  {
    "x": "1980-06-16",
    "y1": 0.562803992965426,
    "y2": 0.336683463883826,
    "y3": 0.260970985921982
  },
  {
    "x": "1980-06-23",
    "y1": 0.579863594669193,
    "y2": 0.295956339127193,
    "y3": 0.249618005094386
  },
  {
    "x": "1980-06-30",
    "y1": 0.590480522167415,
    "y2": 0.234491514412399,
    "y3": 0.235729670622262
  },
  {
    "x": "1980-07-07",
    "y1": 0.615034586485959,
    "y2": 0.521432027001305,
    "y3": 0.237191406407418
  },
  {
    "x": "1980-07-14",
    "y1": 0.646402126464132,
    "y2": 0.479947242186734,
    "y3": 0.240344136752584
  },
  {
    "x": "1980-07-21",
    "y1": 0.644284351308427,
    "y2": 0.523015955679112,
    "y3": 0.251790769165198
  },
  {
    "x": "1980-07-28",
    "y1": 0.661144579617254,
    "y2": 0.580382488205475,
    "y3": 0.267441752810051
  },
  {
    "x": "1980-08-04",
    "y1": 0.680797888688444,
    "y2": 0.555326917347248,
    "y3": 0.286252146422211
  },
  {
    "x": "1980-08-11",
    "y1": 0.703597492938556,
    "y2": 0.53526602479057,
    "y3": 0.306642007561411
  },
  {
    "x": "1980-08-18",
    "y1": 0.713659183775929,
    "y2": 0.533108227882111,
    "y3": 0.326176214135521
  },
  {
    "x": "1980-08-25",
    "y1": 0.712668580150148,
    "y2": 0.417683780142242,
    "y3": 0.340130387823727
  },
  {
    "x": "1980-09-01",
    "y1": 0.735200511847062,
    "y2": 0.496047652325554,
    "y3": 0.360081713179601
  },
  {
    "x": "1980-09-08",
    "y1": 0.756589452139333,
    "y2": 0.487803726957967,
    "y3": 0.37737249417454
  },
  {
    "x": "1980-09-15",
    "y1": 0.786919655454364,
    "y2": 0.501814424315896,
    "y3": 0.397612158129931
  },
  {
    "x": "1980-09-22",
    "y1": 0.763574559893787,
    "y2": 0.387258074449476,
    "y3": 0.405231075628615
  },
  {
    "x": "1980-09-29",
    "y1": 0.777517990956048,
    "y2": 0.565419189550247,
    "y3": 0.4253051544442
  },
  {
    "x": "1980-10-06",
    "y1": 0.80005844887593,
    "y2": 0.468299328536976,
    "y3": 0.441409151451888
  },
  {
    "x": "1980-10-13",
    "y1": 0.79727778346495,
    "y2": 0.465586865673891,
    "y3": 0.452944508511794
  },
  {
    "x": "1980-10-20",
    "y1": 0.791852883371567,
    "y2": 0.420346402578672,
    "y3": 0.457127655446536
  },
  {
    "x": "1980-10-27",
    "y1": 0.774571956515826,
    "y2": 0.310444236420735,
    "y3": 0.455815694073381
  },
  {
    "x": "1980-11-03",
    "y1": 0.778358634242568,
    "y2": 0.373170851300665,
    "y3": 0.457640063444223
  },
  {
    "x": "1980-11-10",
    "y1": 0.820992091088171,
    "y2": 0.425230615044599,
    "y3": 0.464103777240094
  },
  {
    "x": "1980-11-17",
    "y1": 0.842354169472035,
    "y2": 0.387258074449476,
    "y3": 0.471742105241948
  },
  {
    "x": "1980-11-24",
    "y1": 0.852447761447276,
    "y2": 0.476758853457669,
    "y3": 0.469508446564766
  },
  {
    "x": "1980-12-01",
    "y1": 0.827802122367532,
    "y2": 0.568646094002425,
    "y3": 0.47394338915555
  },
  {
    "x": "1980-12-08",
    "y1": 0.769679756081293,
    "y2": 0.559067276903488,
    "y3": 0.475745955216769
  },
  {
    "x": "1980-12-15",
    "y1": 0.804665648763539,
    "y2": 0.692471746915018,
    "y3": 0.481350418152246
  },
  {
    "x": "1980-12-22",
    "y1": 0.821693565770407,
    "y2": 0.732702834840896,
    "y3": 0.490219214026929
  },
  {
    "x": "1980-12-29",
    "y1": 0.832971409004846,
    "y2": 0.610441890107132,
    "y3": 0.493978007292757
  },
  {
    "x": "1981-01-05",
    "y1": 0.80403503316922,
    "y2": 0.527401143841321,
    "y3": 0.493692653090717
  },
  {
    "x": "1981-01-12",
    "y1": 0.821590437178192,
    "y2": 0.585386319248905,
    "y3": 0.502077780046051
  },
  {
    "x": "1981-01-19",
    "y1": 0.803641844115436,
    "y2": 0.587139571378148,
    "y3": 0.50663237599868
  },
  {
    "x": "1981-01-26",
    "y1": 0.805110015844174,
    "y2": 0.576843107468882,
    "y3": 0.511084345024226
  },
  {
    "x": "1981-02-02",
    "y1": 0.805413324874729,
    "y2": 0.526833317164448,
    "y3": 0.512335289666653
  },
  {
    "x": "1981-02-09",
    "y1": 0.785299129565926,
    "y2": 0.389731264647397,
    "y3": 0.51245894917655
  },
  {
    "x": "1981-02-16",
    "y1": 0.777046996353525,
    "y2": 0.463415116071049,
    "y3": 0.50735874550259
  },
  {
    "x": "1981-02-23",
    "y1": 0.806793740440159,
    "y2": 0.43242175297614,
    "y3": 0.505564866724548
  },
  {
    "x": "1981-03-02",
    "y1": 0.816288235339242,
    "y2": 0.387018801784312,
    "y3": 0.501636463530069
  },
  {
    "x": "1981-03-09",
    "y1": 0.827694502717593,
    "y2": 0.374754779978472,
    "y3": 0.499356882400059
  },
  {
    "x": "1981-03-16",
    "y1": 0.848073367803918,
    "y2": 0.389731264647397,
    "y3": 0.503321233811392
  },
  {
    "x": "1981-03-23",
    "y1": 0.860337724391379,
    "y2": 0.407449489502745,
    "y3": 0.505035165721496
  },
  {
    "x": "1981-03-30",
    "y1": 0.87867881450694,
    "y2": 0.478391600739975,
    "y3": 0.507693215006265
  },
  {
    "x": "1981-04-06",
    "y1": 0.890435222086321,
    "y2": 0.407449489502745,
    "y3": 0.508702785758928
  },
  {
    "x": "1981-04-13",
    "y1": 0.897360648697678,
    "y2": 0.463415116071049,
    "y3": 0.508035598889597
  },
  {
    "x": "1981-04-20",
    "y1": 0.910839222262911,
    "y2": 0.463415116071049,
    "y3": 0.502774049993029
  },
  {
    "x": "1981-04-27",
    "y1": 0.897722056500309,
    "y2": 0.463415116071049,
    "y3": 0.497991441951406
  },
  {
    "x": "1981-05-04",
    "y1": 0.889230287993358,
    "y2": 0.420346402578672,
    "y3": 0.484385174734589
  },
  {
    "x": "1981-05-11",
    "y1": 0.89700350619021,
    "y2": 0.399104572513312,
    "y3": 0.46770526161821
  },
  {
    "x": "1981-05-18",
    "y1": 0.909566442265742,
    "y2": 0.379260767280763,
    "y3": 0.456146205476892
  },
  {
    "x": "1981-05-25",
    "y1": 0.928906886437595,
    "y2": 0.333857816088936,
    "y3": 0.446469039089272
  },
  {
    "x": "1981-06-01",
    "y1": 0.919196419005314,
    "y2": 0.310444236420735,
    "y3": 0.432721934947864
  },
  {
    "x": "1981-06-08",
    "y1": 0.925793759425308,
    "y2": 0.284510515208087,
    "y3": 0.417590482139361
  },
  {
    "x": "1981-06-15",
    "y1": 0.911428536642256,
    "y2": 0.346065891669754,
    "y3": 0.406051621349404
  },
  {
    "x": "1981-06-22",
    "y1": 0.912339435487519,
    "y2": 0.346065891669754,
    "y3": 0.39701325007467
  },
  {
    "x": "1981-06-29",
    "y1": 0.880668559854777,
    "y2": 0.294083307426838,
    "y3": 0.392230852213642
  },
  {
    "x": "1981-07-06",
    "y1": 0.870048213364109,
    "y2": 0.267362815308422,
    "y3": 0.38242823717551
  },
  {
    "x": "1981-07-13",
    "y1": 0.880592534117867,
    "y2": 0.29625505702968,
    "y3": 0.375619902378187
  },
  {
    "x": "1981-07-20",
    "y1": 0.858219932925292,
    "y2": 0.178702479215845,
    "y3": 0.365204086249764
  },
  {
    "x": "1981-07-27",
    "y1": 0.875671879477275,
    "y2": 0.255710134992015,
    "y3": 0.359251854000441
  },
  {
    "x": "1981-08-03",
    "y1": 0.874396047760452,
    "y2": 0.210307183800187,
    "y3": 0.350280649958081
  },
  {
    "x": "1981-08-10",
    "y1": 0.87799178254774,
    "y2": 0.15611132651505,
    "y3": 0.337713741808696
  },
  {
    "x": "1981-08-17",
    "y1": 0.852723063267455,
    "y2": 0.151434318767552,
    "y3": 0.321365877710075
  },
  {
    "x": "1981-08-24",
    "y1": 0.8081787041082,
    "y2": 0.170726186907339,
    "y3": 0.309529712580304
  },
  {
    "x": "1981-08-31",
    "y1": 0.768087597823225,
    "y2": 0.170726186907339,
    "y3": 0.294895266122119
  },
  {
    "x": "1981-09-07",
    "y1": 0.769036776071111,
    "y2": 0.188393944163731,
    "y3": 0.281144207526753
  },
  {
    "x": "1981-09-14",
    "y1": 0.73984972924855,
    "y2": 0.127468802006589,
    "y3": 0.26434689182353
  },
  {
    "x": "1981-09-21",
    "y1": 0.690194283744005,
    "y2": 0.0646686958743536,
    "y3": 0.246563006488314
  },
  {
    "x": "1981-09-28",
    "y1": 0.74301520801259,
    "y2": 0.0750103801177183,
    "y3": 0.230358296868534
  },
  {
    "x": "1981-10-05",
    "y1": 0.78044000238267,
    "y2": 0.112637458375312,
    "y3": 0.217027131423262
  },
  {
    "x": "1981-10-12",
    "y1": 0.775054951113316,
    "y2": 0.0869500632806879,
    "y3": 0.204681743782849
  },
  {
    "x": "1981-10-19",
    "y1": 0.783833326432514,
    "y2": 0.119238006492144,
    "y3": 0.19512143228642
  },
  {
    "x": "1981-10-26",
    "y1": 0.801185219338096,
    "y2": 0.136956231347492,
    "y3": 0.18774371809339
  },
  {
    "x": "1981-11-02",
    "y1": 0.825411789684636,
    "y2": 0.294227338724303,
    "y3": 0.185151790446118
  },
  {
    "x": "1981-11-09",
    "y1": 0.826361944409077,
    "y2": 0.361739034742053,
    "y3": 0.185935447599732
  },
  {
    "x": "1981-11-16",
    "y1": 0.818568191760934,
    "y2": 0.273078698649475,
    "y3": 0.184885217160864
  },
  {
    "x": "1981-11-23",
    "y1": 0.830753479246192,
    "y2": 0.294227338724303,
    "y3": 0.186228443331658
  },
  {
    "x": "1981-11-30",
    "y1": 0.830057034182652,
    "y2": 0.278165465201336,
    "y3": 0.185323963740241
  },
  {
    "x": "1981-12-07",
    "y1": 0.81890607122608,
    "y2": 0.196013026168808,
    "y3": 0.186189491087889
  },
  {
    "x": "1981-12-14",
    "y1": 0.810700247183486,
    "y2": 0.152755641268058,
    "y3": 0.181041766401692
  },
  {
    "x": "1981-12-21",
    "y1": 0.804050850730921,
    "y2": 0.132353014472515,
    "y3": 0.177144057935308
  },
  {
    "x": "1981-12-28",
    "y1": 0.804766228307985,
    "y2": 0.172897936510181,
    "y3": 0.177983388435064
  },
  {
    "x": "1982-01-04",
    "y1": 0.785413729548775,
    "y2": 0.0728386305148765,
    "y3": 0.174053604022431
  },
  {
    "x": "1982-01-11",
    "y1": 0.76078474932291,
    "y2": 0.110071647066181,
    "y3": 0.171020877030373
  },
  {
    "x": "1982-01-18",
    "y1": 0.752830417511545,
    "y2": 0.148619304938865,
    "y3": 0.169915532931949
  },
  {
    "x": "1982-01-25",
    "y1": 0.766606436095031,
    "y2": 0.155500781569773,
    "y3": 0.168270874802251
  },
  {
    "x": "1982-02-01",
    "y1": 0.765651010242468,
    "y2": 0.0668404454771954,
    "y3": 0.165239456975782
  },
  {
    "x": "1982-02-08",
    "y1": 0.735418810899014,
    "y2": 0.0599589688462875,
    "y3": 0.165003970624378
  },
  {
    "x": "1982-02-15",
    "y1": 0.725173301737263,
    "y2": 0.148619304938865,
    "y3": 0.168684416865436
  },
  {
    "x": "1982-02-22",
    "y1": 0.718419904217624,
    "y2": 0.14266005849519,
    "y3": 0.17018554687143
  },
  {
    "x": "1982-03-01",
    "y1": 0.687990256567,
    "y2": 0.14266005849519,
    "y3": 0.172971046632155
  },
  {
    "x": "1982-03-08",
    "y1": 0.654996030821826,
    "y2": 0.137565863954628,
    "y3": 0.173887439505279
  },
  {
    "x": "1982-03-15",
    "y1": 0.675979201890878,
    "y2": 0.0943084790538781,
    "y3": 0.171755051890598
  },
  {
    "x": "1982-03-22",
    "y1": 0.696007162716584,
    "y2": 0.0588839348685388,
    "y3": 0.15998788169781
  },
  {
    "x": "1982-03-29",
    "y1": 0.715185248726164,
    "y2": 0.0777470316163732,
    "y3": 0.145788281541526
  },
  {
    "x": "1982-04-05",
    "y1": 0.729690156730773,
    "y2": 0.120457731070908,
    "y3": 0.138157233162598
  },
  {
    "x": "1982-04-12",
    "y1": 0.735762506388947,
    "y2": 0.120457731070908,
    "y3": 0.129468752779928
  },
  {
    "x": "1982-04-19",
    "y1": 0.750467541647006,
    "y2": 0.309760142308094,
    "y3": 0.131048486635266
  },
  {
    "x": "1982-04-26",
    "y1": 0.749223850863206,
    "y2": 0.196258032130702,
    "y3": 0.13106073693336
  },
  {
    "x": "1982-05-03",
    "y1": 0.767794549245684,
    "y2": 0.27846633874188,
    "y3": 0.137346271807051
  },
  {
    "x": "1982-05-10",
    "y1": 0.768272922368284,
    "y2": 0.164750431791075,
    "y3": 0.138966142672979
  },
  {
    "x": "1982-05-17",
    "y1": 0.737351621303185,
    "y2": 0.190092490426225,
    "y3": 0.139825870368782
  },
  {
    "x": "1982-05-24",
    "y1": 0.716189336547067,
    "y2": 0.217288001804008,
    "y3": 0.147048338933238
  },
  {
    "x": "1982-05-31",
    "y1": 0.695353747313274,
    "y2": 0.318987362607979,
    "y3": 0.157494124710328
  },
  {
    "x": "1982-06-07",
    "y1": 0.688089108145826,
    "y2": 0.194131502861959,
    "y3": 0.159769734606483
  },
  {
    "x": "1982-06-14",
    "y1": 0.658990848491796,
    "y2": 0.142630192593622,
    "y3": 0.159126205157675
  },
  {
    "x": "1982-06-21",
    "y1": 0.670741564975708,
    "y2": 0.243110571305866,
    "y3": 0.167939711449109
  },
  {
    "x": "1982-06-28",
    "y1": 0.668219317870138,
    "y2": 0.17397765209096,
    "y3": 0.173640645611342
  },
  {
    "x": "1982-07-05",
    "y1": 0.656575708978603,
    "y2": 0.0646686958743536,
    "y3": 0.169443115158117
  },
  {
    "x": "1982-07-12",
    "y1": 0.669129914128913,
    "y2": 0.0988288685172181,
    "y3": 0.167251555659218
  },
  {
    "x": "1982-07-19",
    "y1": 0.680470894371211,
    "y2": 0.0777228429808033,
    "y3": 0.164004694883499
  },
  {
    "x": "1982-07-26",
    "y1": 0.652814195225573,
    "y2": 0.0823869207297009,
    "y3": 0.161245747722252
  },
  {
    "x": "1982-08-02",
    "y1": 0.630346256005427,
    "y2": 0.14266005849519,
    "y3": 0.163663326694318
  },
  {
    "x": "1982-08-09",
    "y1": 0.603144122330634,
    "y2": 0.14266005849519,
    "y3": 0.167852132875651
  },
  {
    "x": "1982-08-16",
    "y1": 0.652283291327812,
    "y2": 0.153503517404792,
    "y3": 0.171639957165072
  },
  {
    "x": "1982-08-23",
    "y1": 0.716011124112839,
    "y2": 0.0906266932849622,
    "y3": 0.170148405275774
  },
  {
    "x": "1982-08-30",
    "y1": 0.741067412374724,
    "y2": 0.0906266932849622,
    "y3": 0.168656853386477
  },
  {
    "x": "1982-09-06",
    "y1": 0.743374460778486,
    "y2": 0.17397765209096,
    "y3": 0.16186772887562
  },
  {
    "x": "1982-09-13",
    "y1": 0.766063118431538,
    "y2": 0.171634984389629,
    "y3": 0.160636576488567
  },
  {
    "x": "1982-09-20",
    "y1": 0.776780657649471,
    "y2": 0.300477103832229,
    "y3": 0.161737114743084
  },
  {
    "x": "1982-09-27",
    "y1": 0.777257813354891,
    "y2": 0.300477103832229,
    "y3": 0.168523448345142
  },
  {
    "x": "1982-10-04",
    "y1": 0.831258887049668,
    "y2": 0.393032838308267,
    "y3": 0.178670465739244
  },
  {
    "x": "1982-10-11",
    "y1": 0.859264354098348,
    "y2": 0.353684147034901,
    "y3": 0.185490273000789
  },
  {
    "x": "1982-10-18",
    "y1": 0.912233082537361,
    "y2": 0.432771690908727,
    "y3": 0.191179489415826
  },
  {
    "x": "1982-10-25",
    "y1": 0.899877708454624,
    "y2": 0.374372927711601,
    "y3": 0.200191560658308
  },
  {
    "x": "1982-11-01",
    "y1": 0.967600953367404,
    "y2": 0.568607578279312,
    "y3": 0.221490429942593
  },
  {
    "x": "1982-11-08",
    "y1": 0.992179211135353,
    "y2": 0.61167629177169,
    "y3": 0.239918715965884
  },
  {
    "x": "1982-11-15",
    "y1": 0.978422292086965,
    "y2": 0.509440376968244,
    "y3": 0.256691852209748
  },
  {
    "x": "1982-11-22",
    "y1": 0.975065837441704,
    "y2": 0.555326917347248,
    "y3": 0.281224763283393
  },
  {
    "x": "1982-11-29",
    "y1": 1.01232967708133,
    "y2": 0.657306430095002,
    "y3": 0.309148641362282
  },
  {
    "x": "1982-12-06",
    "y1": 0.99837286519281,
    "y2": 0.626012626528788,
    "y3": 0.336563130539681
  },
  {
    "x": "1982-12-13",
    "y1": 0.97733368067572,
    "y2": 0.551932658082383,
    "y3": 0.360040417407315
  },
  {
    "x": "1982-12-20",
    "y1": 0.992185422535899,
    "y2": 0.531871765525705,
    "y3": 0.379501002758841
  },
  {
    "x": "1982-12-27",
    "y1": 0.99252976820983,
    "y2": 0.486039038569852,
    "y3": 0.396669951762574
  },
  {
    "x": "1983-01-03",
    "y1": 1.01916374413113,
    "y2": 0.516436388437819,
    "y3": 0.414816595314226
  },
  {
    "x": "1983-01-10",
    "y1": 1.04862727556225,
    "y2": 0.512296719577983,
    "y3": 0.435900096628877
  },
  {
    "x": "1983-01-17",
    "y1": 1.04186912863757,
    "y2": 0.409235663068388,
    "y3": 0.451830545118048
  },
  {
    "x": "1983-01-24",
    "y1": 1.05400173281131,
    "y2": 0.52106630447702,
    "y3": 0.469184977737351
  },
  {
    "x": "1983-01-31",
    "y1": 1.07311646719232,
    "y2": 0.515781536177938,
    "y3": 0.486392305326767
  },
  {
    "x": "1983-02-07",
    "y1": 1.09294567789362,
    "y2": 0.580896163113883,
    "y3": 0.500413258290849
  },
  {
    "x": "1983-02-14",
    "y1": 1.11106441866307,
    "y2": 0.621529635677788,
    "y3": 0.516465884883127
  },
  {
    "x": "1983-02-21",
    "y1": 1.11546563516151,
    "y2": 0.607559969069269,
    "y3": 0.527192241421177
  },
  {
    "x": "1983-02-28",
    "y1": 1.12880201668658,
    "y2": 0.732702834840896,
    "y3": 0.546143175811477
  },
  {
    "x": "1983-03-07",
    "y1": 1.12970443915846,
    "y2": 0.701409031274681,
    "y3": 0.559575042829775
  },
  {
    "x": "1983-03-14",
    "y1": 1.12530898141427,
    "y2": 0.676353460416454,
    "y3": 0.574674069465017
  },
  {
    "x": "1983-03-21",
    "y1": 1.14749684098989,
    "y2": 0.770569202046589,
    "y3": 0.584772150653381
  },
  {
    "x": "1983-03-28",
    "y1": 1.14716450369209,
    "y2": 0.650615062387797,
    "y3": 0.586719089184186
  },
  {
    "x": "1983-04-04",
    "y1": 1.13719411295663,
    "y2": 0.670962442721397,
    "y3": 0.594795192471844
  },
  {
    "x": "1983-04-11",
    "y1": 1.18754845720378,
    "y2": 0.728080752170829,
    "y3": 0.603432884213023
  },
  {
    "x": "1983-04-18",
    "y1": 1.21222878937288,
    "y2": 0.690616334330734,
    "y3": 0.605098379424809
  },
  {
    "x": "1983-04-25",
    "y1": 1.22785869738334,
    "y2": 0.723063540434435,
    "y3": 0.609950925120092
  },
  {
    "x": "1983-05-02",
    "y1": 1.25713603704526,
    "y2": 0.766059355913473,
    "y3": 0.620657260011646
  },
  {
    "x": "1983-05-09",
    "y1": 1.26476097963005,
    "y2": 0.797520898664535,
    "y3": 0.633939716668588
  },
  {
    "x": "1983-05-16",
    "y1": 1.26351071681581,
    "y2": 0.797793616312866,
    "y3": 0.649527445555739
  },
  {
    "x": "1983-05-23",
    "y1": 1.29147879661109,
    "y2": 0.719251736022926,
    "y3": 0.659668212934994
  },
  {
    "x": "1983-05-30",
    "y1": 1.29724716187615,
    "y2": 0.663134316089392,
    "y3": 0.667210092760565
  },
  {
    "x": "1983-06-06",
    "y1": 1.30167597852049,
    "y2": 0.696095237080876,
    "y3": 0.681553071461189
  },
  {
    "x": "1983-06-13",
    "y1": 1.33615762886284,
    "y2": 0.599190975620712,
    "y3": 0.685459305018374
  },
  {
    "x": "1983-06-20",
    "y1": 1.34474374531533,
    "y2": 0.59259042750388,
    "y3": 0.689299749584671
  },
  {
    "x": "1983-06-27",
    "y1": 1.32245796194532,
    "y2": 0.667193510754813,
    "y3": 0.693614616966717
  },
  {
    "x": "1983-07-04",
    "y1": 1.3162076375098,
    "y2": 0.622308026345949,
    "y3": 0.693653536500125
  },
  {
    "x": "1983-07-11",
    "y1": 1.29524192716942,
    "y2": 0.584441659140256,
    "y3": 0.692497621003674
  },
  {
    "x": "1983-07-18",
    "y1": 1.32030024679178,
    "y2": 0.547959129461206,
    "y3": 0.68326043573469
  },
  {
    "x": "1983-07-25",
    "y1": 1.26807237598549,
    "y2": 0.4555502351218,
    "y3": 0.670967495927046
  },
  {
    "x": "1983-08-01",
    "y1": 1.25570239521912,
    "y2": 0.430250003373298,
    "y3": 0.658662323074888
  },
  {
    "x": "1983-08-08",
    "y1": 1.25363702010402,
    "y2": 0.420157731170299,
    "y3": 0.641141749531074
  },
  {
    "x": "1983-08-15",
    "y1": 1.25203484208725,
    "y2": 0.387018801784312,
    "y3": 0.6279619365009
  },
  {
    "x": "1983-08-22",
    "y1": 1.22264664962469,
    "y2": 0.420157731170299,
    "y3": 0.615421700923345
  },
  {
    "x": "1983-08-29",
    "y1": 1.24861891585159,
    "y2": 0.374754779978472,
    "y3": 0.597755402313727
  },
  {
    "x": "1983-09-05",
    "y1": 1.26332432056221,
    "y2": 0.374754779978472,
    "y3": 0.581962324596114
  },
  {
    "x": "1983-09-12",
    "y1": 1.25022164435963,
    "y2": 0.374754779978472,
    "y3": 0.564546886573315
  },
  {
    "x": "1983-09-19",
    "y1": 1.26812487477027,
    "y2": 0.420353339806904,
    "y3": 0.547261585767987
  },
  {
    "x": "1983-09-26",
    "y1": 1.24520075570014,
    "y2": 0.374754779978472,
    "y3": 0.526123279833684
  },
  {
    "x": "1983-10-03",
    "y1": 1.2475941198319,
    "y2": 0.420346402578672,
    "y3": 0.507250919146974
  },
  {
    "x": "1983-10-10",
    "y1": 1.22166597941327,
    "y2": 0.373170851300665,
    "y3": 0.489946874910861
  },
  {
    "x": "1983-10-17",
    "y1": 1.18658914918298,
    "y2": 0.346065891669754,
    "y3": 0.474093453689879
  },
  {
    "x": "1983-10-24",
    "y1": 1.17460311854508,
    "y2": 0.346065891669754,
    "y3": 0.456591986419323
  },
  {
    "x": "1983-10-31",
    "y1": 1.16384770077455,
    "y2": 0.250825922526088,
    "y3": 0.439173733764592
  },
  {
    "x": "1983-11-07",
    "y1": 1.17834413618262,
    "y2": 0.250825922526088,
    "y3": 0.422085508515702
  },
  {
    "x": "1983-11-14",
    "y1": 1.19331903541174,
    "y2": 0.205422971334261,
    "y3": 0.398996981544674
  },
  {
    "x": "1983-11-21",
    "y1": 1.20828629747569,
    "y2": 0.205422971334261,
    "y3": 0.37815272879409
  },
  {
    "x": "1983-11-28",
    "y1": 1.20275199985997,
    "y2": 0.178702479215845,
    "y3": 0.35786576979787
  },
  {
    "x": "1983-12-05",
    "y1": 1.19077639543382,
    "y2": 0.196420704071192,
    "y3": 0.340288848528369
  },
  {
    "x": "1983-12-12",
    "y1": 1.1747341871584,
    "y2": 0.244771662607627,
    "y3": 0.32974991990266
  },
  {
    "x": "1983-12-19",
    "y1": 1.17665440294966,
    "y2": 0.222376430004782,
    "y3": 0.319356241234234
  },
  {
    "x": "1983-12-26",
    "y1": 1.1841035874978,
    "y2": 0.222376430004782,
    "y3": 0.309467176175959
  },
  {
    "x": "1984-01-02",
    "y1": 1.21748473462352,
    "y2": 0.223211034104346,
    "y3": 0.30127678779196
  },
  {
    "x": "1984-01-09",
    "y1": 1.21383767725906,
    "y2": 0.133716093912205,
    "y3": 0.286954705929056
  },
  {
    "x": "1984-01-16",
    "y1": 1.20533148102587,
    "y2": 0.0948493956052264,
    "y3": 0.272959436710393
  },
  {
    "x": "1984-01-23",
    "y1": 1.16584619273879,
    "y2": 0.170726186907339,
    "y3": 0.262758007056837
  },
  {
    "x": "1984-01-30",
    "y1": 1.13227864329882,
    "y2": 0.153329031966931,
    "y3": 0.25168671965626
  },
  {
    "x": "1984-02-06",
    "y1": 1.09451486120456,
    "y2": 0.148619304938865,
    "y3": 0.238100017912858
  },
  {
    "x": "1984-02-13",
    "y1": 1.08384728315898,
    "y2": 0.148619304938865,
    "y3": 0.226793244160877
  },
  {
    "x": "1984-02-20",
    "y1": 1.08428495717143,
    "y2": 0.0994026735944394,
    "y3": 0.210746057711666
  },
  {
    "x": "1984-02-27",
    "y1": 1.10059099759824,
    "y2": 0.053999722402612,
    "y3": 0.194787501266763
  },
  {
    "x": "1984-03-05",
    "y1": 1.07503727234638,
    "y2": 0.053999722402612,
    "y3": 0.180184192803406
  },
  {
    "x": "1984-03-12",
    "y1": 1.09254661215817,
    "y2": 0.0489055278620507,
    "y3": 0.165326174613021
  },
  {
    "x": "1984-03-19",
    "y1": 1.07916697188908,
    "y2": 0.066623752717398,
    "y3": 0.156116066122586
  },
  {
    "x": "1984-03-26",
    "y1": 1.08236724017227,
    "y2": 0.137565863954628,
    "y3": 0.150453063194013
  },
  {
    "x": "1984-04-02",
    "y1": 1.05509235233757,
    "y2": 0.137565863954628,
    "y3": 0.147060207825032
  },
  {
    "x": "1984-04-09",
    "y1": 1.05537927561678,
    "y2": 0.137565863954628,
    "y3": 0.14366735245605
  },
  {
    "x": "1984-04-16",
    "y1": 1.06087090147984,
    "y2": 0.137565863954628,
    "y3": 0.141610521692989
  },
  {
    "x": "1984-04-23",
    "y1": 1.06718835717338,
    "y2": 0.0783883332895299,
    "y3": 0.135708903153906
  },
  {
    "x": "1984-04-30",
    "y1": 1.0833487686428,
    "y2": 0.131809877565808,
    "y3": 0.130060813901815
  },
  {
    "x": "1984-05-07",
    "y1": 1.08207334090073,
    "y2": 0.131809877565808,
    "y3": 0.125532486279867
  },
  {
    "x": "1984-05-14",
    "y1": 1.05828754635367,
    "y2": 0.149528102421156,
    "y3": 0.121890069900685
  },
  {
    "x": "1984-05-21",
    "y1": 1.01994077042707,
    "y2": 0.167048669382108,
    "y3": 0.119081951664573
  },
  {
    "x": "1984-05-28",
    "y1": 1.02278903884995,
    "y2": 0.167048669382108,
    "y3": 0.120748580438068
  },
  {
    "x": "1984-06-04",
    "y1": 1.04165301647677,
    "y2": 0.167048669382108,
    "y3": 0.124358544126913
  },
  {
    "x": "1984-06-11",
    "y1": 1.02205656715595,
    "y2": 0.0783883332895299,
    "y3": 0.119741651446022
  },
  {
    "x": "1984-06-18",
    "y1": 1.04526994873323,
    "y2": 0.0717877851726977,
    "y3": 0.11566458910631
  },
  {
    "x": "1984-06-25",
    "y1": 1.039214593459,
    "y2": 0.066503016873616,
    "y3": 0.111558774703048
  },
  {
    "x": "1984-07-02",
    "y1": 1.02698846055516,
    "y2": 0.150932071642184,
    "y3": 0.111674413038214
  },
  {
    "x": "1984-07-09",
    "y1": 1.01832842743085,
    "y2": 0.147544270961116,
    "y3": 0.114081492906548
  },
  {
    "x": "1984-07-16",
    "y1": 0.995743507785769,
    "y2": 0.220470213658386,
    "y3": 0.122405017469336
  },
  {
    "x": "1984-07-23",
    "y1": 0.995438358607936,
    "y2": 0.204408340135419,
    "y3": 0.129925448355977
  },
  {
    "x": "1984-07-30",
    "y1": 1.06931538528021,
    "y2": 0.221099806215517,
    "y3": 0.13853516227365
  },
  {
    "x": "1984-08-06",
    "y1": 1.09445340934019,
    "y2": 0.189806002649302,
    "y3": 0.144694274770245
  },
  {
    "x": "1984-08-13",
    "y1": 1.0862927405672,
    "y2": 0.164750431791075,
    "y3": 0.146053503162068
  },
  {
    "x": "1984-08-20",
    "y1": 1.10390668691906,
    "y2": 0.162407764089745,
    "y3": 0.147295598168823
  },
  {
    "x": "1984-08-27",
    "y1": 1.10335719563121,
    "y2": 0.217288001804008,
    "y3": 0.151281705061292
  },
  {
    "x": "1984-09-03",
    "y1": 1.09173291538866,
    "y2": 0.204427966771224,
    "y3": 0.154624810202122
  },
  {
    "x": "1984-09-10",
    "y1": 1.10730830295149,
    "y2": 0.318987362607979,
    "y3": 0.166654761668045
  },
  {
    "x": "1984-09-17",
    "y1": 1.09588415053362,
    "y2": 0.0972272414017944,
    "y3": 0.164925629859844
  },
  {
    "x": "1984-09-24",
    "y1": 1.08504043392053,
    "y2": 0.13602964447679,
    "y3": 0.165136618205393
  },
  {
    "x": "1984-10-01",
    "y1": 1.06711614935712,
    "y2": 0.122574941537185,
    "y3": 0.163788960161195
  },
  {
    "x": "1984-10-08",
    "y1": 1.07013085731008,
    "y2": 0.161601045113926,
    "y3": 0.163516578947785
  },
  {
    "x": "1984-10-15",
    "y1": 1.09043954968204,
    "y2": 0.174002261078458,
    "y3": 0.163864258532603
  },
  {
    "x": "1984-10-22",
    "y1": 1.07531214881452,
    "y2": 0.0811106436618708,
    "y3": 0.159567357246591
  },
  {
    "x": "1984-10-29",
    "y1": 1.07773739585703,
    "y2": 0.199033222949186,
    "y3": 0.165599601729574
  },
  {
    "x": "1984-11-05",
    "y1": 1.08378578295381,
    "y2": 0.243110571305866,
    "y3": 0.174165741036232
  },
  {
    "x": "1984-11-12",
    "y1": 1.06615053687571,
    "y2": 0.300477103832229,
    "y3": 0.185864445384163
  },
  {
    "x": "1984-11-19",
    "y1": 1.06696651787637,
    "y2": 0.275421532974003,
    "y3": 0.192088918450754
  },
  {
    "x": "1984-11-26",
    "y1": 1.05514422224166,
    "y2": 0.124994850978531,
    "y3": 0.190961447451625
  },
  {
    "x": "1984-12-03",
    "y1": 1.04235548081104,
    "y2": 0.255360640417325,
    "y3": 0.192705968789572
  },
  {
    "x": "1984-12-10",
    "y1": 1.04110181157605,
    "y2": 0.195114797794257,
    "y3": 0.192241291672514
  },
  {
    "x": "1984-12-17",
    "y1": 1.06536960677169,
    "y2": 0.15063843080178,
    "y3": 0.188718222901827
  },
  {
    "x": "1984-12-24",
    "y1": 1.06986303336897,
    "y2": 0.137778395768997,
    "y3": 0.186116842557811
  },
  {
    "x": "1984-12-31",
    "y1": 1.07067642178701,
    "y2": 0.281977269612845,
    "y3": 0.1919781844489
  },
  {
    "x": "1985-01-07",
    "y1": 1.09546305605536,
    "y2": 0.30437250221569,
    "y3": 0.199076421355197
  },
  {
    "x": "1985-01-14",
    "y1": 1.13868275981099,
    "y2": 0.313388076205617,
    "y3": 0.203881425075278
  },
  {
    "x": "1985-01-21",
    "y1": 1.1801118500566,
    "y2": 0.353684147034901,
    "y3": 0.211344234088462
  },
  {
    "x": "1985-01-28",
    "y1": 1.19617022194158,
    "y2": 0.322390343468686,
    "y3": 0.211514383131497
  },
  {
    "x": "1985-02-04",
    "y1": 1.23208976295895,
    "y2": 0.423384956133164,
    "y3": 0.227822268868065
  },
  {
    "x": "1985-02-11",
    "y1": 1.22966264193167,
    "y2": 0.521432027001305,
    "y3": 0.247092387994291
  },
  {
    "x": "1985-02-18",
    "y1": 1.22444887781504,
    "y2": 0.568607578279312,
    "y3": 0.269394019831397
  },
  {
    "x": "1985-02-25",
    "y1": 1.22794293776384,
    "y2": 0.537313774713097,
    "y3": 0.288179656311356
  },
  {
    "x": "1985-03-04",
    "y1": 1.21122978279682,
    "y2": 0.445021760020186,
    "y3": 0.301730631258442
  },
  {
    "x": "1985-03-11",
    "y1": 1.19564906752918,
    "y2": 0.428959886497219,
    "y3": 0.31912309340021
  },
  {
    "x": "1985-03-18",
    "y1": 1.19888645564603,
    "y2": 0.335441043023508,
    "y3": 0.325943484403926
  },
  {
    "x": "1985-03-25",
    "y1": 1.19996217567871,
    "y2": 0.372842466563685,
    "y3": 0.332430079166817
  },
  {
    "x": "1985-04-01",
    "y1": 1.19351511897438,
    "y2": 0.317143051462591,
    "y3": 0.333263376548335
  },
  {
    "x": "1985-04-08",
    "y1": 1.20505085176977,
    "y2": 0.334832847307652,
    "y3": 0.336233942265017
  },
  {
    "x": "1985-04-15",
    "y1": 1.21289112846827,
    "y2": 0.423597867762293,
    "y3": 0.351164093104205
  },
  {
    "x": "1985-04-22",
    "y1": 1.21748808167429,
    "y2": 0.421255200060962,
    "y3": 0.359458821086387
  },
  {
    "x": "1985-04-29",
    "y1": 1.20411244552889,
    "y2": 0.277295530035365,
    "y3": 0.363567857698443
  },
  {
    "x": "1985-05-06",
    "y1": 1.22979925437866,
    "y2": 0.346065891669754,
    "y3": 0.373339230741841
  },
  {
    "x": "1985-05-13",
    "y1": 1.24440799249007,
    "y2": 0.310500753210429,
    "y3": 0.381975348613913
  },
  {
    "x": "1985-05-20",
    "y1": 1.24577924336338,
    "y2": 0.257405555577176,
    "y3": 0.380746762912129
  },
  {
    "x": "1985-05-27",
    "y1": 1.2413286501303,
    "y2": 0.257405555577176,
    "y3": 0.378398415580204
  },
  {
    "x": "1985-06-03",
    "y1": 1.2420164500458,
    "y2": 0.346065891669754,
    "y3": 0.380032306353411
  },
  {
    "x": "1985-06-10",
    "y1": 1.23170717169529,
    "y2": 0.346065891669754,
    "y3": 0.379651393585153
  },
  {
    "x": "1985-06-17",
    "y1": 1.23413776963637,
    "y2": 0.346065891669754,
    "y3": 0.380835170995207
  },
  {
    "x": "1985-06-24",
    "y1": 1.26011629295774,
    "y2": 0.362546002654419,
    "y3": 0.377793223321269
  },
  {
    "x": "1985-07-01",
    "y1": 1.26821890537359,
    "y2": 0.423597867762293,
    "y3": 0.372901515359319
  },
  {
    "x": "1985-07-08",
    "y1": 1.28094491915556,
    "y2": 0.403536975205615,
    "y3": 0.364647985205634
  },
  {
    "x": "1985-07-15",
    "y1": 1.29880204218954,
    "y2": 0.387475101682648,
    "y3": 0.357156051554112
  },
  {
    "x": "1985-07-22",
    "y1": 1.28840573999213,
    "y2": 0.405193326537995,
    "y3": 0.355164629880002
  },
  {
    "x": "1985-07-29",
    "y1": 1.28807742055185,
    "y2": 0.476135437775226,
    "y3": 0.357523407443902
  },
  {
    "x": "1985-08-05",
    "y1": 1.27034345044845,
    "y2": 0.42349318340023,
    "y3": 0.361926014462739
  },
  {
    "x": "1985-08-12",
    "y1": 1.26165068531819,
    "y2": 0.463275402742442,
    "y3": 0.366447661271676
  },
  {
    "x": "1985-08-19",
    "y1": 1.26232526274494,
    "y2": 0.452978938833176,
    "y3": 0.373239455640206
  },
  {
    "x": "1985-08-26",
    "y1": 1.26569567042562,
    "y2": 0.356074677373012,
    "y3": 0.374301547143474
  },
  {
    "x": "1985-09-02",
    "y1": 1.26065704113945,
    "y2": 0.34947412925618,
    "y3": 0.370595360218168
  },
  {
    "x": "1985-09-09",
    "y1": 1.23027216730727,
    "y2": 0.315328448886661,
    "y3": 0.365299022659453
  },
  {
    "x": "1985-09-16",
    "y1": 1.2205228003451,
    "y2": 0.346065891669754,
    "y3": 0.368737540741172
  },
  {
    "x": "1985-09-23",
    "y1": 1.20575493192179,
    "y2": 0.346065891669754,
    "y3": 0.368737540741172
  },
  {
    "x": "1985-09-30",
    "y1": 1.20682555212129,
    "y2": 0.346065891669754,
    "y3": 0.370515797664139
  },
  {
    "x": "1985-10-07",
    "y1": 1.21146008970763,
    "y2": 0.205422971334261,
    "y3": 0.367916668451993
  },
  {
    "x": "1985-10-14",
    "y1": 1.23488097824353,
    "y2": 0.205422971334261,
    "y3": 0.365317539239847
  },
  {
    "x": "1985-10-21",
    "y1": 1.23869514650565,
    "y2": 0.178702479215845,
    "y3": 0.356949368617152
  },
  {
    "x": "1985-10-28",
    "y1": 1.25458463218273,
    "y2": 0.15611132651505,
    "y3": 0.347451640359416
  },
  {
    "x": "1985-11-04",
    "y1": 1.27464581468542,
    "y2": 0.173829551370397,
    "y3": 0.338839823344448
  },
  {
    "x": "1985-11-11",
    "y1": 1.29531252204219,
    "y2": 0.196420704071192,
    "y3": 0.330533558415287
  },
  {
    "x": "1985-11-18",
    "y1": 1.31033530258613,
    "y2": 0.235644490660612,
    "y3": 0.321135889560203
  },
  {
    "x": "1985-11-25",
    "y1": 1.32063135256269,
    "y2": 0.235644490660612,
    "y3": 0.312741265332953
  },
  {
    "x": "1985-12-02",
    "y1": 1.32891162677771,
    "y2": 0.388994891833524,
    "y3": 0.312817254840497
  },
  {
    "x": "1985-12-09",
    "y1": 1.35228494880495,
    "y2": 0.49013822343509,
    "y3": 0.317064499685352
  },
  {
    "x": "1985-12-16",
    "y1": 1.34950718986518,
    "y2": 0.345737506932774,
    "y3": 0.310544603143229
  },
  {
    "x": "1985-12-23",
    "y1": 1.34857862810449,
    "y2": 0.388994891833524,
    "y3": 0.308819688564894
  },
  {
    "x": "1985-12-30",
    "y1": 1.35756259503055,
    "y2": 0.49013822343509,
    "y3": 0.310162829599526
  },
  {
    "x": "1986-01-06",
    "y1": 1.35357113582937,
    "y2": 0.388994891833524,
    "y3": 0.306963627249543
  },
  {
    "x": "1986-01-13",
    "y1": 1.37299166119645,
    "y2": 0.465082652576864,
    "y3": 0.312414026009736
  },
  {
    "x": "1986-01-20",
    "y1": 1.3675486063307,
    "y2": 0.281794166464094,
    "y3": 0.309030027870132
  },
  {
    "x": "1986-01-27",
    "y1": 1.38852760914168,
    "y2": 0.382295145140255,
    "y3": 0.312378362682811
  },
  {
    "x": "1986-02-03",
    "y1": 1.40758664620754,
    "y2": 0.366233271617288,
    "y3": 0.313386731680188
  },
  {
    "x": "1986-02-10",
    "y1": 1.43096478681134,
    "y2": 0.353373236584505,
    "y3": 0.313752098925926
  },
  {
    "x": "1986-02-17",
    "y1": 1.4465272696768,
    "y2": 0.479947242186734,
    "y3": 0.320446166451775
  },
  {
    "x": "1986-02-24",
    "y1": 1.45735253656724,
    "y2": 0.448653438620519,
    "y3": 0.332607689816088
  },
  {
    "x": "1986-03-03",
    "y1": 1.46486300167721,
    "y2": 0.51225820385487,
    "y3": 0.347949451442118
  },
  {
    "x": "1986-03-10",
    "y1": 1.49136762691849,
    "y2": 0.61167629177169,
    "y3": 0.36959814206991
  },
  {
    "x": "1986-03-17",
    "y1": 1.49351937069691,
    "y2": 0.580382488205475,
    "y3": 0.390811700154432
  },
  {
    "x": "1986-03-24",
    "y1": 1.49539801180798,
    "y2": 0.555326917347248,
    "y3": 0.409886568453274
  },
  {
    "x": "1986-03-31",
    "y1": 1.49245138544338,
    "y2": 0.452978938833176,
    "y3": 0.422714480191373
  },
  {
    "x": "1986-04-07",
    "y1": 1.51045241034857,
    "y2": 0.44473501346559,
    "y3": 0.433169006331622
  },
  {
    "x": "1986-04-14",
    "y1": 1.54001169350362,
    "y2": 0.53526602479057,
    "y3": 0.44815008303812
  },
  {
    "x": "1986-04-21",
    "y1": 1.54565122607227,
    "y2": 0.430543815175026,
    "y3": 0.450227529205195
  },
  {
    "x": "1986-04-28",
    "y1": 1.52245475431826,
    "y2": 0.417683780142242,
    "y3": 0.446604807040553
  },
  {
    "x": "1986-05-05",
    "y1": 1.53785139760777,
    "y2": 0.496047652325554,
    "y3": 0.454120314310192
  },
  {
    "x": "1986-05-12",
    "y1": 1.52654326646548,
    "y2": 0.487803726957967,
    "y3": 0.459060756066414
  },
  {
    "x": "1986-05-19",
    "y1": 1.5452591007805,
    "y2": 0.621768563974688,
    "y3": 0.465642273093394
  },
  {
    "x": "1986-05-26",
    "y1": 1.5664380199941,
    "y2": 0.531585277748782,
    "y3": 0.472771792389157
  },
  {
    "x": "1986-06-02",
    "y1": 1.5666878340443,
    "y2": 0.506529706890555,
    "y3": 0.474844145104841
  },
  {
    "x": "1986-06-09",
    "y1": 1.5649391912494,
    "y2": 0.568646094002425,
    "y3": 0.489186741481758
  },
  {
    "x": "1986-06-16",
    "y1": 1.55818240404772,
    "y2": 0.555070515291557,
    "y3": 0.497825509989323
  },
  {
    "x": "1986-06-23",
    "y1": 1.57506326146788,
    "y2": 0.692471746915018,
    "y3": 0.514137433754209
  },
  {
    "x": "1986-06-30",
    "y1": 1.59389380157835,
    "y2": 0.661177943348803,
    "y3": 0.529527669092425
  },
  {
    "x": "1986-07-07",
    "y1": 1.54622841850037,
    "y2": 0.476173953498338,
    "y3": 0.529339004658005
  },
  {
    "x": "1986-07-14",
    "y1": 1.5194153443524,
    "y2": 0.491295451044134,
    "y3": 0.531471105279185
  },
  {
    "x": "1986-07-21",
    "y1": 1.51600411819201,
    "y2": 0.486010682745052,
    "y3": 0.530158729223695
  },
  {
    "x": "1986-07-28",
    "y1": 1.492044202767,
    "y2": 0.463415116071049,
    "y3": 0.522745670438663
  },
  {
    "x": "1986-08-04",
    "y1": 1.47882590157276,
    "y2": 0.377089017677922,
    "y3": 0.512580996912285
  },
  {
    "x": "1986-08-11",
    "y1": 1.51819174327479,
    "y2": 0.331686066486094,
    "y3": 0.501398954369227
  },
  {
    "x": "1986-08-18",
    "y1": 1.52161096408286,
    "y2": 0.331686066486094,
    "y3": 0.495334310751873
  },
  {
    "x": "1986-08-25",
    "y1": 1.52528067285478,
    "y2": 0.331686066486094,
    "y3": 0.489681863402898
  },
  {
    "x": "1986-09-01",
    "y1": 1.51352825689309,
    "y2": 0.310444236420735,
    "y3": 0.478440773984407
  },
  {
    "x": "1986-09-08",
    "y1": 1.43001872567422,
    "y2": 0.267362815308422,
    "y3": 0.470281723991076
  },
  {
    "x": "1986-09-15",
    "y1": 1.4375158600313,
    "y2": 0.29625505702968,
    "y3": 0.464210287835448
  },
  {
    "x": "1986-09-22",
    "y1": 1.44381240337836,
    "y2": 0.29625505702968,
    "y3": 0.454220658070655
  },
  {
    "x": "1986-09-29",
    "y1": 1.44722532052461,
    "y2": 0.207594720937102,
    "y3": 0.440210207769611
  },
  {
    "x": "1986-10-06",
    "y1": 1.44920948217782,
    "y2": 0.207594720937102,
    "y3": 0.419501515617732
  },
  {
    "x": "1986-10-13",
    "y1": 1.45543299620054,
    "y2": 0.207594720937102,
    "y3": 0.403301987777148
  },
  {
    "x": "1986-10-20",
    "y1": 1.45824435398991,
    "y2": 0.29625505702968,
    "y3": 0.392788255284104
  },
  {
    "x": "1986-10-27",
    "y1": 1.46973853802588,
    "y2": 0.29625505702968,
    "y3": 0.379168703435467
  },
  {
    "x": "1986-11-03",
    "y1": 1.47029289560292,
    "y2": 0.196420704071192,
    "y3": 0.361236212874449
  },
  {
    "x": "1986-11-10",
    "y1": 1.46336768784669,
    "y2": 0.151434318767552,
    "y3": 0.334184341467075
  },
  {
    "x": "1986-11-17",
    "y1": 1.45276800083701,
    "y2": 0.222376430004782,
    "y3": 0.312244265799874
  },
  {
    "x": "1986-11-24",
    "y1": 1.4665824742733,
    "y2": 0.222376430004782,
    "y3": 0.299554389625197
  },
  {
    "x": "1986-12-01",
    "y1": 1.47603740708413,
    "y2": 0.179119045104032,
    "y3": 0.283945569328191
  },
  {
    "x": "1986-12-08",
    "y1": 1.4564781616199,
    "y2": 0.0948493956052264,
    "y3": 0.2643875049712
  },
  {
    "x": "1986-12-15",
    "y1": 1.44608203418831,
    "y2": 0.127468802006589,
    "y3": 0.247590189267977
  },
  {
    "x": "1986-12-22",
    "y1": 1.43955160195994,
    "y2": 0.170726186907339,
    "y3": 0.237272047729448
  },
  {
    "x": "1986-12-29",
    "y1": 1.44898292053128,
    "y2": 0.170726186907339,
    "y3": 0.22922405375051
  },
  {
    "x": "1987-01-05",
    "y1": 1.52684248748928,
    "y2": 0.146219388383209,
    "y3": 0.219950719845366
  },
  {
    "x": "1987-01-12",
    "y1": 1.55100844859897,
    "y2": 0.146219388383209,
    "y3": 0.210677385940222
  },
  {
    "x": "1987-01-19",
    "y1": 1.55690744410179,
    "y2": 0.146219388383209,
    "y3": 0.202466143538345
  },
  {
    "x": "1987-01-26",
    "y1": 1.55665245659439,
    "y2": 0.163937613238556,
    "y3": 0.197294883434852
  },
  {
    "x": "1987-02-02",
    "y1": 1.59439789796799,
    "y2": 0.361739034742053,
    "y3": 0.200569082320471
  },
  {
    "x": "1987-02-09",
    "y1": 1.60816050840671,
    "y2": 0.442344483127479,
    "y3": 0.207873553625361
  },
  {
    "x": "1987-02-16",
    "y1": 1.61955447739346,
    "y2": 0.270614280492043,
    "y3": 0.211024531603108
  },
  {
    "x": "1987-02-23",
    "y1": 1.63825051661864,
    "y2": 0.250553387935365,
    "y3": 0.213172464953021
  },
  {
    "x": "1987-03-02",
    "y1": 1.64883875191276,
    "y2": 0.322390343468686,
    "y3": 0.2189122460796
  },
  {
    "x": "1987-03-09",
    "y1": 1.65465947368226,
    "y2": 0.385995108703037,
    "y3": 0.223399248663268
  },
  {
    "x": "1987-03-16",
    "y1": 1.67225208040336,
    "y2": 0.365934216146359,
    "y3": 0.226883206619102
  },
  {
    "x": "1987-03-23",
    "y1": 1.66542769469283,
    "y2": 0.306614957722642,
    "y3": 0.232392919301674
  },
  {
    "x": "1987-03-30",
    "y1": 1.6672600075233,
    "y2": 0.285150878078508,
    "y3": 0.239078747267222
  },
  {
    "x": "1987-04-06",
    "y1": 1.65239946776404,
    "y2": 0.337012307590609,
    "y3": 0.244810541146513
  },
  {
    "x": "1987-04-13",
    "y1": 1.62594322720252,
    "y2": 0.326715843681343,
    "y3": 0.250027511830341
  },
  {
    "x": "1987-04-20",
    "y1": 1.60949508918945,
    "y2": 0.318471918313756,
    "y3": 0.256995155490828
  },
  {
    "x": "1987-04-27",
    "y1": 1.62355225765084,
    "y2": 0.451069682469644,
    "y3": 0.274806169834049
  },
  {
    "x": "1987-05-04",
    "y1": 1.63502457691606,
    "y2": 0.432771690908727,
    "y3": 0.290071314279155
  },
  {
    "x": "1987-05-11",
    "y1": 1.62486385341295,
    "y2": 0.213694984481255,
    "y3": 0.292219754157851
  },
  {
    "x": "1987-05-18",
    "y1": 1.59741100030348,
    "y2": 0.178702479215845,
    "y3": 0.292618568773277
  },
  {
    "x": "1987-05-25",
    "y1": 1.6197477853792,
    "y2": 0.302355320573833,
    "y3": 0.300425365382808
  },
  {
    "x": "1987-06-01",
    "y1": 1.62286900457,
    "y2": 0.298967519892765,
    "y3": 0.308062771958286
  },
  {
    "x": "1987-06-08",
    "y1": 1.64105954149094,
    "y2": 0.497665467042082,
    "y3": 0.325635075891229
  },
  {
    "x": "1987-06-15",
    "y1": 1.649757266597,
    "y2": 0.448653438620519,
    "y3": 0.339870867160328
  },
  {
    "x": "1987-06-22",
    "y1": 1.64416417905948,
    "y2": 0.423597867762293,
    "y3": 0.342963808811339
  },
  {
    "x": "1987-06-29",
    "y1": 1.64228928267406,
    "y2": 0.492197311298193,
    "y3": 0.345456450219875
  },
  {
    "x": "1987-07-06",
    "y1": 1.64252409390897,
    "y2": 0.442033572677083,
    "y3": 0.354027414829127
  },
  {
    "x": "1987-07-13",
    "y1": 1.66153819274352,
    "y2": 0.476135437775226,
    "y3": 0.36530651732112
  },
  {
    "x": "1987-07-20",
    "y1": 1.65002010951454,
    "y2": 0.334832847307652,
    "y3": 0.365928642513068
  },
  {
    "x": "1987-07-27",
    "y1": 1.66353674365686,
    "y2": 0.32823229919082,
    "y3": 0.363040502037458
  },
  {
    "x": "1987-08-03",
    "y1": 1.68354137076454,
    "y2": 0.374615066649864,
    "y3": 0.363474544562633
  },
  {
    "x": "1987-08-10",
    "y1": 1.7015756356201,
    "y2": 0.523015955679112,
    "y3": 0.374294594460456
  },
  {
    "x": "1987-08-17",
    "y1": 1.70954730536071,
    "y2": 0.491722152112897,
    "y3": 0.384623158162176
  },
  {
    "x": "1987-08-24",
    "y1": 1.70537326238376,
    "y2": 0.46666658125467,
    "y3": 0.391105871845379
  },
  {
    "x": "1987-08-31",
    "y1": 1.69037218588677,
    "y2": 0.432849697049676,
    "y3": 0.396412564513796
  },
  {
    "x": "1987-09-07",
    "y1": 1.68970032072894,
    "y2": 0.428618415725666,
    "y3": 0.401919889384391
  },
  {
    "x": "1987-09-14",
    "y1": 1.6778221984395,
    "y2": 0.428618415725666,
    "y3": 0.400797326047192
  },
  {
    "x": "1987-09-21",
    "y1": 1.68009028647271,
    "y2": 0.49200863988982,
    "y3": 0.403759173496247
  },
  {
    "x": "1987-09-28",
    "y1": 1.70204098197171,
    "y2": 0.430543815175026,
    "y3": 0.414601615030935
  },
  {
    "x": "1987-10-05",
    "y1": 1.67281154878165,
    "y2": 0.257405555577176,
    "y3": 0.418536768849002
  },
  {
    "x": "1987-10-12",
    "y1": 1.59959073092029,
    "y2": 0.244771662607627,
    "y3": 0.415657585950692
  },
  {
    "x": "1987-10-19",
    "y1": 1.40810663018089,
    "y2": 0.153329031966931,
    "y3": 0.4083756615544
  },
  {
    "x": "1987-10-26",
    "y1": 1.39227706486268,
    "y2": 0.148619304938865,
    "y3": 0.390923353449239
  },
  {
    "x": "1987-11-02",
    "y1": 1.40186570148676,
    "y2": 0.148619304938865,
    "y3": 0.375921646765156
  },
  {
    "x": "1987-11-09",
    "y1": 1.3914490533248,
    "y2": 0.053999722402612,
    "y3": 0.357441739497172
  },
  {
    "x": "1987-11-16",
    "y1": 1.35894131338672,
    "y2": 0.0489055278620507,
    "y3": 0.335277150325365
  },
  {
    "x": "1987-11-23",
    "y1": 1.37174131338672,
    "y2": 0.0489055278620507,
    "y3": 0.315620748084614
  },
  {
    "x": "1987-11-30",
    "y1": 1.29717573328082,
    "y2": 0.0588382855893703,
    "y3": 0.294755890475321
  },
  {
    "x": "1987-12-07",
    "y1": 1.3302928804613,
    "y2": 0.133586133357547,
    "y3": 0.284693554777816
  },
  {
    "x": "1987-12-14",
    "y1": 1.41059687022612,
    "y2": 0.0715079651833248,
    "y3": 0.271857338077441
  },
  {
    "x": "1987-12-21",
    "y1": 1.42986887520676,
    "y2": 0.0537897403279775,
    "y3": 0.255816071761347
  },
  {
    "x": "1987-12-28",
    "y1": 1.42176559757137,
    "y2": 0.0537897403279775,
    "y3": 0.23235476099379
  },
  {
    "x": "1988-01-04",
    "y1": 1.44597134643672,
    "y2": 0.0866322586571163,
    "y3": 0.212100266321001
  },
  {
    "x": "1988-01-11",
    "y1": 1.45069810006601,
    "y2": 0.204408340135419,
    "y3": 0.198987354265038
  },
  {
    "x": "1988-01-18",
    "y1": 1.44334732101534,
    "y2": 0.204408340135419,
    "y3": 0.187565286419325
  },
  {
    "x": "1988-01-25",
    "y1": 1.46437814440146,
    "y2": 0.204408340135419,
    "y3": 0.176354782639813
  },
  {
    "x": "1988-02-01",
    "y1": 1.46756925419834,
    "y2": 0.115748004042841,
    "y3": 0.160711262055672
  },
  {
    "x": "1988-02-08",
    "y1": 1.48925809244228,
    "y2": 0.258332822766821,
    "y3": 0.149027471199522
  },
  {
    "x": "1988-02-15",
    "y1": 1.5000138763139,
    "y2": 0.221099806215517,
    "y3": 0.138555270751546
  },
  {
    "x": "1988-02-22",
    "y1": 1.51765595888262,
    "y2": 0.189806002649302,
    "y3": 0.135175293105153
  },
  {
    "x": "1988-02-29",
    "y1": 1.54517384597111,
    "y2": 0.248045251370749,
    "y3": 0.135338972543309
  },
  {
    "x": "1988-03-07",
    "y1": 1.55079785812387,
    "y2": 0.144689539234397,
    "y3": 0.134906997906682
  },
  {
    "x": "1988-03-14",
    "y1": 1.56704288103603,
    "y2": 0.217288001804008,
    "y3": 0.138340432749939
  },
  {
    "x": "1988-03-21",
    "y1": 1.5431959052552,
    "y2": 0.204427966771224,
    "y3": 0.141130865841557
  },
  {
    "x": "1988-03-28",
    "y1": 1.54883350553309,
    "y2": 0.194131502861959,
    "y3": 0.148137454864524
  },
  {
    "x": "1988-04-04",
    "y1": 1.56805395820832,
    "y2": 0.287693559041764,
    "y3": 0.16007685642351
  },
  {
    "x": "1988-04-11",
    "y1": 1.54736251203476,
    "y2": 0.0906266932849622,
    "y3": 0.162162914694656
  },
  {
    "x": "1988-04-18",
    "y1": 1.54762997955321,
    "y2": 0.130744876177708,
    "y3": 0.165758244224073
  },
  {
    "x": "1988-04-25",
    "y1": 1.56153375550784,
    "y2": 0.0811106436618708,
    "y3": 0.163134469739289
  },
  {
    "x": "1988-05-02",
    "y1": 1.56206113336389,
    "y2": 0.112243396669023,
    "y3": 0.165171241313574
  },
  {
    "x": "1988-05-09",
    "y1": 1.54387453872107,
    "y2": 0.148619304938865,
    "y3": 0.169912719544118
  },
  {
    "x": "1988-05-16",
    "y1": 1.52642487429154,
    "y2": 0.0599589688462875,
    "y3": 0.170221180970034
  },
  {
    "x": "1988-05-23",
    "y1": 1.52833747595009,
    "y2": 0.148619304938865,
    "y3": 0.173320533284121
  },
  {
    "x": "1988-05-30",
    "y1": 1.55615307821327,
    "y2": 0.161601045113926,
    "y3": 0.171180168533046
  },
  {
    "x": "1988-06-06",
    "y1": 1.58109336489066,
    "y2": 0.0906266932849622,
    "y3": 0.165491086190524
  },
  {
    "x": "1988-06-13",
    "y1": 1.58264657773683,
    "y2": 0.0906266932849622,
    "y3": 0.159802003848001
  },
  {
    "x": "1988-06-20",
    "y1": 1.59479445129893,
    "y2": 0.0906266932849622,
    "y3": 0.158545938310107
  },
  {
    "x": "1988-06-27",
    "y1": 1.60271070782395,
    "y2": 0.17928702937754,
    "y3": 0.154593648640643
  },
  {
    "x": "1988-07-04",
    "y1": 1.60169721808063,
    "y2": 0.287693559041764,
    "y3": 0.157923336281955
  },
  {
    "x": "1988-07-11",
    "y1": 1.60347254709078,
    "y2": 0.370637605705422,
    "y3": 0.166964916434761
  },
  {
    "x": "1988-07-18",
    "y1": 1.58423202530973,
    "y2": 0.547365748213952,
    "y3": 0.181930941276921
  },
  {
    "x": "1988-07-25",
    "y1": 1.58397387841997,
    "y2": 0.516071944647738,
    "y3": 0.200500061547588
  },
  {
    "x": "1988-08-01",
    "y1": 1.58500673260709,
    "y2": 0.447758988888761,
    "y3": 0.212023610901826
  },
  {
    "x": "1988-08-08",
    "y1": 1.5625666708761,
    "y2": 0.356361423927608,
    "y3": 0.219620283759645
  },
  {
    "x": "1988-08-15",
    "y1": 1.55834501888793,
    "y2": 0.525350193378562,
    "y3": 0.236181218285475
  },
  {
    "x": "1988-08-22",
    "y1": 1.55039589316319,
    "y2": 0.353373236584505,
    "y3": 0.239465202162612
  },
  {
    "x": "1988-08-29",
    "y1": 1.55600488391573,
    "y2": 0.61167629177169,
    "y3": 0.265517682086949
  },
  {
    "x": "1988-09-05",
    "y1": 1.56955071685999,
    "y2": 0.491722152112897,
    "y3": 0.283566545883708
  },
  {
    "x": "1988-09-12",
    "y1": 1.57557793844328,
    "y2": 0.302298577978173,
    "y3": 0.294625942599523
  },
  {
    "x": "1988-09-19",
    "y1": 1.57844328390044,
    "y2": 0.26990885004818,
    "y3": 0.302509215268481
  },
  {
    "x": "1988-09-26",
    "y1": 1.58545630262,
    "y2": 0.314732034534438,
    "y3": 0.31081485174826
  },
  {
    "x": "1988-10-03",
    "y1": 1.58029767497742,
    "y2": 0.35095010413568,
    "y3": 0.325364408512729
  },
  {
    "x": "1988-10-10",
    "y1": 1.57744570176326,
    "y2": 0.348237641272595,
    "y3": 0.335345325329416
  },
  {
    "x": "1988-10-17",
    "y1": 1.58784611761485,
    "y2": 0.346065891669754,
    "y3": 0.344568567657207
  },
  {
    "x": "1988-10-24",
    "y1": 1.57292069759568,
    "y2": 0.205422971334261,
    "y3": 0.350308381559672
  },
  {
    "x": "1988-10-31",
    "y1": 1.56821853497716,
    "y2": 0.294083307426838,
    "y3": 0.360481212266766
  },
  {
    "x": "1988-11-07",
    "y1": 1.54932086514243,
    "y2": 0.224105430407672,
    "y3": 0.367155149122902
  },
  {
    "x": "1988-11-14",
    "y1": 1.53273450374082,
    "y2": 0.222376430004782,
    "y3": 0.369309619154264
  },
  {
    "x": "1988-11-21",
    "y1": 1.52947005274216,
    "y2": 0.222376430004782,
    "y3": 0.366043762702415
  },
  {
    "x": "1988-11-28",
    "y1": 1.54993948539755,
    "y2": 0.133716093912205,
    "y3": 0.354197687112754
  },
  {
    "x": "1988-12-05",
    "y1": 1.55341639989814,
    "y2": 0.133716093912205,
    "y3": 0.333515204397666
  },
  {
    "x": "1988-12-12",
    "y1": 1.55501548189818,
    "y2": 0.0948493956052264,
    "y3": 0.312454076945541
  },
  {
    "x": "1988-12-19",
    "y1": 1.55900696686019,
    "y2": 0.135887843515046,
    "y3": 0.296860519676855
  },
  {
    "x": "1988-12-26",
    "y1": 1.56987366772467,
    "y2": 0.224548179607624,
    "y3": 0.290269857460856
  },
  {
    "x": "1989-01-02",
    "y1": 1.57852604938003,
    "y2": 0.224548179607624,
    "y3": 0.275229756772309
  },
  {
    "x": "1989-01-09",
    "y1": 1.58476466081837,
    "y2": 0.153606068370394,
    "y3": 0.265241398361603
  },
  {
    "x": "1989-01-16",
    "y1": 1.59664791070467,
    "y2": 0.211900361711603,
    "y3": 0.245252601858599
  },
  {
    "x": "1989-01-23",
    "y1": 1.61273161659345,
    "y2": 0.211900361711603,
    "y3": 0.231261512338534
  },
  {
    "x": "1989-01-30",
    "y1": 1.63383712889618,
    "y2": 0.234491514412399,
    "y3": 0.227871159160246
  },
  {
    "x": "1989-02-06",
    "y1": 1.62399460906332,
    "y2": 0.353684147034901,
    "y3": 0.232059924009582
  },
  {
    "x": "1989-02-13",
    "y1": 1.63592308417105,
    "y2": 0.411050679561264,
    "y3": 0.236875856260923
  },
  {
    "x": "1989-02-20",
    "y1": 1.61824132584298,
    "y2": 0.385995108703037,
    "y3": 0.238628106489291
  },
  {
    "x": "1989-02-27",
    "y1": 1.62824132584298,
    "y2": 0.299995351562927,
    "y3": 0.236215992003807
  },
  {
    "x": "1989-03-06",
    "y1": 1.6329442810323,
    "y2": 0.269160273494545,
    "y3": 0.232370711095047
  },
  {
    "x": "1989-03-13",
    "y1": 1.6238287803053,
    "y2": 0.173899389285135,
    "y3": 0.230794531992591
  },
  {
    "x": "1989-03-20",
    "y1": 1.62059651210269,
    "y2": 0.179119045104032,
    "y3": 0.22504631887645
  },
  {
    "x": "1989-03-27",
    "y1": 1.63506400623801,
    "y2": 0.133716093912205,
    "y3": 0.220526852051677
  },
  {
    "x": "1989-04-03",
    "y1": 1.64489926534777,
    "y2": 0.168614620986054,
    "y3": 0.21783876160074
  },
  {
    "x": "1989-04-10",
    "y1": 1.6619433359393,
    "y2": 0.164383339662044,
    "y3": 0.214939107083604
  },
  {
    "x": "1989-04-17",
    "y1": 1.67654705968283,
    "y2": 0.277273880053781,
    "y3": 0.222116996390682
  },
  {
    "x": "1989-04-24",
    "y1": 1.6855135967758,
    "y2": 0.261212006530815,
    "y3": 0.228491792021613
  },
  {
    "x": "1989-05-01",
    "y1": 1.69276337708278,
    "y2": 0.337012307590609,
    "y3": 0.240599937620882
  },
  {
    "x": "1989-05-08",
    "y1": 1.70228270717272,
    "y2": 0.494327067370394,
    "y3": 0.258521898813649
  },
  {
    "x": "1989-05-15",
    "y1": 1.71907207818352,
    "y2": 0.521432027001305,
    "y3": 0.273366091183333
  },
  {
    "x": "1989-05-22",
    "y1": 1.7260840801304,
    "y2": 0.42741160855516,
    "y3": 0.28350926263071
  },
  {
    "x": "1989-05-29",
    "y1": 1.740459627572,
    "y2": 0.402356037696933,
    "y3": 0.295946761097037
  },
  {
    "x": "1989-06-05",
    "y1": 1.74510977388541,
    "y2": 0.382295145140255,
    "y3": 0.30446650026847
  },
  {
    "x": "1989-06-12",
    "y1": 1.7307831267064,
    "y2": 0.388994891833524,
    "y3": 0.313321226774566
  },
  {
    "x": "1989-06-19",
    "y1": 1.73346644883676,
    "y2": 0.378698427924258,
    "y3": 0.320531572450159
  },
  {
    "x": "1989-06-26",
    "y1": 1.70425144820824,
    "y2": 0.370454502556672,
    "y3": 0.321370090226247
  },
  {
    "x": "1989-07-03",
    "y1": 1.72056205308446,
    "y2": 0.363853954439839,
    "y3": 0.319010253970176
  },
  {
    "x": "1989-07-10",
    "y1": 1.73525463918229,
    "y2": 0.340299550404641,
    "y3": 0.316725476055256
  },
  {
    "x": "1989-07-17",
    "y1": 1.73614569265059,
    "y2": 0.26567756872417,
    "y3": 0.315009586913319
  },
  {
    "x": "1989-07-24",
    "y1": 1.74393558825507,
    "y2": 0.327439515371857,
    "y3": 0.317923549007184
  },
  {
    "x": "1989-07-31",
    "y1": 1.75409461260915,
    "y2": 0.343076772675239,
    "y3": 0.326382418176689
  },
  {
    "x": "1989-08-07",
    "y1": 1.76524460423917,
    "y2": 0.568607578279312,
    "y3": 0.345856844835453
  },
  {
    "x": "1989-08-14",
    "y1": 1.76416352315808,
    "y2": 0.466371663475867,
    "y3": 0.362489623313636
  },
  {
    "x": "1989-08-21",
    "y1": 1.77455310712555,
    "y2": 0.61167629177169,
    "y3": 0.384642706852918
  },
  {
    "x": "1989-08-28",
    "y1": 1.78419321020541,
    "y2": 0.580382488205475,
    "y3": 0.40544266428009
  },
  {
    "x": "1989-09-04",
    "y1": 1.78419321020541,
    "y2": 0.432878052874475,
    "y3": 0.413222872921125
  },
  {
    "x": "1989-09-11",
    "y1": 1.77634262292494,
    "y2": 0.463275402742442,
    "y3": 0.423326042731706
  },
  {
    "x": "1989-09-18",
    "y1": 1.77741191290242,
    "y2": 0.452978938833176,
    "y3": 0.429124374293834
  },
  {
    "x": "1989-09-25",
    "y1": 1.78766610587483,
    "y2": 0.44473501346559,
    "y3": 0.426644771598594
  },
  {
    "x": "1989-10-02",
    "y1": 1.81029248004512,
    "y2": 0.34947412925618,
    "y3": 0.418046876711338
  },
  {
    "x": "1989-10-09",
    "y1": 1.77658690083746,
    "y2": 0.312615986023576,
    "y3": 0.412307095584759
  },
  {
    "x": "1989-10-16",
    "y1": 1.78386279320399,
    "y2": 0.401276322116154,
    "y3": 0.41225310980572
  },
  {
    "x": "1989-10-23",
    "y1": 1.74583427408386,
    "y2": 0.346065891669754,
    "y3": 0.410441647132195
  },
  {
    "x": "1989-10-30",
    "y1": 1.74627599716783,
    "y2": 0.294083307426838,
    "y3": 0.40569606791186
  },
  {
    "x": "1989-11-06",
    "y1": 1.75334004177496,
    "y2": 0.348237641272595,
    "y3": 0.404173028579277
  },
  {
    "x": "1989-11-13",
    "y1": 1.75443605226734,
    "y2": 0.259577305180018,
    "y3": 0.398629168710444
  },
  {
    "x": "1989-11-20",
    "y1": 1.75421707678925,
    "y2": 0.259577305180018,
    "y3": 0.393415336247453
  },
  {
    "x": "1989-11-27",
    "y1": 1.75531212714693,
    "y2": 0.259577305180018,
    "y3": 0.389379223986222
  },
  {
    "x": "1989-12-04",
    "y1": 1.75334320593829,
    "y2": 0.348237641272595,
    "y3": 0.393507227613643
  },
  {
    "x": "1989-12-11",
    "y1": 1.72616209221129,
    "y2": 0.294083307426838,
    "y3": 0.391839417216392
  },
  {
    "x": "1989-12-18",
    "y1": 1.72796474730942,
    "y2": 0.294083307426838,
    "y3": 0.389389743953972
  },
  {
    "x": "1989-12-25",
    "y1": 1.75090667612055,
    "y2": 0.294083307426838,
    "y3": 0.375663530411349
  },
  {
    "x": "1990-01-01",
    "y1": 1.75838254354649,
    "y2": 0.205422971334261,
    "y3": 0.362616095804268
  },
  {
    "x": "1990-01-08",
    "y1": 1.71800716269286,
    "y2": 0.15611132651505,
    "y3": 0.339837847541436
  },
  {
    "x": "1990-01-15",
    "y1": 1.72073625447393,
    "y2": 0.244771662607627,
    "y3": 0.323057306261544
  },
  {
    "x": "1990-01-22",
    "y1": 1.67628171517966,
    "y2": 0.183509731697804,
    "y3": 0.310588890202711
  },
  {
    "x": "1990-01-29",
    "y1": 1.678418018147,
    "y2": 0.183509731697804,
    "y3": 0.296600606650479
  },
  {
    "x": "1990-02-05",
    "y1": 1.69405036157455,
    "y2": 0.140252346797054,
    "y3": 0.280964277048673
  },
  {
    "x": "1990-02-12",
    "y1": 1.69451680796617,
    "y2": 0.0948493956052264,
    "y3": 0.263469996155654
  },
  {
    "x": "1990-02-19",
    "y1": 1.67237228582165,
    "y2": 0.0820658508147611,
    "y3": 0.250099582233583
  },
  {
    "x": "1990-02-26",
    "y1": 1.69978587342594,
    "y2": 0.0820658508147611,
    "y3": 0.238572075473143
  },
  {
    "x": "1990-03-05",
    "y1": 1.71324292166948,
    "y2": 0.1174518329265,
    "y3": 0.22438085101366
  },
  {
    "x": "1990-03-12",
    "y1": 1.72560561527062,
    "y2": 0.1174518329265,
    "y3": 0.212950148076497
  },
  {
    "x": "1990-03-19",
    "y1": 1.7145246015239,
    "y2": 0.0997336080711531,
    "y3": 0.203232663108713
  },
  {
    "x": "1990-03-26",
    "y1": 1.71040846193274,
    "y2": 0.207223353964106,
    "y3": 0.196181948743289
  },
  {
    "x": "1990-04-02",
    "y1": 1.69984587616118,
    "y2": 0.188393944163731,
    "y3": 0.192622780692474
  },
  {
    "x": "1990-04-09",
    "y1": 1.71237777213002,
    "y2": 0.188393944163731,
    "y3": 0.18906361264166
  },
  {
    "x": "1990-04-16",
    "y1": 1.68831176183028,
    "y2": 0.0820658508147611,
    "y3": 0.180188039923397
  },
  {
    "x": "1990-04-23",
    "y1": 1.66999333060299,
    "y2": 0.127468802006589,
    "y3": 0.169149597960097
  },
  {
    "x": "1990-04-30",
    "y1": 1.69535219687934,
    "y2": 0.170726186907339,
    "y3": 0.162981741934122
  },
  {
    "x": "1990-05-07",
    "y1": 1.7175173855511,
    "y2": 0.0820658508147611,
    "y3": 0.152380869103518
  },
  {
    "x": "1990-05-14",
    "y1": 1.74079969905794,
    "y2": 0.119238006492144,
    "y3": 0.143638604056783
  },
  {
    "x": "1990-05-21",
    "y1": 1.75284525908717,
    "y2": 0.119238006492144,
    "y3": 0.139329355814677
  },
  {
    "x": "1990-05-28",
    "y1": 1.77135968198882,
    "y2": 0.112637458375312,
    "y3": 0.13715566240769
  },
  {
    "x": "1990-06-04",
    "y1": 1.76876281509598,
    "y2": 0.196013026168808,
    "y3": 0.13471773058575
  },
  {
    "x": "1990-06-11",
    "y1": 1.78329961764698,
    "y2": 0.339343802139208,
    "y3": 0.14250943410782
  },
  {
    "x": "1990-06-18",
    "y1": 1.76554936486211,
    "y2": 0.196013026168808,
    "y3": 0.14313459883137
  },
  {
    "x": "1990-06-25",
    "y1": 1.77208104367711,
    "y2": 0.196013026168808,
    "y3": 0.145922632799958
  },
  {
    "x": "1990-07-02",
    "y1": 1.76818749437904,
    "y2": 0.127468802006589,
    "y3": 0.147553603120026
  },
  {
    "x": "1990-07-09",
    "y1": 1.78534274714014,
    "y2": 0.296086417238457,
    "y3": 0.158254631441211
  },
  {
    "x": "1990-07-16",
    "y1": 1.75737518464181,
    "y2": 0.112637458375312,
    "y3": 0.159783211819238
  },
  {
    "x": "1990-07-23",
    "y1": 1.72948152764653,
    "y2": 0.152755641268058,
    "y3": 0.161548402236316
  },
  {
    "x": "1990-07-30",
    "y1": 1.67277116669447,
    "y2": 0.170726186907339,
    "y3": 0.164212119935358
  },
  {
    "x": "1990-08-06",
    "y1": 1.6500166756765,
    "y2": 0.161498966607454,
    "y3": 0.167300387862173
  },
  {
    "x": "1990-08-13",
    "y1": 1.61447745999023,
    "y2": 0.153329031966931,
    "y3": 0.164605671762314
  },
  {
    "x": "1990-08-20",
    "y1": 1.54789547217058,
    "y2": 0.0994026735944394,
    "y3": 0.16015610823385
  },
  {
    "x": "1990-08-27",
    "y1": 1.5857392643732,
    "y2": 0.107533669640957,
    "y3": 0.156113094507711
  },
  {
    "x": "1990-09-03",
    "y1": 1.58364058051977,
    "y2": 0.0621307184491293,
    "y3": 0.155116337889429
  },
  {
    "x": "1990-09-10",
    "y1": 1.56786770960424,
    "y2": 0.0621307184491293,
    "y3": 0.151849433711556
  },
  {
    "x": "1990-09-17",
    "y1": 1.53554931670688,
    "y2": 0.0621307184491293,
    "y3": 0.146419660288646
  },
  {
    "x": "1990-09-24",
    "y1": 1.48641879395582,
    "y2": 0.066623752717398,
    "y3": 0.145647555383778
  },
  {
    "x": "1990-10-01",
    "y1": 1.49483677333604,
    "y2": 0.137565863954628,
    "y3": 0.146563948256902
  },
  {
    "x": "1990-10-08",
    "y1": 1.4378419888201,
    "y2": 0.133625071951553,
    "y3": 0.147283301529872
  },
  {
    "x": "1990-10-15",
    "y1": 1.46775648091529,
    "y2": 0.13973761355747,
    "y3": 0.14863830928898
  },
  {
    "x": "1990-10-22",
    "y1": 1.4588649573401,
    "y2": 0.066503016873616,
    "y3": 0.142162808824221
  },
  {
    "x": "1990-10-29",
    "y1": 1.46514488001308,
    "y2": 0.066503016873616,
    "y3": 0.128520769560941
  },
  {
    "x": "1990-11-05",
    "y1": 1.48148960512452,
    "y2": 0.066503016873616,
    "y3": 0.122045269096181
  },
  {
    "x": "1990-11-12",
    "y1": 1.50751297909085,
    "y2": 0.102887969010058,
    "y3": 0.117389016238244
  },
  {
    "x": "1990-11-19",
    "y1": 1.50209834834268,
    "y2": 0.120606193865405,
    "y3": 0.117045885831185
  },
  {
    "x": "1990-11-26",
    "y1": 1.5310381939115,
    "y2": 0.110309729956139,
    "y3": 0.107757051467069
  },
  {
    "x": "1990-12-03",
    "y1": 1.56556894770076,
    "y2": 0.230648096430341,
    "y3": 0.11365758336982
  },
  {
    "x": "1990-12-10",
    "y1": 1.55830108173298,
    "y2": 0.110309729956139,
    "y3": 0.111535287804224
  },
  {
    "x": "1990-12-17",
    "y1": 1.57131631619454,
    "y2": 0.270296404101357,
    "y3": 0.116513798663925
  },
  {
    "x": "1990-12-24",
    "y1": 1.56489234976714,
    "y2": 0.1742987220059,
    "y3": 0.117153786433848
  },
  {
    "x": "1990-12-31",
    "y1": 1.55411648805255,
    "y2": 0.225179940686452,
    "y3": 0.120746331869824
  },
  {
    "x": "1991-01-07",
    "y1": 1.53941053970139,
    "y2": 0.166407367708951,
    "y3": 0.124096566575549
  },
  {
    "x": "1991-01-14",
    "y1": 1.58142273627373,
    "y2": 0.266502757407344,
    "y3": 0.132045020963869
  },
  {
    "x": "1991-01-21",
    "y1": 1.6273112980588,
    "y2": 0.230327026515401,
    "y3": 0.140454836367182
  },
  {
    "x": "1991-01-28",
    "y1": 1.68665703769485,
    "y2": 0.243110571305866,
    "y3": 0.149503829010019
  },
  {
    "x": "1991-02-04",
    "y1": 1.7323835759466,
    "y2": 0.281977269612845,
    "y3": 0.160496156568205
  },
  {
    "x": "1991-02-11",
    "y1": 1.75962722234455,
    "y2": 0.25068346604663,
    "y3": 0.169699142234666
  },
  {
    "x": "1991-02-18",
    "y1": 1.76029579329353,
    "y2": 0.314288231280981,
    "y3": 0.178535260600984
  },
  {
    "x": "1991-02-25",
    "y1": 1.77744504097066,
    "y2": 0.294227338724303,
    "y3": 0.186565373939621
  },
  {
    "x": "1991-03-04",
    "y1": 1.81775590729966,
    "y2": 0.393032838308267,
    "y3": 0.199230135177161
  },
  {
    "x": "1991-03-11",
    "y1": 1.79919183355132,
    "y2": 0.222048045267802,
    "y3": 0.207007386596871
  },
  {
    "x": "1991-03-18",
    "y1": 1.7946023836184,
    "y2": 0.211751581358536,
    "y3": 0.214269814821117
  },
  {
    "x": "1991-03-25",
    "y1": 1.83370610899846,
    "y2": 0.341072802542097,
    "y3": 0.227998304104541
  },
  {
    "x": "1991-04-01",
    "y1": 1.86167629579793,
    "y2": 0.399087098226728,
    "y3": 0.242808260565374
  },
  {
    "x": "1991-04-08",
    "y1": 1.87343527938329,
    "y2": 0.322390343468686,
    "y3": 0.252897468045538
  },
  {
    "x": "1991-04-15",
    "y1": 1.8725780713773,
    "y2": 0.297334772610459,
    "y3": 0.262248720178254
  },
  {
    "x": "1991-04-22",
    "y1": 1.8595091997696,
    "y2": 0.494327067370394,
    "y3": 0.275432668725257
  },
  {
    "x": "1991-04-29",
    "y1": 1.85437413493517,
    "y2": 0.547365748213952,
    "y3": 0.297285469638148
  },
  {
    "x": "1991-05-06",
    "y1": 1.85705653141525,
    "y2": 0.568607578279312,
    "y3": 0.312201028347045
  },
  {
    "x": "1991-05-13",
    "y1": 1.83265539603916,
    "y2": 0.494056389812347,
    "y3": 0.328188911737368
  },
  {
    "x": "1991-05-20",
    "y1": 1.8561088183467,
    "y2": 0.608282032506824,
    "y3": 0.347344016328386
  },
  {
    "x": "1991-05-27",
    "y1": 1.88338868429657,
    "y2": 0.531585277748782,
    "y3": 0.365602911830378
  },
  {
    "x": "1991-06-03",
    "y1": 1.86843150695224,
    "y2": 0.476758853457669,
    "y3": 0.376115716632894
  },
  {
    "x": "1991-06-10",
    "y1": 1.86147118047647,
    "y2": 0.504187039189225,
    "y3": 0.389808717266585
  },
  {
    "x": "1991-06-17",
    "y1": 1.84278695427987,
    "y2": 0.559067276903488,
    "y3": 0.405606552546467
  },
  {
    "x": "1991-06-24",
    "y1": 1.8224090494031,
    "y2": 0.657306430095002,
    "y3": 0.424373010570574
  },
  {
    "x": "1991-07-01",
    "y1": 1.81847976384669,
    "y2": 0.626012626528788,
    "y3": 0.443139468594682
  },
  {
    "x": "1991-07-08",
    "y1": 1.85784270898458,
    "y2": 0.641735693673347,
    "y3": 0.459511841714301
  },
  {
    "x": "1991-07-15",
    "y1": 1.86766592430765,
    "y2": 0.576266165503054,
    "y3": 0.473613783053238
  },
  {
    "x": "1991-07-22",
    "y1": 1.85789809098276,
    "y2": 0.551210594644827,
    "y3": 0.481522670870066
  },
  {
    "x": "1991-07-29",
    "y1": 1.88424327948264,
    "y2": 0.565325426692228,
    "y3": 0.498686539941287
  },
  {
    "x": "1991-08-05",
    "y1": 1.88946404413302,
    "y2": 0.53280605342053,
    "y3": 0.514739263544387
  },
  {
    "x": "1991-08-12",
    "y1": 1.89764797355505,
    "y2": 0.590888129624976,
    "y3": 0.527230029898531
  },
  {
    "x": "1991-08-19",
    "y1": 1.91440998371475,
    "y2": 0.543825279082558,
    "y3": 0.534466938941322
  },
  {
    "x": "1991-08-26",
    "y1": 1.92327651566661,
    "y2": 0.483687404255546,
    "y3": 0.542531791980665
  },
  {
    "x": "1991-09-02",
    "y1": 1.90665044970224,
    "y2": 0.517317267541357,
    "y3": 0.55353091672721
  },
  {
    "x": "1991-09-09",
    "y1": 1.90620556157661,
    "y2": 0.513929466860289,
    "y3": 0.554511036701705
  },
  {
    "x": "1991-09-16",
    "y1": 1.92648769279741,
    "y2": 0.561998633984464,
    "y3": 0.555242680990231
  },
  {
    "x": "1991-09-23",
    "y1": 1.92134718944927,
    "y2": 0.513456480784632,
    "y3": 0.552485126115497
  },
  {
    "x": "1991-09-30",
    "y1": 1.91356813932987,
    "y2": 0.463822248268794,
    "y3": 0.550973419038319
  },
  {
    "x": "1991-10-07",
    "y1": 1.91097391074079,
    "y2": 0.460434447587727,
    "y3": 0.543581039792364
  },
  {
    "x": "1991-10-14",
    "y1": 1.94921692603397,
    "y2": 0.549094783680305,
    "y3": 0.54445651508894
  },
  {
    "x": "1991-10-21",
    "y1": 1.92366484047558,
    "y2": 0.414617905614357,
    "y3": 0.541349467696775
  },
  {
    "x": "1991-10-28",
    "y1": 1.95375260473596,
    "y2": 0.392473004833819,
    "y3": 0.535763765979004
  },
  {
    "x": "1991-11-04",
    "y1": 1.9669706264964,
    "y2": 0.374754779978472,
    "y3": 0.526548141132754
  },
  {
    "x": "1991-11-11",
    "y1": 1.93633634219673,
    "y2": 0.310444236420735,
    "y3": 0.50920503144904
  },
  {
    "x": "1991-11-18",
    "y1": 1.92724534433409,
    "y2": 0.373170851300665,
    "y3": 0.496562942687634
  },
  {
    "x": "1991-11-25",
    "y1": 1.92238268154537,
    "y2": 0.346065891669754,
    "y3": 0.481779452587454
  },
  {
    "x": "1991-12-02",
    "y1": 1.94605124959473,
    "y2": 0.346065891669754,
    "y3": 0.470269438895789
  },
  {
    "x": "1991-12-09",
    "y1": 1.95462860690556,
    "y2": 0.257405555577176,
    "y3": 0.455579186942407
  },
  {
    "x": "1991-12-16",
    "y1": 1.94512589953555,
    "y2": 0.257405555577176,
    "y3": 0.440183193386654
  },
  {
    "x": "1991-12-23",
    "y1": 2.00102781767262,
    "y2": 0.297013809679091,
    "y3": 0.428393581199582
  },
  {
    "x": "1991-12-30",
    "y1": 2.04864939302931,
    "y2": 0.322947530891739,
    "y3": 0.41499655126292
  },
  {
    "x": "1992-01-06",
    "y1": 2.08754247805999,
    "y2": 0.374615066649864,
    "y3": 0.406536040641286
  },
  {
    "x": "1992-01-13",
    "y1": 2.10565188711934,
    "y2": 0.374615066649864,
    "y3": 0.401082423761002
  },
  {
    "x": "1992-01-20",
    "y1": 2.10219016103707,
    "y2": 0.46432391355334,
    "y3": 0.398432756061601
  },
  {
    "x": "1992-01-27",
    "y1": 2.09503454415237,
    "y2": 0.53526602479057,
    "y3": 0.399499583958115
  },
  {
    "x": "1992-02-03",
    "y1": 2.11880067129023,
    "y2": 0.53526602479057,
    "y3": 0.39816295349842
  },
  {
    "x": "1992-02-10",
    "y1": 2.12113153268136,
    "y2": 0.621768563974688,
    "y3": 0.403578557657923
  },
  {
    "x": "1992-02-17",
    "y1": 2.1106354957996,
    "y2": 0.475946766366853,
    "y3": 0.404184783562826
  },
  {
    "x": "1992-02-24",
    "y1": 2.1165425552726,
    "y2": 0.401477628564839,
    "y3": 0.401236942611682
  },
  {
    "x": "1992-03-02",
    "y1": 2.08888542974754,
    "y2": 0.394877080448007,
    "y3": 0.393526057450067
  },
  {
    "x": "1992-03-09",
    "y1": 2.09322016934855,
    "y2": 0.432849697049676,
    "y3": 0.394437647021833
  },
  {
    "x": "1992-03-16",
    "y1": 2.10236962171731,
    "y2": 0.463086731334069,
    "y3": 0.397968333346845
  },
  {
    "x": "1992-03-23",
    "y1": 2.07095736204787,
    "y2": 0.407387316232976,
    "y3": 0.39959996015957
  },
  {
    "x": "1992-03-30",
    "y1": 2.04671277647414,
    "y2": 0.422518152181514,
    "y3": 0.405203655947609
  },
  {
    "x": "1992-04-06",
    "y1": 2.03693324826996,
    "y2": 0.399104572513312,
    "y3": 0.406500342008242
  },
  {
    "x": "1992-04-13",
    "y1": 2.04989026499383,
    "y2": 0.399104572513312,
    "y3": 0.40915227605042
  },
  {
    "x": "1992-04-20",
    "y1": 2.0179205737277,
    "y2": 0.284510515208087,
    "y3": 0.406074507227336
  },
  {
    "x": "1992-04-27",
    "y1": 2.02708463640249,
    "y2": 0.257405555577176,
    "y3": 0.406074507227336
  },
  {
    "x": "1992-05-04",
    "y1": 2.04026482619064,
    "y2": 0.257405555577176,
    "y3": 0.406074507227336
  },
  {
    "x": "1992-05-11",
    "y1": 2.02092240454875,
    "y2": 0.257405555577176,
    "y3": 0.404094094522241
  },
  {
    "x": "1992-05-18",
    "y1": 2.03114122179721,
    "y2": 0.294083307426838,
    "y3": 0.402650883348996
  },
  {
    "x": "1992-05-25",
    "y1": 2.03977470425631,
    "y2": 0.205422971334261,
    "y3": 0.394191278583215
  },
  {
    "x": "1992-06-01",
    "y1": 2.03997971547718,
    "y2": 0.35095010413568,
    "y3": 0.393008030457506
  },
  {
    "x": "1992-06-08",
    "y1": 2.0128031557799,
    "y2": 0.223141196189608,
    "y3": 0.380948894589319
  },
  {
    "x": "1992-06-15",
    "y1": 1.98590329835816,
    "y2": 0.267362815308422,
    "y3": 0.367553734115212
  },
  {
    "x": "1992-06-22",
    "y1": 1.97442732359909,
    "y2": 0.244771662607627,
    "y3": 0.353029016006065
  },
  {
    "x": "1992-06-29",
    "y1": 2.00273841437406,
    "y2": 0.298967519892765,
    "y3": 0.336888963801969
  },
  {
    "x": "1992-07-06",
    "y1": 2.01063761096567,
    "y2": 0.210307183800187,
    "y3": 0.323606984673635
  },
  {
    "x": "1992-07-13",
    "y1": 2.01542808612727,
    "y2": 0.178702479215845,
    "y3": 0.312468227206186
  },
  {
    "x": "1992-07-20",
    "y1": 2.0068218426799,
    "y2": 0.213694984481255,
    "y3": 0.303409122407848
  },
  {
    "x": "1992-07-27",
    "y1": 2.03373090039185,
    "y2": 0.302355320573833,
    "y3": 0.296884403584056
  },
  {
    "x": "1992-08-03",
    "y1": 2.02152418474896,
    "y2": 0.244771662607627,
    "y3": 0.285968650147734
  },
  {
    "x": "1992-08-10",
    "y1": 2.02054813711741,
    "y2": 0.306586601897842,
    "y3": 0.280928614430977
  },
  {
    "x": "1992-08-17",
    "y1": 2.00400886395735,
    "y2": 0.267362815308422,
    "y3": 0.273170847587323
  },
  {
    "x": "1992-08-24",
    "y1": 2.00376047892026,
    "y2": 0.311871370196924,
    "y3": 0.268809187471503
  },
  {
    "x": "1992-08-31",
    "y1": 2.02129189514145,
    "y2": 0.267362815308422,
    "y3": 0.262222099611259
  },
  {
    "x": "1992-09-07",
    "y1": 2.03798066342318,
    "y2": 0.229811582221178,
    "y3": 0.259487152961913
  },
  {
    "x": "1992-09-14",
    "y1": 2.04846073280315,
    "y2": 0.229811582221178,
    "y3": 0.258107454294113
  },
  {
    "x": "1992-09-21",
    "y1": 2.0282271929319,
    "y2": 0.133716093912205,
    "y3": 0.251922981210865
  },
  {
    "x": "1992-09-28",
    "y1": 2.01857714579673,
    "y2": 0.183509731697804,
    "y3": 0.248228190016896
  },
  {
    "x": "1992-10-05",
    "y1": 2.01663535592902,
    "y2": 0.170726186907339,
    "y3": 0.242060333990921
  },
  {
    "x": "1992-10-12",
    "y1": 2.0378264892923,
    "y2": 0.170726186907339,
    "y3": 0.240325494769575
  },
  {
    "x": "1992-10-19",
    "y1": 2.06304061677167,
    "y2": 0.0820658508147611,
    "y3": 0.226881282103529
  },
  {
    "x": "1992-10-26",
    "y1": 2.07621656734597,
    "y2": 0.103121408752221,
    "y3": 0.22088029273166
  },
  {
    "x": "1992-11-02",
    "y1": 2.09546739726658,
    "y2": 0.103121408752221,
    "y3": 0.21266822240385
  },
  {
    "x": "1992-11-09",
    "y1": 2.12844292591155,
    "y2": 0.17582292965447,
    "y3": 0.209220785756192
  },
  {
    "x": "1992-11-16",
    "y1": 2.13698081697611,
    "y2": 0.17582292965447,
    "y3": 0.203063556244277
  },
  {
    "x": "1992-11-23",
    "y1": 2.14770290678347,
    "y2": 0.2467650408917,
    "y3": 0.204886449098853
  },
  {
    "x": "1992-11-30",
    "y1": 2.1663482832075,
    "y2": 0.339213724027943,
    "y3": 0.212912011339458
  },
  {
    "x": "1992-12-07",
    "y1": 2.15756654534022,
    "y2": 0.339213724027943,
    "y3": 0.219187948316792
  },
  {
    "x": "1992-12-14",
    "y1": 2.16595337677145,
    "y2": 0.339213724027943,
    "y3": 0.221030868489498
  },
  {
    "x": "1992-12-21",
    "y1": 2.1728943966084,
    "y2": 0.399087098226728,
    "y3": 0.228746640270453
  },
  {
    "x": "1992-12-28",
    "y1": 2.18951902453392,
    "y2": 0.451069682469644,
    "y3": 0.235970794299043
  },
  {
    "x": "1993-01-04",
    "y1": 2.18990311458627,
    "y2": 0.374372927711601,
    "y3": 0.241321299919202
  },
  {
    "x": "1993-01-11",
    "y1": 2.21934745503374,
    "y2": 0.432771690908727,
    "y3": 0.247366315954792
  },
  {
    "x": "1993-01-18",
    "y1": 2.22577359045921,
    "y2": 0.479947242186734,
    "y3": 0.257995537298707
  },
  {
    "x": "1993-01-25",
    "y1": 2.21823403543658,
    "y2": 0.420074262552281,
    "y3": 0.267508671315263
  },
  {
    "x": "1993-02-01",
    "y1": 2.22489738011638,
    "y2": 0.470955481232833,
    "y3": 0.279565866265845
  },
  {
    "x": "1993-02-08",
    "y1": 2.21000394131314,
    "y2": 0.454893607709866,
    "y3": 0.295624741955728
  },
  {
    "x": "1993-02-15",
    "y1": 2.17100548570929,
    "y2": 0.370454502556672,
    "y3": 0.304971980498672
  },
  {
    "x": "1993-02-22",
    "y1": 2.1817950071718,
    "y2": 0.363853954439839,
    "y3": 0.314628368875297
  },
  {
    "x": "1993-03-01",
    "y1": 2.19759770448577,
    "y2": 0.372842466563685,
    "y3": 0.324734182858114
  },
  {
    "x": "1993-03-08",
    "y1": 2.21434342892544,
    "y2": 0.448653438620519,
    "y3": 0.343063562248402
  },
  {
    "x": "1993-03-15",
    "y1": 2.19982214053905,
    "y2": 0.423597867762293,
    "y3": 0.359087385198906
  },
  {
    "x": "1993-03-22",
    "y1": 2.19809377059761,
    "y2": 0.403536975205615,
    "y3": 0.374108163521575
  },
  {
    "x": "1993-03-29",
    "y1": 2.18094143497786,
    "y2": 0.411607866984316,
    "y3": 0.385897410388068
  },
  {
    "x": "1993-04-05",
    "y1": 2.17568658893115,
    "y2": 0.381442864447659,
    "y3": 0.396178407127727
  },
  {
    "x": "1993-04-12",
    "y1": 2.17636194828086,
    "y2": 0.378055063766592,
    "y3": 0.402742908271472
  },
  {
    "x": "1993-04-19",
    "y1": 2.16380899860543,
    "y2": 0.289394727674014,
    "y3": 0.400251958453775
  },
  {
    "x": "1993-04-26",
    "y1": 2.16838063313164,
    "y2": 0.302808506769003,
    "y3": 0.398431697590828
  },
  {
    "x": "1993-05-03",
    "y1": 2.19864887426213,
    "y2": 0.318716249567729,
    "y3": 0.397406823867818
  },
  {
    "x": "1993-05-10",
    "y1": 2.19120873675031,
    "y2": 0.292782528355081,
    "y3": 0.392091595374235
  },
  {
    "x": "1993-05-17",
    "y1": 2.21770308605546,
    "y2": 0.421255200060962,
    "y3": 0.390600871253801
  },
  {
    "x": "1993-05-24",
    "y1": 2.22669075902642,
    "y2": 0.387475101682648,
    "y3": 0.391255979952353
  },
  {
    "x": "1993-05-31",
    "y1": 2.22880341716648,
    "y2": 0.392333291505212,
    "y3": 0.389234059982178
  },
  {
    "x": "1993-06-07",
    "y1": 2.21623948331722,
    "y2": 0.401276322116154,
    "y3": 0.385300513978649
  },
  {
    "x": "1993-06-14",
    "y1": 2.21104613723136,
    "y2": 0.375342600903507,
    "y3": 0.38306393089621
  },
  {
    "x": "1993-06-21",
    "y1": 2.21861580979018,
    "y2": 0.401276322116154,
    "y3": 0.379579972940376
  },
  {
    "x": "1993-06-28",
    "y1": 2.2325476655634,
    "y2": 0.448939926397442,
    "y3": 0.379282288874755
  },
  {
    "x": "1993-07-05",
    "y1": 2.23442137185095,
    "y2": 0.387475101682648,
    "y3": 0.380133318831054
  },
  {
    "x": "1993-07-12",
    "y1": 2.22580713131756,
    "y2": 0.312615986023576,
    "y3": 0.377571420410241
  },
  {
    "x": "1993-07-19",
    "y1": 2.22653599785159,
    "y2": 0.375342600903507,
    "y3": 0.377696427127232
  },
  {
    "x": "1993-07-26",
    "y1": 2.23290527414952,
    "y2": 0.375342600903507,
    "y3": 0.374030885241381
  },
  {
    "x": "1993-08-02",
    "y1": 2.25189208364439,
    "y2": 0.373170851300665,
    "y3": 0.3715095344183
  },
  {
    "x": "1993-08-09",
    "y1": 2.2521427418879,
    "y2": 0.257405555577176,
    "y3": 0.364202963436878
  },
  {
    "x": "1993-08-16",
    "y1": 2.26982437811205,
    "y2": 0.257405555577176,
    "y3": 0.356492847866521
  },
  {
    "x": "1993-08-23",
    "y1": 2.27407903672275,
    "y2": 0.257405555577176,
    "y3": 0.350290982422996
  },
  {
    "x": "1993-08-30",
    "y1": 2.29538492647766,
    "y2": 0.346065891669754,
    "y3": 0.348691523818154
  },
  {
    "x": "1993-09-06",
    "y1": 2.28818210904719,
    "y2": 0.275123780432523,
    "y3": 0.34797797645608
  },
  {
    "x": "1993-09-13",
    "y1": 2.28253928250878,
    "y2": 0.294083307426838,
    "y3": 0.347541716488972
  },
  {
    "x": "1993-09-20",
    "y1": 2.30218506401461,
    "y2": 0.348237641272595,
    "y3": 0.349017786074215
  },
  {
    "x": "1993-09-27",
    "y1": 2.31355451445801,
    "y2": 0.259577305180018,
    "y3": 0.347357524915462
  },
  {
    "x": "1993-10-04",
    "y1": 2.31491719554905,
    "y2": 0.259577305180018,
    "y3": 0.339273630171415
  },
  {
    "x": "1993-10-11",
    "y1": 2.34520748927679,
    "y2": 0.259577305180018,
    "y3": 0.332878740346283
  },
  {
    "x": "1993-10-18",
    "y1": 2.32648813930564,
    "y2": 0.205422971334261,
    "y3": 0.323533224337736
  },
  {
    "x": "1993-10-25",
    "y1": 2.33500397658914,
    "y2": 0.294083307426838,
    "y3": 0.31817357360327
  },
  {
    "x": "1993-11-01",
    "y1": 2.31412516935233,
    "y2": 0.294083307426838,
    "y3": 0.314110608929436
  },
  {
    "x": "1993-11-08",
    "y1": 2.33552783163998,
    "y2": 0.358569186140758,
    "y3": 0.311975252130667
  },
  {
    "x": "1993-11-15",
    "y1": 2.29990702182536,
    "y2": 0.315311801240007,
    "y3": 0.305293845872795
  },
  {
    "x": "1993-11-22",
    "y1": 2.30431119124542,
    "y2": 0.315311801240007,
    "y3": 0.301685680850663
  },
  {
    "x": "1993-11-29",
    "y1": 2.32729524902778,
    "y2": 0.315311801240007,
    "y3": 0.301820471611484
  },
  {
    "x": "1993-12-06",
    "y1": 2.31242904392524,
    "y2": 0.205422971334261,
    "y3": 0.293324490133022
  },
  {
    "x": "1993-12-13",
    "y1": 2.31044412163246,
    "y2": 0.294083307426838,
    "y3": 0.289261525459189
  },
  {
    "x": "1993-12-20",
    "y1": 2.30974608773581,
    "y2": 0.205422971334261,
    "y3": 0.280874131460868
  },
  {
    "x": "1993-12-27",
    "y1": 2.3336026519835,
    "y2": 0.370454502556672,
    "y3": 0.286526578809843
  },
  {
    "x": "1994-01-03",
    "y1": 2.3415068934162,
    "y2": 0.450489915764075,
    "y3": 0.296180796819188
  },
  {
    "x": "1994-01-10",
    "y1": 2.35347459858897,
    "y2": 0.42741160855516,
    "y3": 0.304681099468087
  },
  {
    "x": "1994-01-17",
    "y1": 2.35596103917959,
    "y2": 0.402356037696933,
    "y3": 0.307495606769446
  },
  {
    "x": "1994-01-24",
    "y1": 2.35879379326758,
    "y2": 0.470955481232833,
    "y3": 0.317287191809462
  },
  {
    "x": "1994-01-31",
    "y1": 2.33462646838092,
    "y2": 0.358569186140758,
    "y3": 0.320511485745158
  },
  {
    "x": "1994-02-07",
    "y1": 2.33991411915882,
    "y2": 0.354337904816748,
    "y3": 0.320816498922365
  },
  {
    "x": "1994-02-14",
    "y1": 2.34946115815043,
    "y2": 0.354337904816748,
    "y3": 0.325554528904202
  },
  {
    "x": "1994-02-21",
    "y1": 2.34303414864803,
    "y2": 0.205422971334261,
    "y3": 0.322846812211914
  },
  {
    "x": "1994-02-28",
    "y1": 2.35167172327744,
    "y2": 0.26990885004818,
    "y3": 0.323363389455322
  },
  {
    "x": "1994-03-07",
    "y1": 2.34996408225943,
    "y2": 0.26990885004818,
    "y3": 0.326587683391018
  },
  {
    "x": "1994-03-14",
    "y1": 2.3686285275723,
    "y2": 0.428959886497219,
    "y3": 0.333331512344537
  },
  {
    "x": "1994-03-21",
    "y1": 2.34315369685901,
    "y2": 0.262289768043103,
    "y3": 0.33174183537535
  },
  {
    "x": "1994-03-28",
    "y1": 2.29211024850712,
    "y2": 0.267362815308422,
    "y3": 0.327181516833734
  },
  {
    "x": "1994-04-04",
    "y1": 2.29917182524943,
    "y2": 0.267362815308422,
    "y3": 0.324784067537154
  },
  {
    "x": "1994-04-11",
    "y1": 2.27147077856799,
    "y2": 0.244771662607627,
    "y3": 0.321257060605535
  },
  {
    "x": "1994-04-18",
    "y1": 2.26403919023021,
    "y2": 0.222376430004782,
    "y3": 0.316610292043774
  },
  {
    "x": "1994-04-25",
    "y1": 2.27965039114776,
    "y2": 0.158283076117891,
    "y3": 0.314253297282956
  },
  {
    "x": "1994-05-02",
    "y1": 2.27831489367142,
    "y2": 0.133716093912205,
    "y3": 0.306234936607224
  },
  {
    "x": "1994-05-09",
    "y1": 2.25656448737278,
    "y2": 0.133716093912205,
    "y3": 0.302649592736121
  },
  {
    "x": "1994-05-16",
    "y1": 2.2702062180122,
    "y2": 0.151434318767552,
    "y3": 0.291698583546665
  },
  {
    "x": "1994-05-23",
    "y1": 2.27906820003123,
    "y2": 0.151434318767552,
    "y3": 0.276745803696839
  },
  {
    "x": "1994-05-30",
    "y1": 2.2916715091533,
    "y2": 0.112567620460574,
    "y3": 0.26100360429211
  },
  {
    "x": "1994-06-06",
    "y1": 2.2807202377972,
    "y2": 0.0948493956052264,
    "y3": 0.245628272187524
  },
  {
    "x": "1994-06-13",
    "y1": 2.27404672821047,
    "y2": 0.112567620460574,
    "y3": 0.227708879148911
  },
  {
    "x": "1994-06-20",
    "y1": 2.22529098851221,
    "y2": 0.170726186907339,
    "y3": 0.21831672918724
  },
  {
    "x": "1994-06-27",
    "y1": 2.24411512545886,
    "y2": 0.170726186907339,
    "y3": 0.20913614329177
  },
  {
    "x": "1994-07-04",
    "y1": 2.24497817477312,
    "y2": 0.127468802006589,
    "y3": 0.197792688151262
  },
  {
    "x": "1994-07-11",
    "y1": 2.26462587633532,
    "y2": 0.0728386305148765,
    "y3": 0.191163471110293
  },
  {
    "x": "1994-07-18",
    "y1": 2.25813814098707,
    "y2": 0.0842376004176029,
    "y3": 0.181879908628764
  },
  {
    "x": "1994-07-25",
    "y1": 2.26578448318268,
    "y2": 0.0842376004176029,
    "y3": 0.172596346147235
  },
  {
    "x": "1994-08-01",
    "y1": 2.26095177247569,
    "y2": 0.172897936510181,
    "y3": 0.159793248647883
  },
  {
    "x": "1994-08-08",
    "y1": 2.27895725865032,
    "y2": 0.172897936510181,
    "y3": 0.155323657071237
  },
  {
    "x": "1994-08-15",
    "y1": 2.2937465692678,
    "y2": 0.226438731861574,
    "y3": 0.153277452898895
  },
  {
    "x": "1994-08-22",
    "y1": 2.32137208274108,
    "y2": 0.25068346604663,
    "y3": 0.152443485435805
  },
  {
    "x": "1994-08-29",
    "y1": 2.31650928624229,
    "y2": 0.137778395768997,
    "y3": 0.147093822093874
  },
  {
    "x": "1994-09-05",
    "y1": 2.32243634407162,
    "y2": 0.268401690901977,
    "y3": 0.149395085138733
  },
  {
    "x": "1994-09-12",
    "y1": 2.34100310593565,
    "y2": 0.314288231280981,
    "y3": 0.157195342896888
  },
  {
    "x": "1994-09-19",
    "y1": 2.31471477967958,
    "y2": 0.294227338724303,
    "y3": 0.165220905137493
  },
  {
    "x": "1994-09-26",
    "y1": 2.32373169919554,
    "y2": 0.216142267952308,
    "y3": 0.169342213839498
  },
  {
    "x": "1994-10-03",
    "y1": 2.30498232858143,
    "y2": 0.164640957683972,
    "y3": 0.170002545785319
  },
  {
    "x": "1994-10-10",
    "y1": 2.32781020555566,
    "y2": 0.20129779446789,
    "y3": 0.172495719570336
  },
  {
    "x": "1994-10-17",
    "y1": 2.32559399320603,
    "y2": 0.10735269007623,
    "y3": 0.172234973051119
  },
  {
    "x": "1994-10-24",
    "y1": 2.33966546027146,
    "y2": 0.103121408752221,
    "y3": 0.172648573708468
  },
  {
    "x": "1994-10-31",
    "y1": 2.32669115503734,
    "y2": 0.0997336080711531,
    "y3": 0.172006873088997
  },
  {
    "x": "1994-11-07",
    "y1": 2.32152195353839,
    "y2": 0.114739370063415,
    "y3": 0.169207532246801
  },
  {
    "x": "1994-11-14",
    "y1": 2.32486786731746,
    "y2": 0.183509731697804,
    "y3": 0.169846709486324
  },
  {
    "x": "1994-11-21",
    "y1": 2.29590117073731,
    "y2": 0.170726186907339,
    "y3": 0.172009578731362
  },
  {
    "x": "1994-11-28",
    "y1": 2.2992680833245,
    "y2": 0.170726186907339,
    "y3": 0.176903956550985
  },
  {
    "x": "1994-12-05",
    "y1": 2.26440991702366,
    "y2": 0.0728386305148765,
    "y3": 0.176334008055849
  },
  {
    "x": "1994-12-12",
    "y1": 2.27834499761799,
    "y2": 0.161498966607454,
    "y3": 0.180197076365341
  },
  {
    "x": "1994-12-19",
    "y1": 2.29634051928996,
    "y2": 0.0869500632806879,
    "y3": 0.175899682703867
  },
  {
    "x": "1994-12-26",
    "y1": 2.30950429069501,
    "y2": 0.281977269612845,
    "y3": 0.181353649359
  },
  {
    "x": "1995-01-02",
    "y1": 2.30648548721488,
    "y2": 0.25068346604663,
    "y3": 0.182565886068253
  },
  {
    "x": "1995-01-09",
    "y1": 2.32311898994603,
    "y2": 0.30437250221569,
    "y3": 0.185250337876706
  },
  {
    "x": "1995-01-16",
    "y1": 2.32297468251001,
    "y2": 0.384330187442848,
    "y3": 0.197577927460398
  },
  {
    "x": "1995-01-23",
    "y1": 2.31885419868515,
    "y2": 0.336683463883826,
    "y3": 0.200992016109491
  },
  {
    "x": "1995-01-30",
    "y1": 2.33618171430544,
    "y2": 0.316622571327148,
    "y3": 0.201108733111799
  },
  {
    "x": "1995-02-06",
    "y1": 2.35997519560907,
    "y2": 0.353684147034901,
    "y3": 0.204081573527329
  },
  {
    "x": "1995-02-13",
    "y1": 2.35559780355067,
    "y2": 0.322390343468686,
    "y3": 0.209393977303148
  },
  {
    "x": "1995-02-20",
    "y1": 2.36082042517504,
    "y2": 0.297334772610459,
    "y3": 0.216028668049472
  },
  {
    "x": "1995-02-27",
    "y1": 2.37056654537899,
    "y2": 0.365934216146359,
    "y3": 0.224260489133396
  },
  {
    "x": "1995-03-06",
    "y1": 2.3748605309949,
    "y2": 0.349872342623392,
    "y3": 0.236386471760754
  },
  {
    "x": "1995-03-13",
    "y1": 2.38247695368425,
    "y2": 0.337012307590609,
    "y3": 0.248081016702673
  },
  {
    "x": "1995-03-20",
    "y1": 2.39525633319051,
    "y2": 0.432771690908727,
    "y3": 0.264732920844552
  },
  {
    "x": "1995-03-27",
    "y1": 2.39348520571458,
    "y2": 0.374372927711601,
    "y3": 0.277714598726961
  },
  {
    "x": "1995-04-03",
    "y1": 2.39040151919154,
    "y2": 0.437977692945952,
    "y3": 0.290437996789368
  },
  {
    "x": "1995-04-10",
    "y1": 2.41243445460654,
    "y2": 0.417916800389274,
    "y3": 0.302797527463465
  },
  {
    "x": "1995-04-17",
    "y1": 2.40138524721177,
    "y2": 0.31319459077373,
    "y3": 0.309920947656785
  },
  {
    "x": "1995-04-24",
    "y1": 2.42632935724583,
    "y2": 0.49013822343509,
    "y3": 0.330785927302795
  },
  {
    "x": "1995-05-01",
    "y1": 2.42579622709785,
    "y2": 0.376422316484286,
    "y3": 0.341532094796637
  },
  {
    "x": "1995-05-08",
    "y1": 2.44406466166369,
    "y2": 0.356361423927608,
    "y3": 0.355002662828983
  },
  {
    "x": "1995-05-15",
    "y1": 2.45061925787159,
    "y2": 0.358017775259988,
    "y3": 0.35880468811134
  },
  {
    "x": "1995-05-22",
    "y1": 2.45906274738791,
    "y2": 0.26990885004818,
    "y3": 0.359765957311418
  },
  {
    "x": "1995-05-29",
    "y1": 2.46032437537385,
    "y2": 0.354337904816748,
    "y3": 0.362264227441471
  },
  {
    "x": "1995-06-05",
    "y1": 2.47339473811553,
    "y2": 0.35095010413568,
    "y3": 0.360595223276112
  },
  {
    "x": "1995-06-12",
    "y1": 2.50083771443482,
    "y2": 0.416099851464435,
    "y3": 0.364566042655143
  },
  {
    "x": "1995-06-19",
    "y1": 2.53409581149217,
    "y2": 0.479947242186734,
    "y3": 0.372732276198122
  },
  {
    "x": "1995-06-26",
    "y1": 2.5283229324585,
    "y2": 0.448653438620519,
    "y3": 0.377480740777403
  },
  {
    "x": "1995-07-03",
    "y1": 2.56722163842427,
    "y2": 0.540734180534459,
    "y3": 0.388397932630692
  },
  {
    "x": "1995-07-10",
    "y1": 2.59771372618459,
    "y2": 0.509440376968244,
    "y3": 0.399003212848581
  },
  {
    "x": "1995-07-17",
    "y1": 2.5601285471984,
    "y2": 0.484384806110018,
    "y3": 0.404925742346764
  },
  {
    "x": "1995-07-24",
    "y1": 2.60536806276038,
    "y2": 0.53526602479057,
    "y3": 0.414195426455123
  },
  {
    "x": "1995-07-31",
    "y1": 2.59125259042643,
    "y2": 0.430543815175026,
    "y3": 0.418872001834344
  },
  {
    "x": "1995-08-07",
    "y1": 2.60438959931896,
    "y2": 0.621768563974688,
    "y3": 0.428321845487642
  },
  {
    "x": "1995-08-14",
    "y1": 2.6314484318589,
    "y2": 0.576988228940609,
    "y3": 0.438452610549092
  },
  {
    "x": "1995-08-21",
    "y1": 2.62048142166531,
    "y2": 0.568646094002425,
    "y3": 0.444986030601916
  },
  {
    "x": "1995-08-28",
    "y1": 2.61999121115484,
    "y2": 0.626012626528788,
    "y3": 0.455390821908891
  },
  {
    "x": "1995-09-04",
    "y1": 2.65977664845004,
    "y2": 0.607559969069269,
    "y3": 0.470109090823668
  },
  {
    "x": "1995-09-11",
    "y1": 2.65135230813502,
    "y2": 0.572517607256226,
    "y3": 0.474228060014725
  },
  {
    "x": "1995-09-18",
    "y1": 2.65353101531387,
    "y2": 0.636122372490577,
    "y3": 0.48721306281504
  },
  {
    "x": "1995-09-25",
    "y1": 2.64418027584514,
    "y2": 0.463313918465555,
    "y3": 0.492560687541937
  },
  {
    "x": "1995-10-02",
    "y1": 2.61399450447459,
    "y2": 0.52106630447702,
    "y3": 0.500713114002789
  },
  {
    "x": "1995-10-09",
    "y1": 2.62025910566933,
    "y2": 0.515781536177938,
    "y3": 0.513006748309276
  },
  {
    "x": "1995-10-16",
    "y1": 2.64102740857458,
    "y2": 0.498420405748116,
    "y3": 0.520210873355845
  },
  {
    "x": "1995-10-23",
    "y1": 2.62757904241415,
    "y2": 0.419502118080283,
    "y3": 0.523638474053075
  },
  {
    "x": "1995-10-30",
    "y1": 2.66668974734503,
    "y2": 0.444773529188702,
    "y3": 0.525072157939288
  },
  {
    "x": "1995-11-06",
    "y1": 2.66501000051669,
    "y2": 0.414617905614357,
    "y3": 0.521805691110669
  },
  {
    "x": "1995-11-13",
    "y1": 2.64730110196068,
    "y2": 0.402565277036818,
    "y3": 0.519501283031484
  },
  {
    "x": "1995-11-20",
    "y1": 2.63308142890347,
    "y2": 0.463415116071049,
    "y3": 0.515635329808314
  },
  {
    "x": "1995-11-27",
    "y1": 2.65748518127057,
    "y2": 0.47567913787689,
    "y3": 0.513947267853746
  },
  {
    "x": "1995-12-04",
    "y1": 2.66421303866956,
    "y2": 0.47567913787689,
    "y3": 0.51351198444209
  },
  {
    "x": "1995-12-11",
    "y1": 2.63415867859794,
    "y2": 0.374754779978472,
    "y3": 0.505486422201485
  },
  {
    "x": "1995-12-18",
    "y1": 2.65008332972238,
    "y2": 0.420157731170299,
    "y3": 0.504967118001249
  },
  {
    "x": "1995-12-25",
    "y1": 2.65508862174069,
    "y2": 0.374754779978472,
    "y3": 0.492616428801438
  },
  {
    "x": "1996-01-01",
    "y1": 2.63735313839445,
    "y2": 0.463415116071049,
    "y3": 0.48693777315796
  },
  {
    "x": "1996-01-08",
    "y1": 2.61293057078254,
    "y2": 0.420346402578672,
    "y3": 0.479522788586772
  },
  {
    "x": "1996-01-15",
    "y1": 2.6230671784378,
    "y2": 0.420346402578672,
    "y3": 0.469239477389266
  },
  {
    "x": "1996-01-22",
    "y1": 2.64516934198109,
    "y2": 0.420346402578672,
    "y3": 0.459878799064736
  },
  {
    "x": "1996-01-29",
    "y1": 2.67509366720298,
    "y2": 0.383026793125466,
    "y3": 0.450404258358198
  },
  {
    "x": "1996-02-05",
    "y1": 2.69607098346872,
    "y2": 0.383026793125466,
    "y3": 0.437749479389943
  },
  {
    "x": "1996-02-12",
    "y1": 2.69251716039618,
    "y2": 0.383026793125466,
    "y3": 0.433735123122939
  },
  {
    "x": "1996-02-19",
    "y1": 2.71734509733161,
    "y2": 0.471687129218044,
    "y3": 0.43126616435999
  },
  {
    "x": "1996-02-26",
    "y1": 2.68897654697809,
    "y2": 0.420346402578672,
    "y3": 0.426494407680026
  },
  {
    "x": "1996-03-04",
    "y1": 2.66839797404582,
    "y2": 0.420346402578672,
    "y3": 0.422590707521554
  },
  {
    "x": "1996-03-11",
    "y1": 2.70210952303851,
    "y2": 0.420346402578672,
    "y3": 0.422632921746474
  },
  {
    "x": "1996-03-18",
    "y1": 2.70450132813365,
    "y2": 0.284510515208087,
    "y3": 0.414619771047443
  },
  {
    "x": "1996-03-25",
    "y1": 2.70375742373085,
    "y2": 0.284510515208087,
    "y3": 0.408114401527129
  },
  {
    "x": "1996-04-01",
    "y1": 2.71901975907752,
    "y2": 0.257405555577176,
    "y3": 0.400856415454147
  },
  {
    "x": "1996-04-08",
    "y1": 2.70357541487156,
    "y2": 0.205422971334261,
    "y3": 0.387956808217308
  },
  {
    "x": "1996-04-15",
    "y1": 2.73787338912563,
    "y2": 0.403988784979239,
    "y3": 0.384372290572425
  },
  {
    "x": "1996-04-22",
    "y1": 2.7801936363751,
    "y2": 0.289394727674014,
    "y3": 0.375058070062281
  },
  {
    "x": "1996-04-29",
    "y1": 2.77826419132608,
    "y2": 0.315328448886661,
    "y3": 0.372086753507691
  },
  {
    "x": "1996-05-06",
    "y1": 2.79359428971706,
    "y2": 0.333046673742009,
    "y3": 0.367731200636276
  },
  {
    "x": "1996-05-13",
    "y1": 2.82611947745157,
    "y2": 0.315328448886661,
    "y3": 0.364759884081686
  },
  {
    "x": "1996-05-20",
    "y1": 2.83088647903146,
    "y2": 0.476135437775226,
    "y3": 0.365395900166895
  },
  {
    "x": "1996-05-27",
    "y1": 2.82738431927334,
    "y2": 0.476135437775226,
    "y3": 0.368185351926722
  },
  {
    "x": "1996-06-03",
    "y1": 2.81639050108106,
    "y2": 0.378055063766592,
    "y3": 0.366070784986118
  },
  {
    "x": "1996-06-10",
    "y1": 2.8029082314325,
    "y2": 0.348237641272595,
    "y3": 0.362465346920815
  },
  {
    "x": "1996-06-17",
    "y1": 2.77179981336277,
    "y2": 0.348237641272595,
    "y3": 0.360725889328171
  },
  {
    "x": "1996-06-24",
    "y1": 2.77995001975574,
    "y2": 0.348237641272595,
    "y3": 0.358986431735527
  },
  {
    "x": "1996-07-01",
    "y1": 2.75744403377598,
    "y2": 0.259577305180018,
    "y3": 0.352813957338255
  },
  {
    "x": "1996-07-08",
    "y1": 2.7100835757902,
    "y2": 0.250825922526088,
    "y3": 0.341770897003657
  },
  {
    "x": "1996-07-15",
    "y1": 2.70481851985417,
    "y2": 0.267362815308422,
    "y3": 0.334121717640145
  },
  {
    "x": "1996-07-22",
    "y1": 2.68820155369629,
    "y2": 0.224105430407672,
    "y3": 0.324309669031595
  },
  {
    "x": "1996-07-29",
    "y1": 2.73033460880616,
    "y2": 0.267362815308422,
    "y3": 0.316660489668082
  },
  {
    "x": "1996-08-05",
    "y1": 2.74131314514962,
    "y2": 0.178702479215845,
    "y3": 0.31137008786847
  },
  {
    "x": "1996-08-12",
    "y1": 2.73813008830734,
    "y2": 0.217926265805265,
    "y3": 0.308040875398329
  },
  {
    "x": "1996-08-19",
    "y1": 2.74642191048493,
    "y2": 0.235644490660612,
    "y3": 0.306952822152501
  },
  {
    "x": "1996-08-26",
    "y1": 2.74506584665403,
    "y2": 0.235644490660612,
    "y3": 0.308463898118818
  },
  {
    "x": "1996-09-02",
    "y1": 2.74321741445818,
    "y2": 0.306586601897842,
    "y3": 0.303593788964749
  },
  {
    "x": "1996-09-09",
    "y1": 2.78646865298345,
    "y2": 0.401854926866308,
    "y3": 0.309216798924363
  },
  {
    "x": "1996-09-16",
    "y1": 2.81256495920312,
    "y2": 0.432771690908727,
    "y3": 0.315088961025467
  },
  {
    "x": "1996-09-23",
    "y1": 2.82105900926467,
    "y2": 0.401477887342513,
    "y3": 0.318510521705492
  },
  {
    "x": "1996-09-30",
    "y1": 2.83529421033011,
    "y2": 0.479947242186734,
    "y3": 0.326741461370495
  },
  {
    "x": "1996-10-07",
    "y1": 2.83586328989675,
    "y2": 0.537313774713097,
    "y3": 0.329800378217389
  },
  {
    "x": "1996-10-14",
    "y1": 2.83122483910333,
    "y2": 0.51225820385487,
    "y3": 0.331606516521371
  },
  {
    "x": "1996-10-21",
    "y1": 2.8152245773725,
    "y2": 0.416099851464435,
    "y3": 0.333508755906263
  },
  {
    "x": "1996-10-28",
    "y1": 2.81455391950775,
    "y2": 0.370454502556672,
    "y3": 0.334619598970467
  },
  {
    "x": "1996-11-04",
    "y1": 2.84379812027384,
    "y2": 0.320596569539089,
    "y3": 0.333237545383792
  },
  {
    "x": "1996-11-11",
    "y1": 2.84720965499657,
    "y2": 0.26990885004818,
    "y3": 0.329321105822571
  },
  {
    "x": "1996-11-18",
    "y1": 2.85716363822482,
    "y2": 0.26567756872417,
    "y3": 0.329626118999779
  },
  {
    "x": "1996-11-25",
    "y1": 2.87148455241687,
    "y2": 0.343076772675239,
    "y3": 0.334238661507236
  },
  {
    "x": "1996-12-02",
    "y1": 2.86767061650697,
    "y2": 0.421255200060962,
    "y3": 0.341933280744863
  },
  {
    "x": "1996-12-09",
    "y1": 2.86551944586232,
    "y2": 0.390958914070751,
    "y3": 0.350275954928017
  },
  {
    "x": "1996-12-16",
    "y1": 2.86836013067057,
    "y2": 0.385674145771669,
    "y3": 0.35619152145118
  },
  {
    "x": "1996-12-23",
    "y1": 2.87054857836476,
    "y2": 0.385674145771669,
    "y3": 0.366540104778971
  },
  {
    "x": "1996-12-30",
    "y1": 2.88549386848475,
    "y2": 0.342416760870919,
    "y3": 0.372764629532254
  },
  {
    "x": "1997-01-06",
    "y1": 2.90177546654516,
    "y2": 0.403536975205615,
    "y3": 0.381159253759504
  },
  {
    "x": "1997-01-13",
    "y1": 2.91456058166893,
    "y2": 0.322947530891739,
    "y3": 0.38552440577106
  },
  {
    "x": "1997-01-20",
    "y1": 2.92551637032881,
    "y2": 0.257405555577176,
    "y3": 0.383065353455027
  },
  {
    "x": "1997-01-27",
    "y1": 2.93726271704903,
    "y2": 0.32001680283352,
    "y3": 0.378973447253387
  },
  {
    "x": "1997-02-03",
    "y1": 2.92121748384241,
    "y2": 0.346065891669754,
    "y3": 0.374638157291439
  },
  {
    "x": "1997-02-10",
    "y1": 2.92819981493041,
    "y2": 0.294083307426838,
    "y3": 0.369268428295655
  },
  {
    "x": "1997-02-17",
    "y1": 2.90415780429115,
    "y2": 0.267362815308422,
    "y3": 0.358639206951739
  },
  {
    "x": "1997-02-24",
    "y1": 2.88518188598948,
    "y2": 0.244771662607627,
    "y3": 0.344012101346466
  },
  {
    "x": "1997-03-03",
    "y1": 2.88732096072449,
    "y2": 0.267362815308422,
    "y3": 0.331767331919143
  },
  {
    "x": "1997-03-10",
    "y1": 2.87296657939799,
    "y2": 0.178702479215845,
    "y3": 0.319897463306714
  },
  {
    "x": "1997-03-17",
    "y1": 2.84288078831584,
    "y2": 0.224105430407672,
    "y3": 0.312580009699264
  },
  {
    "x": "1997-03-24",
    "y1": 2.83924467811567,
    "y2": 0.224105430407672,
    "y3": 0.307755452742693
  },
  {
    "x": "1997-03-31",
    "y1": 2.82901664536924,
    "y2": 0.224105430407672,
    "y3": 0.305465281760668
  },
  {
    "x": "1997-04-07",
    "y1": 2.80489662198031,
    "y2": 0.326715843681343,
    "y3": 0.308517195508526
  },
  {
    "x": "1997-04-14",
    "y1": 2.81788023417521,
    "y2": 0.238055507588765,
    "y3": 0.303266132254203
  },
  {
    "x": "1997-04-21",
    "y1": 2.80701794587271,
    "y2": 0.329256464296697,
    "y3": 0.298666195465989
  },
  {
    "x": "1997-04-28",
    "y1": 2.88643637643106,
    "y2": 0.41919611219786,
    "y3": 0.300078055372345
  },
  {
    "x": "1997-05-05",
    "y1": 2.90920463715746,
    "y2": 0.401477887342513,
    "y3": 0.300868242450887
  },
  {
    "x": "1997-05-12",
    "y1": 2.91345910810078,
    "y2": 0.376422316484286,
    "y3": 0.300405650986518
  },
  {
    "x": "1997-05-19",
    "y1": 2.94999889683382,
    "y2": 0.497665467042082,
    "y3": 0.308168086295076
  },
  {
    "x": "1997-05-26",
    "y1": 2.95762631516945,
    "y2": 0.466371663475867,
    "y3": 0.311309820708589
  },
  {
    "x": "1997-06-02",
    "y1": 2.96085416287899,
    "y2": 0.51225820385487,
    "y3": 0.320775354356745
  },
  {
    "x": "1997-06-09",
    "y1": 2.97380230211131,
    "y2": 0.431737108767817,
    "y3": 0.329491932016277
  },
  {
    "x": "1997-06-16",
    "y1": 2.9907168757981,
    "y2": 0.38023579849948,
    "y3": 0.332502881799575
  },
  {
    "x": "1997-06-23",
    "y1": 2.98453212607599,
    "y2": 0.34770152917,
    "y3": 0.332584663674588
  },
  {
    "x": "1997-06-30",
    "y1": 3.00501674898555,
    "y2": 0.342416760870919,
    "y3": 0.335001336346791
  },
  {
    "x": "1997-07-07",
    "y1": 3.0288718672493,
    "y2": 0.318716249567729,
    "y3": 0.337569008059757
  },
  {
    "x": "1997-07-14",
    "y1": 3.05906579203709,
    "y2": 0.403536975205615,
    "y3": 0.345507273689656
  },
  {
    "x": "1997-07-21",
    "y1": 3.07301288856647,
    "y2": 0.523015955679112,
    "y3": 0.358289930708191
  },
  {
    "x": "1997-07-28",
    "y1": 3.08878143855624,
    "y2": 0.533108227882111,
    "y3": 0.376010218141504
  },
  {
    "x": "1997-08-04",
    "y1": 3.09140954164159,
    "y2": 0.555326917347248,
    "y3": 0.392571292488483
  },
  {
    "x": "1997-08-11",
    "y1": 3.06858218271675,
    "y2": 0.44473501346559,
    "y3": 0.403602771641379
  },
  {
    "x": "1997-08-18",
    "y1": 3.09205158562309,
    "y2": 0.53526602479057,
    "y3": 0.419160801360524
  },
  {
    "x": "1997-08-25",
    "y1": 3.08493951540691,
    "y2": 0.394877080448007,
    "y3": 0.422568863198857
  },
  {
    "x": "1997-09-01",
    "y1": 3.11546270851329,
    "y2": 0.475946766366853,
    "y3": 0.434463426137761
  },
  {
    "x": "1997-09-08",
    "y1": 3.12375234358517,
    "y2": 0.417683780142242,
    "y3": 0.438884791930039
  },
  {
    "x": "1997-09-15",
    "y1": 3.14256606195787,
    "y2": 0.501814424315896,
    "y3": 0.44301570753594
  },
  {
    "x": "1997-09-22",
    "y1": 3.14368487274794,
    "y2": 0.494477078313017,
    "y3": 0.447665667084466
  },
  {
    "x": "1997-09-29",
    "y1": 3.16367607797314,
    "y2": 0.474416185756339,
    "y3": 0.452565360548068
  },
  {
    "x": "1997-10-06",
    "y1": 3.17717362396765,
    "y2": 0.529296423470602,
    "y3": 0.454146908369494
  },
  {
    "x": "1997-10-13",
    "y1": 3.13566769681576,
    "y2": 0.349404291341441,
    "y3": 0.448298539762773
  },
  {
    "x": "1997-10-20",
    "y1": 3.12611078895126,
    "y2": 0.420346402578672,
    "y3": 0.443702949698963
  },
  {
    "x": "1997-10-27",
    "y1": 3.09139677672278,
    "y2": 0.346065891669754,
    "y3": 0.43941938884406
  },
  {
    "x": "1997-11-03",
    "y1": 3.09691257992639,
    "y2": 0.401276322116154,
    "y3": 0.440471415024893
  },
  {
    "x": "1997-11-10",
    "y1": 3.08512400381516,
    "y2": 0.332085216002756,
    "y3": 0.439690599366531
  },
  {
    "x": "1997-11-17",
    "y1": 3.108641373459,
    "y2": 0.339958079633088,
    "y3": 0.43956766530464
  },
  {
    "x": "1997-11-24",
    "y1": 3.09617803786013,
    "y2": 0.339958079633088,
    "y3": 0.440629756807908
  },
  {
    "x": "1997-12-01",
    "y1": 3.11701460939399,
    "y2": 0.339958079633088,
    "y3": 0.437450812029282
  },
  {
    "x": "1997-12-08",
    "y1": 3.05745155969377,
    "y2": 0.330334210878924,
    "y3": 0.427816724789272
  },
  {
    "x": "1997-12-15",
    "y1": 3.04974615798417,
    "y2": 0.432849697049676,
    "y3": 0.42280379824765
  },
  {
    "x": "1997-12-22",
    "y1": 3.04098401792283,
    "y2": 0.432849697049676,
    "y3": 0.416679937232772
  },
  {
    "x": "1997-12-29",
    "y1": 3.08739856898704,
    "y2": 0.512069532446498,
    "y3": 0.420046663181817
  },
  {
    "x": "1998-01-05",
    "y1": 3.03788319011778,
    "y2": 0.344189360957098,
    "y3": 0.410492829990143
  },
  {
    "x": "1998-01-12",
    "y1": 3.07757134976336,
    "y2": 0.491722152112897,
    "y3": 0.415335083573388
  },
  {
    "x": "1998-01-19",
    "y1": 3.08592135026714,
    "y2": 0.533108227882111,
    "y3": 0.418193156649151
  },
  {
    "x": "1998-01-26",
    "y1": 3.11347963658725,
    "y2": 0.361907585812445,
    "y3": 0.415404346932661
  },
  {
    "x": "1998-02-02",
    "y1": 3.1597880491161,
    "y2": 0.46432391355334,
    "y3": 0.413529821394533
  },
  {
    "x": "1998-02-09",
    "y1": 3.16927255266668,
    "y2": 0.430543815175026,
    "y3": 0.410333158237634
  },
  {
    "x": "1998-02-16",
    "y1": 3.17962671157647,
    "y2": 0.422518152181514,
    "y3": 0.407738256558892
  },
  {
    "x": "1998-02-23",
    "y1": 3.20415033234752,
    "y2": 0.50634411623482,
    "y3": 0.406590641197103
  },
  {
    "x": "1998-03-02",
    "y1": 3.19453727202175,
    "y2": 0.422518152181514,
    "y3": 0.410246334239107
  },
  {
    "x": "1998-03-09",
    "y1": 3.20489948911253,
    "y2": 0.422518152181514,
    "y3": 0.410354921719249
  },
  {
    "x": "1998-03-16",
    "y1": 3.21477723070086,
    "y2": 0.377089017677922,
    "y3": 0.411906078019657
  },
  {
    "x": "1998-03-23",
    "y1": 3.23403764356454,
    "y2": 0.452790267424804,
    "y3": 0.41448177528509
  },
  {
    "x": "1998-03-30",
    "y1": 3.25146453588968,
    "y2": 0.39914339086539,
    "y3": 0.417834684028222
  },
  {
    "x": "1998-04-06",
    "y1": 3.23251442609285,
    "y2": 0.331686066486094,
    "y3": 0.417421083370872
  },
  {
    "x": "1998-04-13",
    "y1": 3.25798358708276,
    "y2": 0.420346402578672,
    "y3": 0.421440499518151
  },
  {
    "x": "1998-04-20",
    "y1": 3.2592479101206,
    "y2": 0.399104572513312,
    "y3": 0.424397824162162
  },
  {
    "x": "1998-04-27",
    "y1": 3.26164495476703,
    "y2": 0.373170851300665,
    "y3": 0.426539656183249
  },
  {
    "x": "1998-05-04",
    "y1": 3.25680362193932,
    "y2": 0.373170851300665,
    "y3": 0.423555713895799
  },
  {
    "x": "1998-05-11",
    "y1": 3.24736344878055,
    "y2": 0.310444236420735,
    "y3": 0.417435440864352
  },
  {
    "x": "1998-05-18",
    "y1": 3.22474557049062,
    "y2": 0.346065891669754,
    "y3": 0.409135258825515
  },
  {
    "x": "1998-05-25",
    "y1": 3.21026911349183,
    "y2": 0.346065891669754,
    "y3": 0.409229085361147
  },
  {
    "x": "1998-06-01",
    "y1": 3.21254586718335,
    "y2": 0.294083307426838,
    "y3": 0.399347143126844
  },
  {
    "x": "1998-06-08",
    "y1": 3.19130543340967,
    "y2": 0.178702479215845,
    "y3": 0.381626855693531
  },
  {
    "x": "1998-06-15",
    "y1": 3.2120727404899,
    "y2": 0.178702479215845,
    "y3": 0.372466600363701
  },
  {
    "x": "1998-06-22",
    "y1": 3.26160986712247,
    "y2": 0.26567756872417,
    "y3": 0.362534283122242
  },
  {
    "x": "1998-06-29",
    "y1": 3.27469870245523,
    "y2": 0.210307183800187,
    "y3": 0.3515224515535
  },
  {
    "x": "1998-07-06",
    "y1": 3.30059101452625,
    "y2": 0.26990885004818,
    "y3": 0.343891986446834
  },
  {
    "x": "1998-07-13",
    "y1": 3.33441428598844,
    "y2": 0.448653438620519,
    "y3": 0.341007452566119
  },
  {
    "x": "1998-07-20",
    "y1": 3.29569885002139,
    "y2": 0.345157740227205,
    "y3": 0.337139431968403
  },
  {
    "x": "1998-07-27",
    "y1": 3.26535173487201,
    "y2": 0.416099851464435,
    "y3": 0.336818516932549
  },
  {
    "x": "1998-08-03",
    "y1": 3.25166869078571,
    "y2": 0.358569186140758,
    "y3": 0.335892525355691
  },
  {
    "x": "1998-08-10",
    "y1": 3.22103137399661,
    "y2": 0.358569186140758,
    "y3": 0.331181471291489
  },
  {
    "x": "1998-08-17",
    "y1": 3.22517621012471,
    "y2": 0.255710134992015,
    "y3": 0.32400980849782
  },
  {
    "x": "1998-08-24",
    "y1": 3.13732070591214,
    "y2": 0.15611132651505,
    "y3": 0.315231071499268
  },
  {
    "x": "1998-08-31",
    "y1": 3.09270222438941,
    "y2": 0.183509731697804,
    "y3": 0.303389237955225
  },
  {
    "x": "1998-09-07",
    "y1": 3.14065564610161,
    "y2": 0.306586601897842,
    "y3": 0.298763339424451
  },
  {
    "x": "1998-09-14",
    "y1": 3.15413607097268,
    "y2": 0.213694984481255,
    "y3": 0.290789546083481
  },
  {
    "x": "1998-09-21",
    "y1": 3.20211141933937,
    "y2": 0.356361423927608,
    "y3": 0.289949074714828
  },
  {
    "x": "1998-09-28",
    "y1": 3.12834981949496,
    "y2": 0.158283076117891,
    "y3": 0.282341016699686
  },
  {
    "x": "1998-10-05",
    "y1": 3.05250368411511,
    "y2": 0.224548179607624,
    "y3": 0.276265131096579
  },
  {
    "x": "1998-10-12",
    "y1": 3.13857458695402,
    "y2": 0.272247027774349,
    "y3": 0.272574187901809
  },
  {
    "x": "1998-10-19",
    "y1": 3.18355440519392,
    "y2": 0.240929258959694,
    "y3": 0.269916485478452
  },
  {
    "x": "1998-10-26",
    "y1": 3.22932562003301,
    "y2": 0.223211034104346,
    "y3": 0.272141913222877
  },
  {
    "x": "1998-11-02",
    "y1": 3.27740653007598,
    "y2": 0.329256464296697,
    "y3": 0.279669612476919
  },
  {
    "x": "1998-11-09",
    "y1": 3.27279042928263,
    "y2": 0.223211034104346,
    "y3": 0.277546285745928
  },
  {
    "x": "1998-11-16",
    "y1": 3.31619973946669,
    "y2": 0.437977692945952,
    "y3": 0.288929811203216
  },
  {
    "x": "1998-11-23",
    "y1": 3.36195719444107,
    "y2": 0.49013822343509,
    "y3": 0.299941279872562
  },
  {
    "x": "1998-11-30",
    "y1": 3.35537137606192,
    "y2": 0.465082652576864,
    "y3": 0.300762740570379
  },
  {
    "x": "1998-12-07",
    "y1": 3.36842576211589,
    "y2": 0.445021760020186,
    "y3": 0.305755941560028
  },
  {
    "x": "1998-12-14",
    "y1": 3.39643027219246,
    "y2": 0.411636222809116,
    "y3": 0.305532760127262
  },
  {
    "x": "1998-12-21",
    "y1": 3.43329268336535,
    "y2": 0.568607578279312,
    "y3": 0.31603467973419
  },
  {
    "x": "1998-12-28",
    "y1": 3.44700019770086,
    "y2": 0.448653438620519,
    "y3": 0.320538892358178
  },
  {
    "x": "1999-01-04",
    "y1": 3.51619373384023,
    "y2": 0.533108227882111,
    "y3": 0.334408797002683
  },
  {
    "x": "1999-01-11",
    "y1": 3.5178103619917,
    "y2": 0.491722152112897,
    "y3": 0.351189338282575
  },
  {
    "x": "1999-01-18",
    "y1": 3.51384133526775,
    "y2": 0.555326917347248,
    "y3": 0.369780197565047
  },
  {
    "x": "1999-01-25",
    "y1": 3.58524731511004,
    "y2": 0.657306430095002,
    "y3": 0.387316188974905
  },
  {
    "x": "1999-02-01",
    "y1": 3.53246376073984,
    "y2": 0.476758853457669,
    "y3": 0.400469382423726
  },
  {
    "x": "1999-02-08",
    "y1": 3.51066995126089,
    "y2": 0.50634411623482,
    "y3": 0.407968517039087
  },
  {
    "x": "1999-02-15",
    "y1": 3.49417916285432,
    "y2": 0.496047652325554,
    "y3": 0.42485674584947
  },
  {
    "x": "1999-02-22",
    "y1": 3.49611905226191,
    "y2": 0.545358296993569,
    "y3": 0.440897251718767
  },
  {
    "x": "1999-03-01",
    "y1": 3.51756985382332,
    "y2": 0.559067276903488,
    "y3": 0.455238264175224
  },
  {
    "x": "1999-03-08",
    "y1": 3.53657619919573,
    "y2": 0.53735229043621,
    "y3": 0.47005941574905
  },
  {
    "x": "1999-03-15",
    "y1": 3.5532629466839,
    "y2": 0.512296719577983,
    "y3": 0.484513700022732
  },
  {
    "x": "1999-03-22",
    "y1": 3.55239559292356,
    "y2": 0.409235663068388,
    "y3": 0.488512659961316
  },
  {
    "x": "1999-03-29",
    "y1": 3.58306735129884,
    "y2": 0.52106630447702,
    "y3": 0.50340542347995
  },
  {
    "x": "1999-04-05",
    "y1": 3.62304534371701,
    "y2": 0.580896163113883,
    "y3": 0.510551346988347
  },
  {
    "x": "1999-04-12",
    "y1": 3.58100604339001,
    "y2": 0.374754779978472,
    "y3": 0.504782174815516
  },
  {
    "x": "1999-04-19",
    "y1": 3.62394009463985,
    "y2": 0.564834289590916,
    "y3": 0.509769756666218
  },
  {
    "x": "1999-04-26",
    "y1": 3.60547789535466,
    "y2": 0.463313918465555,
    "y3": 0.510684364588487
  },
  {
    "x": "1999-05-03",
    "y1": 3.59004645651151,
    "y2": 0.551974254558133,
    "y3": 0.517701266175938
  },
  {
    "x": "1999-05-10",
    "y1": 3.59972843264997,
    "y2": 0.692471746915018,
    "y3": 0.523894474607723
  },
  {
    "x": "1999-05-17",
    "y1": 3.59667438119313,
    "y2": 0.572517607256226,
    "y3": 0.530087683039508
  },
  {
    "x": "1999-05-24",
    "y1": 3.57698504839339,
    "y2": 0.732702834840896,
    "y3": 0.540067413387447
  },
  {
    "x": "1999-05-31",
    "y1": 3.58015040155691,
    "y2": 0.681908865954011,
    "y3": 0.549576749079503
  },
  {
    "x": "1999-06-07",
    "y1": 3.56785983448464,
    "y2": 0.585386319248905,
    "y3": 0.551079719174586
  },
  {
    "x": "1999-06-14",
    "y1": 3.61506805716139,
    "y2": 0.676353460416454,
    "y3": 0.552032070690659
  },
  {
    "x": "1999-06-21",
    "y1": 3.61085885417278,
    "y2": 0.515087828565182,
    "y3": 0.553948519446034
  },
  {
    "x": "1999-06-28",
    "y1": 3.68465280336046,
    "y2": 0.723063540434435,
    "y3": 0.564784490656015
  },
  {
    "x": "1999-07-05",
    "y1": 3.70364210240141,
    "y2": 0.811096477375402,
    "y3": 0.580536931908507
  },
  {
    "x": "1999-07-12",
    "y1": 3.72920891968907,
    "y2": 0.734188851078515,
    "y3": 0.589978459612755
  },
  {
    "x": "1999-07-19",
    "y1": 3.66913516134609,
    "y2": 0.678097061542503,
    "y3": 0.595929948844705
  },
  {
    "x": "1999-07-26",
    "y1": 3.6491121654819,
    "y2": 0.594638148536289,
    "y3": 0.598794241749709
  },
  {
    "x": "1999-08-02",
    "y1": 3.61480465631329,
    "y2": 0.509045254394362,
    "y3": 0.598631668490528
  },
  {
    "x": "1999-08-09",
    "y1": 3.65006413304324,
    "y2": 0.54638232081722,
    "y3": 0.60548900137797
  },
  {
    "x": "1999-08-16",
    "y1": 3.65405229720122,
    "y2": 0.420384918301785,
    "y3": 0.600454932069208
  },
  {
    "x": "1999-08-23",
    "y1": 3.69580306880332,
    "y2": 0.420384918301785,
    "y3": 0.592429369828603
  },
  {
    "x": "1999-08-30",
    "y1": 3.72632617875978,
    "y2": 0.463822248268794,
    "y3": 0.596882743243119
  },
  {
    "x": "1999-09-06",
    "y1": 3.74178458505124,
    "y2": 0.463822248268794,
    "y3": 0.591832141177013
  },
  {
    "x": "1999-09-13",
    "y1": 3.73574385813448,
    "y2": 0.509045254394362,
    "y3": 0.594118707973454
  },
  {
    "x": "1999-09-20",
    "y1": 3.69071692083911,
    "y2": 0.463415116071049,
    "y3": 0.5896907510491
  },
  {
    "x": "1999-09-27",
    "y1": 3.6894179128194,
    "y2": 0.463415116071049,
    "y3": 0.578237919506901
  },
  {
    "x": "1999-10-04",
    "y1": 3.74412312697466,
    "y2": 0.420346402578672,
    "y3": 0.570629359273023
  },
  {
    "x": "1999-10-11",
    "y1": 3.69051625564646,
    "y2": 0.284510515208087,
    "y3": 0.548219743291383
  },
  {
    "x": "1999-10-18",
    "y1": 3.72151743031117,
    "y2": 0.333857816088936,
    "y3": 0.530817190798129
  },
  {
    "x": "1999-10-25",
    "y1": 3.77474265543644,
    "y2": 0.310444236420735,
    "y3": 0.51707008665672
  },
  {
    "x": "1999-11-01",
    "y1": 3.82054185196313,
    "y2": 0.409235663068388,
    "y3": 0.503714196789317
  },
  {
    "x": "1999-11-08",
    "y1": 3.85885544024296,
    "y2": 0.453017454556289,
    "y3": 0.500610678088872
  },
  {
    "x": "1999-11-15",
    "y1": 3.90483284028525,
    "y2": 0.641735693673347,
    "y3": 0.496544285750818
  },
  {
    "x": "1999-11-22",
    "y1": 3.92814961956662,
    "y2": 0.661760723603665,
    "y3": 0.489077498062231
  },
  {
    "x": "1999-11-29",
    "y1": 3.94927022162451,
    "y2": 0.701409031274681,
    "y3": 0.48743850707204
  },
  {
    "x": "1999-12-06",
    "y1": 3.97756348468751,
    "y2": 0.676353460416454,
    "y3": 0.487351327015737
  },
  {
    "x": "1999-12-13",
    "y1": 4.01425167903862,
    "y2": 0.656292567859776,
    "y3": 0.490434047981912
  },
  {
    "x": "1999-12-20",
    "y1": 4.07190593434877,
    "y2": 0.728080752170829,
    "y3": 0.501385822870735
  },
  {
    "x": "1999-12-27",
    "y1": 4.09706568450539,
    "y2": 0.651383997412787,
    "y3": 0.506635906700513
  },
  {
    "x": "2000-01-03",
    "y1": 4.05118814292755,
    "y2": 0.517863128859625,
    "y3": 0.511509817228405
  },
  {
    "x": "2000-01-10",
    "y1": 4.09797353445726,
    "y2": 0.714988762647138,
    "y3": 0.526240009445673
  },
  {
    "x": "2000-01-17",
    "y1": 4.14007946786969,
    "y2": 0.69492787009046,
    "y3": 0.537795290536756
  },
  {
    "x": "2000-01-24",
    "y1": 4.05783697790042,
    "y2": 0.558972337009591,
    "y3": 0.542552794973796
  },
  {
    "x": "2000-01-31",
    "y1": 4.14969795855675,
    "y2": 0.811723876527012,
    "y3": 0.557686726080429
  },
  {
    "x": "2000-02-07",
    "y1": 4.18534948129622,
    "y2": 0.76548265464473,
    "y3": 0.572790103009112
  },
  {
    "x": "2000-02-14",
    "y1": 4.18905559519552,
    "y2": 0.734188851078515,
    "y3": 0.586328789759486
  },
  {
    "x": "2000-02-21",
    "y1": 4.22957470015826,
    "y2": 0.811096477375402,
    "y3": 0.605866293499322
  },
  {
    "x": "2000-02-28",
    "y1": 4.30021842939527,
    "y2": 0.859542769840859,
    "y3": 0.634617906230961
  },
  {
    "x": "2000-03-06",
    "y1": 4.32744849966508,
    "y2": 0.948299222811561,
    "y3": 0.665339976567092
  },
  {
    "x": "2000-03-13",
    "y1": 4.27783291588957,
    "y2": 0.734686210394283,
    "y3": 0.68655207526577
  },
  {
    "x": "2000-03-20",
    "y1": 4.31220045206954,
    "y2": 0.843503555921662,
    "y3": 0.708265469908433
  },
  {
    "x": "2000-03-27",
    "y1": 4.23357918161127,
    "y2": 0.681250763596458,
    "y3": 0.719677135360442
  },
  {
    "x": "2000-04-03",
    "y1": 4.2059420552249,
    "y2": 0.627192238811876,
    "y3": 0.718949962617368
  },
  {
    "x": "2000-04-10",
    "y1": 3.95289521857392,
    "y2": 0.420346402578672,
    "y3": 0.706879246566119
  },
  {
    "x": "2000-04-17",
    "y1": 4.05002309357307,
    "y2": 0.54638232081722,
    "y3": 0.699127911043246
  },
  {
    "x": "2000-04-24",
    "y1": 4.10951463453176,
    "y2": 0.546068486705432,
    "y3": 0.692613662357694
  },
  {
    "x": "2000-05-01",
    "y1": 4.09815910341841,
    "y2": 0.541919703400366,
    "y3": 0.686895019134724
  },
  {
    "x": "2000-05-08",
    "y1": 4.02276649789553,
    "y2": 0.457721984724642,
    "y3": 0.673377080762415
  },
  {
    "x": "2000-05-15",
    "y1": 3.98347553827802,
    "y2": 0.422556667904626,
    "y3": 0.661935714287006
  },
  {
    "x": "2000-05-22",
    "y1": 3.92882422862166,
    "y2": 0.420346402578672,
    "y3": 0.657059877972959
  },
  {
    "x": "2000-05-29",
    "y1": 4.11860547014035,
    "y2": 0.565747192231292,
    "y3": 0.649597799452166
  },
  {
    "x": "2000-06-05",
    "y1": 4.13472246004611,
    "y2": 0.477086856138714,
    "y3": 0.638705748754579
  },
  {
    "x": "2000-06-12",
    "y1": 4.1310371391108,
    "y2": 0.477086856138714,
    "y3": 0.634611474711035
  },
  {
    "x": "2000-06-19",
    "y1": 4.12709471353728,
    "y2": 0.538710323211448,
    "y3": 0.620960797045257
  },
  {
    "x": "2000-06-26",
    "y1": 4.15850156358718,
    "y2": 0.69415893506547,
    "y3": 0.617394611066294
  },
  {
    "x": "2000-07-03",
    "y1": 4.17289598083827,
    "y2": 0.59992291683537,
    "y3": 0.610681314354137
  },
  {
    "x": "2000-07-10",
    "y1": 4.22831958078747,
    "y2": 0.721910137896949,
    "y3": 0.606221997380214
  },
  {
    "x": "2000-07-17",
    "y1": 4.19258623497355,
    "y2": 0.605498598972892,
    "y3": 0.593519788836816
  },
  {
    "x": "2000-07-24",
    "y1": 4.0872118974393,
    "y2": 0.467959619096454,
    "y3": 0.56950280865106
  },
  {
    "x": "2000-07-31",
    "y1": 4.12116224071582,
    "y2": 0.505449991309776,
    "y3": 0.558040997696835
  },
  {
    "x": "2000-08-07",
    "y1": 4.12171932090397,
    "y2": 0.465586865673891,
    "y3": 0.539145163184447
  },
  {
    "x": "2000-08-14",
    "y1": 4.15889341603511,
    "y2": 0.422329480773141,
    "y3": 0.526199099043281
  },
  {
    "x": "2000-08-21",
    "y1": 4.18747614456186,
    "y2": 0.376926529581314,
    "y3": 0.513685813581753
  },
  {
    "x": "2000-08-28",
    "y1": 4.23488285242028,
    "y2": 0.393119065328465,
    "y3": 0.512324446719243
  },
  {
    "x": "2000-09-04",
    "y1": 4.17444350043454,
    "y2": 0.349404291341441,
    "y3": 0.502475545245453
  },
  {
    "x": "2000-09-11",
    "y1": 4.13845426483445,
    "y2": 0.346065891669754,
    "y3": 0.49247541549367
  },
  {
    "x": "2000-09-18",
    "y1": 4.13024876715546,
    "y2": 0.244771662607627,
    "y3": 0.477618013454033
  },
  {
    "x": "2000-09-25",
    "y1": 4.09582494938828,
    "y2": 0.183509731697804,
    "y3": 0.463907400802691
  },
  {
    "x": "2000-10-02",
    "y1": 4.01092831606831,
    "y2": 0.127468802006589,
    "y3": 0.449153007507789
  },
  {
    "x": "2000-10-09",
    "y1": 3.9977656089934,
    "y2": 0.118241581706704,
    "y3": 0.434047766464191
  },
  {
    "x": "2000-10-16",
    "y1": 4.04792581668558,
    "y2": 0.118241581706704,
    "y3": 0.411672485937961
  },
  {
    "x": "2000-10-23",
    "y1": 3.98913409672262,
    "y2": 0.0869500632806879,
    "y3": 0.39216564629506
  },
  {
    "x": "2000-10-30",
    "y1": 4.04197148036177,
    "y2": 0.0728386305148765,
    "y3": 0.371953235013868
  },
  {
    "x": "2000-11-06",
    "y1": 3.9195376737209,
    "y2": 0.0489055278620507,
    "y3": 0.347462995246398
  },
  {
    "x": "2000-11-13",
    "y1": 3.91894340010695,
    "y2": 0.137565863954628,
    "y3": 0.319633341690856
  },
  {
    "x": "2000-11-20",
    "y1": 3.87837440345631,
    "y2": 0.129780396826601,
    "y3": 0.296126215690417
  },
  {
    "x": "2000-11-27",
    "y1": 3.78916780714182,
    "y2": 0.123340565992306,
    "y3": 0.266197737095185
  },
  {
    "x": "2000-12-04",
    "y1": 3.89204495428239,
    "y2": 0.128491938816986,
    "y3": 0.24234740408739
  },
  {
    "x": "2000-12-11",
    "y1": 3.80149953646637,
    "y2": 0.0380053820400558,
    "y3": 0.22084969223457
  },
  {
    "x": "2000-12-18",
    "y1": 3.75014780859961,
    "y2": 0.12266774784544,
    "y3": 0.201710580061353
  },
  {
    "x": "2000-12-25",
    "y1": 3.73167358128351,
    "y2": 0.129378180995719,
    "y3": 0.184900145827445
  },
  {
    "x": "2001-01-01",
    "y1": 3.70622545024613,
    "y2": 0.129378180995719,
    "y3": 0.170252580838573
  },
  {
    "x": "2001-01-08",
    "y1": 3.79712325787306,
    "y2": 0.209118067163485,
    "y3": 0.161862157717682
  },
  {
    "x": "2001-01-15",
    "y1": 3.85190333889819,
    "y2": 0.109788757599166,
    "y3": 0.147695642331217
  },
  {
    "x": "2001-01-22",
    "y1": 3.855845096519,
    "y2": 0.081538064116555,
    "y3": 0.134302330969973
  },
  {
    "x": "2001-01-29",
    "y1": 3.81241215267714,
    "y2": 0.0953154969688266,
    "y3": 0.121764811234926
  },
  {
    "x": "2001-02-05",
    "y1": 3.74117365265952,
    "y2": 0.166257608206057,
    "y3": 0.117839108514848
  },
  {
    "x": "2001-02-12",
    "y1": 3.72272337263542,
    "y2": 0.193354899151182,
    "y3": 0.118331366887517
  },
  {
    "x": "2001-02-19",
    "y1": 3.6555710579811,
    "y2": 0.166257608206057,
    "y3": 0.12027080719749
  },
  {
    "x": "2001-02-26",
    "y1": 3.5915359260578,
    "y2": 0.0822549306943977,
    "y3": 0.118471474646875
  },
  {
    "x": "2001-03-05",
    "y1": 3.56091213573355,
    "y2": 0.0794103629446893,
    "y3": 0.116529913708774
  },
  {
    "x": "2001-03-12",
    "y1": 3.48205809740162,
    "y2": 0.0332384767278715,
    "y3": 0.113844334381133
  },
  {
    "x": "2001-03-19",
    "y1": 3.50203261699723,
    "y2": 0.078641427919699,
    "y3": 0.114134474251375
  },
  {
    "x": "2001-03-26",
    "y1": 3.45618776897529,
    "y2": 0.0329501260935001,
    "y3": 0.113336704162947
  },
  {
    "x": "2001-04-02",
    "y1": 3.39103391909658,
    "y2": 0.0328540092153763,
    "y3": 0.108101111425984
  },
  {
    "x": "2001-04-09",
    "y1": 3.53116160772689,
    "y2": 0.126590791530128,
    "y3": 0.107941631161161
  },
  {
    "x": "2001-04-16",
    "y1": 3.63413742275343,
    "y2": 0.0517954745229476,
    "y3": 0.104364376587693
  },
  {
    "x": "2001-04-23",
    "y1": 3.59358570854629,
    "y2": 0.0787626326009843,
    "y3": 0.101877911276893
  },
  {
    "x": "2001-04-30",
    "y1": 3.64939879219675,
    "y2": 0.0964808574563316,
    "y3": 0.104801685047707
  },
  {
    "x": "2001-05-07",
    "y1": 3.61102373160804,
    "y2": 0.0850309910095801,
    "y3": 0.102919847205914
  },
  {
    "x": "2001-05-14",
    "y1": 3.65441779648245,
    "y2": 0.180283003726346,
    "y3": 0.105465088342445
  },
  {
    "x": "2001-05-21",
    "y1": 3.67813448373399,
    "y2": 0.155973102246811,
    "y3": 0.106794834405
  },
  {
    "x": "2001-05-28",
    "y1": 3.63300399388337,
    "y2": 0.0512187732542048,
    "y3": 0.0988998697095355
  },
  {
    "x": "2001-06-04",
    "y1": 3.66355155884908,
    "y2": 0.166269566156076,
    "y3": 0.101723910137381
  },
  {
    "x": "2001-06-11",
    "y1": 3.57927995227797,
    "y2": 0.0583960226397798,
    "y3": 0.100566808063542
  },
  {
    "x": "2001-06-18",
    "y1": 3.58243998833524,
    "y2": 0.140455810615525,
    "y3": 0.102823823745877
  },
  {
    "x": "2001-06-25",
    "y1": 3.64421392405186,
    "y2": 0.274581364914784,
    "y3": 0.108240011581314
  },
  {
    "x": "2001-07-02",
    "y1": 3.57183386996563,
    "y2": 0.154627225255992,
    "y3": 0.106303627886554
  },
  {
    "x": "2001-07-09",
    "y1": 3.61206519057262,
    "y2": 0.278041572527241,
    "y3": 0.111892826102613
  },
  {
    "x": "2001-07-16",
    "y1": 3.58548215683449,
    "y2": 0.109510761841087,
    "y3": 0.113255617659948
  },
  {
    "x": "2001-07-23",
    "y1": 3.58533430364417,
    "y2": 0.244729314520426,
    "y3": 0.121521565238735
  },
  {
    "x": "2001-07-30",
    "y1": 3.60369746155505,
    "y2": 0.169249189377914,
    "y3": 0.128322100871237
  },
  {
    "x": "2001-08-06",
    "y1": 3.55053068603119,
    "y2": 0.158087432868448,
    "y3": 0.132294401118674
  },
  {
    "x": "2001-08-13",
    "y1": 3.50480549613454,
    "y2": 0.199612851105522,
    "y3": 0.140627537369275
  },
  {
    "x": "2001-08-20",
    "y1": 3.53147382613924,
    "y2": 0.279675559455345,
    "y3": 0.152968614881274
  },
  {
    "x": "2001-08-27",
    "y1": 3.47337178509157,
    "y2": 0.20512437098838,
    "y3": 0.156895293854186
  },
  {
    "x": "2001-09-03",
    "y1": 3.40816288802182,
    "y2": 0.132765981676786,
    "y3": 0.160943819211878
  },
  {
    "x": "2001-09-10",
    "y1": 3.41271349176249,
    "y2": 0.142312047122404,
    "y3": 0.164121289937949
  },
  {
    "x": "2001-09-17",
    "y1": 3.25216537706689,
    "y2": 0.0380053820400558,
    "y3": 0.161197516167135
  },
  {
    "x": "2001-09-24",
    "y1": 3.30529258463214,
    "y2": 0.152150553272919,
    "y3": 0.164553494280302
  },
  {
    "x": "2001-10-01",
    "y1": 3.37634942779363,
    "y2": 0.134665848938326,
    "y3": 0.162272636540901
  },
  {
    "x": "2001-10-08",
    "y1": 3.43745948361001,
    "y2": 0.0737525969885273,
    "y3": 0.158161611277987
  },
  {
    "x": "2001-10-15",
    "y1": 3.41862071094336,
    "y2": 0.042544065587493,
    "y3": 0.157727875894652
  },
  {
    "x": "2001-10-22",
    "y1": 3.4770478722242,
    "y2": 0.0737525969885273,
    "y3": 0.153102027436274
  },
  {
    "x": "2001-10-29",
    "y1": 3.46391587320686,
    "y2": 0.203265292474226,
    "y3": 0.160345490927997
  },
  {
    "x": "2001-11-05",
    "y1": 3.51131724737457,
    "y2": 0.29092123419583,
    "y3": 0.167868762107012
  },
  {
    "x": "2001-11-12",
    "y1": 3.5496550888247,
    "y2": 0.296880480639505,
    "y3": 0.168983717893248
  },
  {
    "x": "2001-11-19",
    "y1": 3.55208848390108,
    "y2": 0.221099806215517,
    "y3": 0.172307346941224
  },
  {
    "x": "2001-11-26",
    "y1": 3.5664747835991,
    "y2": 0.331770907398444,
    "y3": 0.174993813684784
  },
  {
    "x": "2001-12-03",
    "y1": 3.61344515300885,
    "y2": 0.30437250221569,
    "y3": 0.184736900703514
  },
  {
    "x": "2001-12-10",
    "y1": 3.5797582619155,
    "y2": 0.442344483127479,
    "y3": 0.194617659133867
  },
  {
    "x": "2001-12-17",
    "y1": 3.57600022358526,
    "y2": 0.359274616584621,
    "y3": 0.204118930494202
  },
  {
    "x": "2001-12-24",
    "y1": 3.59729193696547,
    "y2": 0.494327067370394,
    "y3": 0.2209309122193
  },
  {
    "x": "2001-12-31",
    "y1": 3.633583047687,
    "y2": 0.568418906870939,
    "y3": 0.23937121500757
  },
  {
    "x": "2002-01-07",
    "y1": 3.61565535878262,
    "y2": 0.277273880053781,
    "y3": 0.239251131037492
  },
  {
    "x": "2002-01-14",
    "y1": 3.57010686986495,
    "y2": 0.106454461701679,
    "y3": 0.234317635573157
  },
  {
    "x": "2002-01-21",
    "y1": 3.57391966216158,
    "y2": 0.207898342584722,
    "y3": 0.238074253618554
  },
  {
    "x": "2002-01-28",
    "y1": 3.56026431736917,
    "y2": 0.169770979754449,
    "y3": 0.239447200250156
  },
  {
    "x": "2002-02-04",
    "y1": 3.51193967691403,
    "y2": 0.166383179073381,
    "y3": 0.245866090101822
  },
  {
    "x": "2002-02-11",
    "y1": 3.50441853551151,
    "y2": 0.112243396669023,
    "y3": 0.243870732271628
  },
  {
    "x": "2002-02-18",
    "y1": 3.45973655329839,
    "y2": 0.053999722402612,
    "y3": 0.239837425944842
  },
  {
    "x": "2002-02-25",
    "y1": 3.50508194940435,
    "y2": 0.155500781569773,
    "y3": 0.243924835173904
  },
  {
    "x": "2002-03-04",
    "y1": 3.57549146735954,
    "y2": 0.0811106436618708,
    "y3": 0.245853164077623
  },
  {
    "x": "2002-03-11",
    "y1": 3.54368810527194,
    "y2": 0.127481931859731,
    "y3": 0.248539630821183
  },
  {
    "x": "2002-03-18",
    "y1": 3.53463707827534,
    "y2": 0.124172686557026,
    "y3": 0.244585000525323
  },
  {
    "x": "2002-03-25",
    "y1": 3.53137464355618,
    "y2": 0.169770979754449,
    "y3": 0.238527487803254
  },
  {
    "x": "2002-04-01",
    "y1": 3.49055856677641,
    "y2": 0.169770979754449,
    "y3": 0.232172012759001
  },
  {
    "x": "2002-04-08",
    "y1": 3.48273944073812,
    "y2": 0.155500781569773,
    "y3": 0.228892061526714
  },
  {
    "x": "2002-04-15",
    "y1": 3.50588045395671,
    "y2": 0.0853419249858805,
    "y3": 0.216570612406086
  },
  {
    "x": "2002-04-22",
    "y1": 3.43189463189364,
    "y2": 0.0668404454771954,
    "y3": 0.204694009569161
  },
  {
    "x": "2002-04-29",
    "y1": 3.40132771647027,
    "y2": 0.14266005849519,
    "y3": 0.189709788337547
  },
  {
    "x": "2002-05-06",
    "y1": 3.39377667681836,
    "y2": 0.110246132504042,
    "y3": 0.177258364133518
  },
  {
    "x": "2002-05-13",
    "y1": 3.48156756366337,
    "y2": 0.300477103832229,
    "y3": 0.16756586595661
  },
  {
    "x": "2002-05-20",
    "y1": 3.43568466336995,
    "y2": 0.0972272414017944,
    "y3": 0.144006282683152
  },
  {
    "x": "2002-05-27",
    "y1": 3.40814311329467,
    "y2": 0.153916759534282,
    "y3": 0.137838426657177
  },
  {
    "x": "2002-06-03",
    "y1": 3.35847516074685,
    "y2": 0.226515222103893,
    "y3": 0.143841464677288
  },
  {
    "x": "2002-06-10",
    "y1": 3.33845536848295,
    "y2": 0.213655187071109,
    "y3": 0.144129306901607
  },
  {
    "x": "2002-06-17",
    "y1": 3.2960692886879,
    "y2": 0.393032838308267,
    "y3": 0.155292399829298
  },
  {
    "x": "2002-06-24",
    "y1": 3.31151038393216,
    "y2": 0.25068346604663,
    "y3": 0.159507414177961
  },
  {
    "x": "2002-07-01",
    "y1": 3.3013614811893,
    "y2": 0.114698387069265,
    "y3": 0.159630163697973
  },
  {
    "x": "2002-07-08",
    "y1": 3.2496754458744,
    "y2": 0.0621307184491293,
    "y3": 0.160036713500299
  },
  {
    "x": "2002-07-15",
    "y1": 3.21010502316895,
    "y2": 0.14266005849519,
    "y3": 0.15939467734657
  },
  {
    "x": "2002-07-22",
    "y1": 3.16687261727015,
    "y2": 0.133625071951553,
    "y3": 0.162020398761054
  },
  {
    "x": "2002-07-29",
    "y1": 3.15562174474867,
    "y2": 0.133625071951553,
    "y3": 0.162327555765645
  },
  {
    "x": "2002-08-05",
    "y1": 3.20225930895341,
    "y2": 0.0449647358589749,
    "y3": 0.158367158230742
  },
  {
    "x": "2002-08-12",
    "y1": 3.24428455537306,
    "y2": 0.0449647358589749,
    "y3": 0.152126846035969
  },
  {
    "x": "2002-08-19",
    "y1": 3.25869296178511,
    "y2": 0.0449647358589749,
    "y3": 0.145886533841195
  },
  {
    "x": "2002-08-26",
    "y1": 3.21105492976771,
    "y2": 0.041120060734023,
    "y3": 0.140167497799407
  },
  {
    "x": "2002-09-02",
    "y1": 3.1961863690035,
    "y2": 0.127761942386001,
    "y3": 0.142288498669413
  },
  {
    "x": "2002-09-09",
    "y1": 3.19317546475966,
    "y2": 0.131952146429442,
    "y3": 0.145544083717026
  },
  {
    "x": "2002-09-16",
    "y1": 3.13873063181516,
    "y2": 0.126320189214144,
    "y3": 0.144727090252974
  },
  {
    "x": "2002-09-23",
    "y1": 3.12077132312009,
    "y2": 0.124493968529792,
    "y3": 0.145439482054261
  },
  {
    "x": "2002-09-30",
    "y1": 3.07135339050348,
    "y2": 0.0340074117528619,
    "y3": 0.132115997450293
  },
  {
    "x": "2002-10-07",
    "y1": 3.13326228143919,
    "y2": 0.0834083332318833,
    "y3": 0.131425052041797
  },
  {
    "x": "2002-10-14",
    "y1": 3.19719613896684,
    "y2": 0.0589081235041087,
    "y3": 0.126674620240288
  },
  {
    "x": "2002-10-21",
    "y1": 3.23079452700856,
    "y2": 0.0856830478258978,
    "y3": 0.119633011526389
  },
  {
    "x": "2002-10-28",
    "y1": 3.25300869555754,
    "y2": 0.100753771055529,
    "y3": 0.11398794072561
  },
  {
    "x": "2002-11-04",
    "y1": 3.25196517242536,
    "y2": 0.214884928418038,
    "y3": 0.105080545231098
  },
  {
    "x": "2002-11-11",
    "y1": 3.29011771217715,
    "y2": 0.29092123419583,
    "y3": 0.107092433638558
  },
  {
    "x": "2002-11-18",
    "y1": 3.33093575644492,
    "y2": 0.301590207667571,
    "y3": 0.116437024668474
  },
  {
    "x": "2002-11-25",
    "y1": 3.3377715743087,
    "y2": 0.176926340980713,
    "y3": 0.122176805795053
  },
  {
    "x": "2002-12-02",
    "y1": 3.29967254215081,
    "y2": 0.0878937360227452,
    "y3": 0.119438489671431
  },
  {
    "x": "2002-12-09",
    "y1": 3.25747751112434,
    "y2": 0.166257608206057,
    "y3": 0.121070116484156
  },
  {
    "x": "2002-12-16",
    "y1": 3.25793992716527,
    "y2": 0.158013682838471,
    "y3": 0.122289547028502
  },
  {
    "x": "2002-12-23",
    "y1": 3.24712595137102,
    "y2": 0.151413134721638,
    "y3": 0.127611966971635
  },
  {
    "x": "2002-12-30",
    "y1": 3.27588038898263,
    "y2": 0.125850631122133,
    "y3": 0.131656261734793
  },
  {
    "x": "2003-01-06",
    "y1": 3.31959813891027,
    "y2": 0.151870770122486,
    "y3": 0.137001563447968
  },
  {
    "x": "2003-01-13",
    "y1": 3.2701893922297,
    "y2": 0.081538064116555,
    "y3": 0.139022463617095
  },
  {
    "x": "2003-01-20",
    "y1": 3.24544722130305,
    "y2": 0.220470213658386,
    "y3": 0.143657877180714
  },
  {
    "x": "2003-01-27",
    "y1": 3.22962921406309,
    "y2": 0.204408340135419,
    "y3": 0.147280686866013
  },
  {
    "x": "2003-02-03",
    "y1": 3.20052801679613,
    "y2": 0.191548305102635,
    "y3": 0.150542092660438
  },
  {
    "x": "2003-02-10",
    "y1": 3.2221270201841,
    "y2": 0.150069158425632,
    "y3": 0.15182085215523
  },
  {
    "x": "2003-02-17",
    "y1": 3.25177964105227,
    "y2": 0.0925915051007918,
    "y3": 0.154750056822626
  },
  {
    "x": "2003-02-24",
    "y1": 3.24325493435148,
    "y2": 0.0925915051007918,
    "y3": 0.155209215416071
  },
  {
    "x": "2003-03-03",
    "y1": 3.21915811337077,
    "y2": 0.212929871574994,
    "y3": 0.162910302819616
  },
  {
    "x": "2003-03-10",
    "y1": 3.24600265821795,
    "y2": 0.309760142308094,
    "y3": 0.174114157543726
  },
  {
    "x": "2003-03-17",
    "y1": 3.30681604927694,
    "y2": 0.370637605705422,
    "y3": 0.18760834927622
  },
  {
    "x": "2003-03-24",
    "y1": 3.27007493108489,
    "y2": 0.199033222949186,
    "y3": 0.186815764002778
  },
  {
    "x": "2003-03-31",
    "y1": 3.2802312062219,
    "y2": 0.211816767739652,
    "y3": 0.182860540679969
  },
  {
    "x": "2003-04-07",
    "y1": 3.26240695196597,
    "y2": 0.268401690901977,
    "y3": 0.181201114841689
  },
  {
    "x": "2003-04-14",
    "y1": 3.31145579886706,
    "y2": 0.442344483127479,
    "y3": 0.194472021949027
  },
  {
    "x": "2003-04-21",
    "y1": 3.31779746078393,
    "y2": 0.494327067370394,
    "y3": 0.21479368851641
  },
  {
    "x": "2003-04-28",
    "y1": 3.36543640006719,
    "y2": 0.479947242186734,
    "y3": 0.230478170215444
  },
  {
    "x": "2003-05-05",
    "y1": 3.37692768312049,
    "y2": 0.401477887342513,
    "y3": 0.242651380440646
  },
  {
    "x": "2003-05-12",
    "y1": 3.38901859821941,
    "y2": 0.329256464296697,
    "y3": 0.251543546919399
  },
  {
    "x": "2003-05-19",
    "y1": 3.37053337990388,
    "y2": 0.337012307590609,
    "y3": 0.262101630742822
  },
  {
    "x": "2003-05-26",
    "y1": 3.42736447626359,
    "y2": 0.537313774713097,
    "y3": 0.281373780972353
  },
  {
    "x": "2003-06-02",
    "y1": 3.44710870312524,
    "y2": 0.61167629177169,
    "y3": 0.30788069235511
  },
  {
    "x": "2003-06-09",
    "y1": 3.44653721347547,
    "y2": 0.491722152112897,
    "y3": 0.321443289277835
  },
  {
    "x": "2003-06-16",
    "y1": 3.45774538603,
    "y2": 0.568646094002425,
    "y3": 0.339655176971186
  },
  {
    "x": "2003-06-23",
    "y1": 3.44591360841184,
    "y2": 0.53735229043621,
    "y3": 0.356945376237864
  },
  {
    "x": "2003-06-30",
    "y1": 3.46941750990597,
    "y2": 0.696220305161846,
    "y3": 0.384252933574675
  },
  {
    "x": "2003-07-07",
    "y1": 3.51178107406036,
    "y2": 0.617920558448053,
    "y3": 0.410519386242038
  },
  {
    "x": "2003-07-14",
    "y1": 3.49711493821681,
    "y2": 0.470406940810911,
    "y3": 0.429410158027544
  },
  {
    "x": "2003-07-21",
    "y1": 3.5101087638954,
    "y2": 0.427776052345241,
    "y3": 0.440152467066056
  },
  {
    "x": "2003-07-28",
    "y1": 3.50139555162283,
    "y2": 0.392542842748557,
    "y3": 0.444291602088079
  },
  {
    "x": "2003-08-04",
    "y1": 3.45966721666284,
    "y2": 0.428618415725666,
    "y3": 0.447190642589092
  },
  {
    "x": "2003-08-11",
    "y1": 3.49493420049862,
    "y2": 0.425230615044599,
    "y3": 0.458500512193862
  },
  {
    "x": "2003-08-18",
    "y1": 3.53213135924632,
    "y2": 0.333857816088936,
    "y3": 0.464602564611326
  },
  {
    "x": "2003-08-25",
    "y1": 3.55769613291677,
    "y2": 0.331686066486094,
    "y3": 0.467766783390532
  },
  {
    "x": "2003-09-01",
    "y1": 3.58409290739351,
    "y2": 0.417479588435975,
    "y3": 0.466523538655957
  },
  {
    "x": "2003-09-08",
    "y1": 3.58236548738621,
    "y2": 0.476173953498338,
    "y3": 0.465615882962354
  },
  {
    "x": "2003-09-15",
    "y1": 3.60968036697024,
    "y2": 0.636122372490577,
    "y3": 0.473424639477547
  },
  {
    "x": "2003-09-22",
    "y1": 3.55005397887439,
    "y2": 0.52106630447702,
    "y3": 0.479404060334272
  },
  {
    "x": "2003-09-29",
    "y1": 3.59943821199724,
    "y2": 0.564834289590916,
    "y3": 0.491182951598983
  },
  {
    "x": "2003-10-06",
    "y1": 3.61791139475401,
    "y2": 0.47780891957627,
    "y3": 0.498222782198266
  },
  {
    "x": "2003-10-13",
    "y1": 3.61637113591762,
    "y2": 0.492235827021305,
    "y3": 0.495968884813676
  },
  {
    "x": "2003-10-20",
    "y1": 3.59191443326252,
    "y2": 0.476173953498338,
    "y3": 0.489193767900009
  },
  {
    "x": "2003-10-27",
    "y1": 3.62762431396393,
    "y2": 0.607559969069269,
    "y3": 0.494985658747827
  },
  {
    "x": "2003-11-03",
    "y1": 3.64756522622285,
    "y2": 0.732702834840896,
    "y3": 0.503188495789751
  },
  {
    "x": "2003-11-10",
    "y1": 3.62702472840511,
    "y2": 0.551210594644827,
    "y3": 0.503881411000182
  },
  {
    "x": "2003-11-17",
    "y1": 3.6081775240395,
    "y2": 0.511339270318354,
    "y3": 0.494637359258007
  },
  {
    "x": "2003-11-24",
    "y1": 3.64322726568716,
    "y2": 0.619810038180727,
    "y3": 0.494731833244641
  },
  {
    "x": "2003-12-01",
    "y1": 3.6317797723114,
    "y2": 0.637923889261838,
    "y3": 0.503107680667187
  },
  {
    "x": "2003-12-08",
    "y1": 3.63754916989261,
    "y2": 0.547630744724226,
    "y3": 0.509100415286136
  },
  {
    "x": "2003-12-15",
    "y1": 3.63858560885169,
    "y2": 0.425269130767711,
    "y3": 0.510736729687094
  },
  {
    "x": "2003-12-22",
    "y1": 3.64992326551115,
    "y2": 0.479938846008718,
    "y3": 0.513302751201247
  },
  {
    "x": "2003-12-29",
    "y1": 3.66692157217642,
    "y2": 0.561998633984464,
    "y3": 0.52014115214824
  },
  {
    "x": "2004-01-05",
    "y1": 3.70690795068039,
    "y2": 0.612748695182103,
    "y3": 0.534085696102898
  },
  {
    "x": "2004-01-12",
    "y1": 3.73256300265498,
    "y2": 0.517863128859625,
    "y3": 0.543394549221575
  },
  {
    "x": "2004-01-19",
    "y1": 3.72481240509522,
    "y2": 0.477086856138714,
    "y3": 0.546374912606712
  },
  {
    "x": "2004-01-26",
    "y1": 3.69763550083133,
    "y2": 0.509045254394362,
    "y3": 0.548018477651513
  },
  {
    "x": "2004-02-02",
    "y1": 3.69659980996703,
    "y2": 0.509045254394362,
    "y3": 0.541664621746702
  },
  {
    "x": "2004-02-09",
    "y1": 3.69153687368163,
    "y2": 0.503278241706934,
    "y3": 0.540775218608198
  },
  {
    "x": "2004-02-16",
    "y1": 3.68392569872845,
    "y2": 0.467959619096454,
    "y3": 0.535931485083475
  },
  {
    "x": "2004-02-23",
    "y1": 3.67994611787527,
    "y2": 0.374754779978472,
    "y3": 0.530778778103585
  },
  {
    "x": "2004-03-01",
    "y1": 3.68872032399454,
    "y2": 0.374754779978472,
    "y3": 0.524904725751443
  },
  {
    "x": "2004-03-08",
    "y1": 3.65800187180148,
    "y2": 0.331686066486094,
    "y3": 0.517680331400831
  },
  {
    "x": "2004-03-15",
    "y1": 3.63570160415743,
    "y2": 0.399104572513312,
    "y3": 0.507257561573033
  },
  {
    "x": "2004-03-22",
    "y1": 3.64577650823907,
    "y2": 0.422518152181514,
    "y3": 0.491748327440064
  },
  {
    "x": "2004-03-29",
    "y1": 3.69534227867798,
    "y2": 0.379260767280763,
    "y3": 0.483150836071861
  },
  {
    "x": "2004-04-05",
    "y1": 3.6932568704592,
    "y2": 0.310444236420735,
    "y3": 0.47310608437698
  },
  {
    "x": "2004-04-12",
    "y1": 3.66542285393611,
    "y2": 0.284510515208087,
    "y3": 0.456341108228348
  },
  {
    "x": "2004-04-19",
    "y1": 3.69249553352426,
    "y2": 0.399104572513312,
    "y3": 0.444400142390922
  },
  {
    "x": "2004-04-26",
    "y1": 3.62925917340478,
    "y2": 0.346065891669754,
    "y3": 0.434321899738198
  },
  {
    "x": "2004-05-03",
    "y1": 3.62811860446552,
    "y2": 0.375342600903507,
    "y3": 0.431825573244988
  },
  {
    "x": "2004-05-10",
    "y1": 3.6209704047029,
    "y2": 0.346065891669754,
    "y3": 0.42513192552804
  },
  {
    "x": "2004-05-17",
    "y1": 3.6250874932261,
    "y2": 0.205422971334261,
    "y3": 0.40730314239553
  },
  {
    "x": "2004-05-24",
    "y1": 3.66412855601523,
    "y2": 0.205422971334261,
    "y3": 0.386936856203137
  },
  {
    "x": "2004-05-31",
    "y1": 3.66004146099671,
    "y2": 0.178702479215845,
    "y3": 0.369978823720948
  },
  {
    "x": "2004-06-07",
    "y1": 3.67078126957665,
    "y2": 0.22531294579245,
    "y3": 0.357390128203635
  },
  {
    "x": "2004-06-14",
    "y1": 3.66421083515815,
    "y2": 0.173829551370397,
    "y3": 0.340629343052437
  },
  {
    "x": "2004-06-21",
    "y1": 3.68371020880994,
    "y2": 0.363853954439839,
    "y3": 0.333369778054711
  },
  {
    "x": "2004-06-28",
    "y1": 3.67442350656528,
    "y2": 0.267362815308422,
    "y3": 0.321574006734785
  },
  {
    "x": "2004-07-05",
    "y1": 3.64435858420803,
    "y2": 0.179119045104032,
    "y3": 0.307131978035164
  },
  {
    "x": "2004-07-12",
    "y1": 3.61189752515477,
    "y2": 0.183509731697804,
    "y3": 0.297569725621131
  },
  {
    "x": "2004-07-19",
    "y1": 3.59381077786848,
    "y2": 0.224548179607624,
    "y3": 0.290059395602588
  },
  {
    "x": "2004-07-26",
    "y1": 3.61450745582285,
    "y2": 0.183509731697804,
    "y3": 0.282650578863174
  },
  {
    "x": "2004-08-02",
    "y1": 3.55597597716456,
    "y2": 0.0728386305148765,
    "y3": 0.266337281763252
  },
  {
    "x": "2004-08-09",
    "y1": 3.5449060494914,
    "y2": 0.118241581706704,
    "y3": 0.251123453239512
  },
  {
    "x": "2004-08-16",
    "y1": 3.59088779917285,
    "y2": 0.0997336080711531,
    "y3": 0.237147095279031
  },
  {
    "x": "2004-08-23",
    "y1": 3.60398338356981,
    "y2": 0.0869500632806879,
    "y3": 0.225972386622029
  },
  {
    "x": "2004-08-30",
    "y1": 3.59452627587104,
    "y2": 0.103121408752221,
    "y3": 0.216902931299235
  },
  {
    "x": "2004-09-06",
    "y1": 3.62154206278803,
    "y2": 0.103121408752221,
    "y3": 0.202103773111181
  },
  {
    "x": "2004-09-13",
    "y1": 3.62987222350009,
    "y2": 0.120839633607568,
    "y3": 0.190842460208071
  },
  {
    "x": "2004-09-20",
    "y1": 3.61384680799647,
    "y2": 0.191781744844798,
    "y3": 0.181664417405136
  },
  {
    "x": "2004-09-27",
    "y1": 3.64721772514106,
    "y2": 0.191781744844798,
    "y3": 0.173950210063888
  },
  {
    "x": "2004-10-04",
    "y1": 3.63577195177702,
    "y2": 0.0869500632806879,
    "y3": 0.16802656466121
  },
  {
    "x": "2004-10-11",
    "y1": 3.63136043970529,
    "y2": 0.161498966607454,
    "y3": 0.165830364424869
  },
  {
    "x": "2004-10-18",
    "y1": 3.63326471103589,
    "y2": 0.118241581706704,
    "y3": 0.162807319549412
  },
  {
    "x": "2004-10-25",
    "y1": 3.66451567708963,
    "y2": 0.164640957683972,
    "y3": 0.159773720143988
  },
  {
    "x": "2004-11-01",
    "y1": 3.69689556331087,
    "y2": 0.281977269612845,
    "y3": 0.165181106056111
  },
  {
    "x": "2004-11-08",
    "y1": 3.71965255852298,
    "y2": 0.25068346604663,
    "y3": 0.15952258163645
  },
  {
    "x": "2004-11-15",
    "y1": 3.71259845489569,
    "y2": 0.225627895188403,
    "y3": 0.157435835630449
  },
  {
    "x": "2004-11-22",
    "y1": 3.72773398836344,
    "y2": 0.393032838308267,
    "y3": 0.168131525290661
  },
  {
    "x": "2004-11-29",
    "y1": 3.74961345899117,
    "y2": 0.384330187442848,
    "y3": 0.178172548077913
  },
  {
    "x": "2004-12-06",
    "y1": 3.74035355985905,
    "y2": 0.442344483127479,
    "y3": 0.189062363253906
  },
  {
    "x": "2004-12-13",
    "y1": 3.7437039583814,
    "y2": 0.411050679561264,
    "y3": 0.200439410647079
  },
  {
    "x": "2004-12-20",
    "y1": 3.75560924434849,
    "y2": 0.342737723802287,
    "y3": 0.21393436531145
  },
  {
    "x": "2004-12-27",
    "y1": 3.76246830490285,
    "y2": 0.267034430571442,
    "y3": 0.221374007754686
  },
  {
    "x": "2005-01-03",
    "y1": 3.72255461556963,
    "y2": 0.191622339575036,
    "y3": 0.225968444329881
  },
  {
    "x": "2005-01-10",
    "y1": 3.7222193709445,
    "y2": 0.277404198862132,
    "y3": 0.235491151108953
  },
  {
    "x": "2005-01-17",
    "y1": 3.69652865877966,
    "y2": 0.227260642470709,
    "y3": 0.241698112794877
  },
  {
    "x": "2005-01-24",
    "y1": 3.69729548742505,
    "y2": 0.29175142619534,
    "y3": 0.251129613667033
  },
  {
    "x": "2005-01-31",
    "y1": 3.72226316996824,
    "y2": 0.277273880053781,
    "y3": 0.258951325989344
  },
  {
    "x": "2005-02-07",
    "y1": 3.717470822187,
    "y2": 0.261212006530815,
    "y3": 0.262422839073645
  },
  {
    "x": "2005-02-14",
    "y1": 3.70878389429058,
    "y2": 0.248351971498031,
    "y3": 0.265251350406306
  },
  {
    "x": "2005-02-21",
    "y1": 3.71207725818013,
    "y2": 0.160995538980976,
    "y3": 0.268953624191321
  },
  {
    "x": "2005-02-28",
    "y1": 3.71459987139039,
    "y2": 0.249655875073554,
    "y3": 0.273361469614626
  },
  {
    "x": "2005-03-07",
    "y1": 3.70058944435154,
    "y2": 0.222376430004782,
    "y3": 0.278568212029529
  },
  {
    "x": "2005-03-14",
    "y1": 3.68402893449273,
    "y2": 0.222376430004782,
    "y3": 0.28145498564557
  },
  {
    "x": "2005-03-21",
    "y1": 3.67569639964434,
    "y2": 0.183509731697804,
    "y3": 0.276531608749818
  },
  {
    "x": "2005-03-28",
    "y1": 3.67255736826604,
    "y2": 0.183509731697804,
    "y3": 0.273172922032377
  },
  {
    "x": "2005-04-04",
    "y1": 3.67988296445054,
    "y2": 0.184003257569959,
    "y3": 0.271091690151455
  },
  {
    "x": "2005-04-11",
    "y1": 3.63426816349747,
    "y2": 0.138600306378131,
    "y3": 0.258370063554948
  },
  {
    "x": "2005-04-18",
    "y1": 3.64686671009213,
    "y2": 0.277404198862132,
    "y3": 0.253023764125912
  },
  {
    "x": "2005-04-25",
    "y1": 3.64141180280464,
    "y2": 0.184003257569959,
    "y3": 0.240106702848036
  },
  {
    "x": "2005-05-02",
    "y1": 3.66519342307434,
    "y2": 0.294992104909129,
    "y3": 0.234303774115429
  },
  {
    "x": "2005-05-09",
    "y1": 3.66998670023802,
    "y2": 0.405666731277816,
    "y3": 0.237450224489206
  },
  {
    "x": "2005-05-16",
    "y1": 3.70521571591824,
    "y2": 0.277273880053781,
    "y3": 0.237962196963323
  },
  {
    "x": "2005-05-23",
    "y1": 3.71953825767117,
    "y2": 0.277273880053781,
    "y3": 0.24224477398726
  },
  {
    "x": "2005-05-30",
    "y1": 3.71746667376161,
    "y2": 0.392091152566949,
    "y3": 0.247979121672501
  },
  {
    "x": "2005-06-06",
    "y1": 3.71339705426261,
    "y2": 0.337012307590609,
    "y3": 0.253466704928496
  },
  {
    "x": "2005-06-13",
    "y1": 3.72653816304684,
    "y2": 0.326715843681343,
    "y3": 0.255214925802796
  },
  {
    "x": "2005-06-20",
    "y1": 3.70891225532083,
    "y2": 0.318471918313756,
    "y3": 0.257274827715795
  },
  {
    "x": "2005-06-27",
    "y1": 3.71090911769998,
    "y2": 0.279866109779426,
    "y3": 0.258207532878225
  },
  {
    "x": "2005-07-04",
    "y1": 3.73789005086377,
    "y2": 0.268613985296174,
    "y3": 0.259220633568132
  },
  {
    "x": "2005-07-11",
    "y1": 3.75866744897403,
    "y2": 0.349317356853375,
    "y3": 0.268636724461752
  },
  {
    "x": "2005-07-18",
    "y1": 3.7693129300271,
    "y2": 0.329256464296697,
    "y3": 0.272616753922909
  },
  {
    "x": "2005-07-25",
    "y1": 3.77164811124753,
    "y2": 0.210307183800187,
    "y3": 0.27201329161268
  },
  {
    "x": "2005-08-01",
    "y1": 3.76848074089461,
    "y2": 0.267362815308422,
    "y3": 0.274262610877862
  },
  {
    "x": "2005-08-08",
    "y1": 3.75883387274418,
    "y2": 0.244771662607627,
    "y3": 0.277325707423353
  },
  {
    "x": "2005-08-15",
    "y1": 3.74894011563157,
    "y2": 0.222376430004782,
    "y3": 0.279269042338702
  },
  {
    "x": "2005-08-22",
    "y1": 3.74201451360835,
    "y2": 0.222376430004782,
    "y3": 0.281187700960443
  },
  {
    "x": "2005-08-29",
    "y1": 3.75158653162123,
    "y2": 0.179119045104032,
    "y3": 0.283213637896738
  },
  {
    "x": "2005-09-05",
    "y1": 3.7676719189774,
    "y2": 0.133716093912205,
    "y3": 0.276029232649242
  },
  {
    "x": "2005-09-12",
    "y1": 3.7607034784548,
    "y2": 0.133716093912205,
    "y3": 0.273514874466354
  },
  {
    "x": "2005-09-19",
    "y1": 3.74056321979356,
    "y2": 0.0948493956052264,
    "y3": 0.263507739001159
  },
  {
    "x": "2005-09-26",
    "y1": 3.7570263686705,
    "y2": 0.183509731697804,
    "y3": 0.252399889022158
  },
  {
    "x": "2005-10-03",
    "y1": 3.72851861642907,
    "y2": 0.227260642470709,
    "y3": 0.249899227143005
  },
  {
    "x": "2005-10-10",
    "y1": 3.7163101258227,
    "y2": 0.183509731697804,
    "y3": 0.245211019725206
  },
  {
    "x": "2005-10-17",
    "y1": 3.72472722657914,
    "y2": 0.187391058251026,
    "y3": 0.23497601500941
  },
  {
    "x": "2005-10-24",
    "y1": 3.72841077531768,
    "y2": 0.141988107059199,
    "y3": 0.225224804982839
  },
  {
    "x": "2005-10-31",
    "y1": 3.76647518728813,
    "y2": 0.248023127791248,
    "y3": 0.221290169188334
  },
  {
    "x": "2005-11-07",
    "y1": 3.78170501268172,
    "y2": 0.270614280492043,
    "y3": 0.218897287297249
  },
  {
    "x": "2005-11-14",
    "y1": 3.79287433529836,
    "y2": 0.353684147034901,
    "y3": 0.222588189160022
  },
  {
    "x": "2005-11-21",
    "y1": 3.80901210389256,
    "y2": 0.340108568324033,
    "y3": 0.226162918311415
  },
  {
    "x": "2005-11-28",
    "y1": 3.81359012492524,
    "y2": 0.385995108703037,
    "y3": 0.227996805903898
  },
  {
    "x": "2005-12-05",
    "y1": 3.8062705351264,
    "y2": 0.365934216146359,
    "y3": 0.229830693496382
  },
  {
    "x": "2005-12-12",
    "y1": 3.80438727924874,
    "y2": 0.494327067370394,
    "y3": 0.244031687674892
  },
  {
    "x": "2005-12-19",
    "y1": 3.80302875059575,
    "y2": 0.463033263804179,
    "y3": 0.25381521009968
  },
  {
    "x": "2005-12-26",
    "y1": 3.78342376128862,
    "y2": 0.283458458780592,
    "y3": 0.255749549908328
  },
  {
    "x": "2006-01-02",
    "y1": 3.82890470995778,
    "y2": 0.394720308045202,
    "y3": 0.264366743810349
  },
  {
    "x": "2006-01-09",
    "y1": 3.83385779038498,
    "y2": 0.479947242186734,
    "y3": 0.277245284419447
  },
  {
    "x": "2006-01-16",
    "y1": 3.80393164033076,
    "y2": 0.401477887342513,
    "y3": 0.288363226531371
  },
  {
    "x": "2006-01-23",
    "y1": 3.8290818074015,
    "y2": 0.491016373789511,
    "y3": 0.306228240525236
  },
  {
    "x": "2006-01-30",
    "y1": 3.81100639709229,
    "y2": 0.307756316687028,
    "y3": 0.314930251663977
  },
  {
    "x": "2006-02-06",
    "y1": 3.81069692945432,
    "y2": 0.370454502556672,
    "y3": 0.328710507011549
  },
  {
    "x": "2006-02-13",
    "y1": 3.819751444137,
    "y2": 0.205422971334261,
    "y3": 0.329806168993372
  },
  {
    "x": "2006-02-20",
    "y1": 3.82180192321144,
    "y2": 0.205422971334261,
    "y3": 0.32871428543655
  },
  {
    "x": "2006-02-27",
    "y1": 3.82860550265386,
    "y2": 0.294083307426838,
    "y3": 0.334242964223001
  },
  {
    "x": "2006-03-06",
    "y1": 3.81099060780736,
    "y2": 0.205422971334261,
    "y3": 0.335144559877163
  },
  {
    "x": "2006-03-13",
    "y1": 3.83063656483678,
    "y2": 0.294083307426838,
    "y3": 0.342749319895545
  },
  {
    "x": "2006-03-20",
    "y1": 3.83338538032372,
    "y2": 0.299512391319441,
    "y3": 0.345323783071955
  },
  {
    "x": "2006-03-27",
    "y1": 3.845046456372,
    "y2": 0.281794166464094,
    "y3": 0.345882777370557
  },
  {
    "x": "2006-04-03",
    "y1": 3.84471735866734,
    "y2": 0.205422971334261,
    "y3": 0.338469718585525
  },
  {
    "x": "2006-04-10",
    "y1": 3.83919799072624,
    "y2": 0.205422971334261,
    "y3": 0.331735438736037
  },
  {
    "x": "2006-04-17",
    "y1": 3.84639885363749,
    "y2": 0.267362815308422,
    "y3": 0.325803824066306
  },
  {
    "x": "2006-04-24",
    "y1": 3.83773848206932,
    "y2": 0.267362815308422,
    "y3": 0.320875254024409
  },
  {
    "x": "2006-05-01",
    "y1": 3.84634963239476,
    "y2": 0.267362815308422,
    "y3": 0.309527041421311
  },
  {
    "x": "2006-05-08",
    "y1": 3.80417798493933,
    "y2": 0.15611132651505,
    "y3": 0.294180944556854
  },
  {
    "x": "2006-05-15",
    "y1": 3.78193866297691,
    "y2": 0.222376430004782,
    "y3": 0.291126843118064
  },
  {
    "x": "2006-05-22",
    "y1": 3.78945513391235,
    "y2": 0.246943412210469,
    "y3": 0.283737998326327
  },
  {
    "x": "2006-05-29",
    "y1": 3.79354485393325,
    "y2": 0.158283076117891,
    "y3": 0.267654790022885
  },
  {
    "x": "2006-06-05",
    "y1": 3.75553932234785,
    "y2": 0.0948493956052264,
    "y3": 0.252323365436021
  },
  {
    "x": "2006-06-12",
    "y1": 3.75314589673844,
    "y2": 0.0948493956052264,
    "y3": 0.232515016526806
  },
  {
    "x": "2006-06-19",
    "y1": 3.74916459170163,
    "y2": 0.227260642470709,
    "y3": 0.22849023281599
  },
  {
    "x": "2006-06-26",
    "y1": 3.77302546076249,
    "y2": 0.227260642470709,
    "y3": 0.221330539811692
  },
  {
    "x": "2006-07-03",
    "y1": 3.75367542112501,
    "y2": 0.138600306378131,
    "y3": 0.217989406563886
  },
  {
    "x": "2006-07-10",
    "y1": 3.71015078780128,
    "y2": 0.0948493956052264,
    "y3": 0.212460727777434
  },
  {
    "x": "2006-07-17",
    "y1": 3.70182626764483,
    "y2": 0.183509731697804,
    "y3": 0.206932048990982
  },
  {
    "x": "2006-07-24",
    "y1": 3.73832906037048,
    "y2": 0.234879724475786,
    "y3": 0.208404886648059
  },
  {
    "x": "2006-07-31",
    "y1": 3.73398845075686,
    "y2": 0.0948493956052264,
    "y3": 0.198443191056978
  },
  {
    "x": "2006-08-07",
    "y1": 3.72087601352496,
    "y2": 0.0820658508147611,
    "y3": 0.187570864031744
  },
  {
    "x": "2006-08-14",
    "y1": 3.77250622004151,
    "y2": 0.0970211452080681,
    "y3": 0.178332212968943
  },
  {
    "x": "2006-08-21",
    "y1": 3.76157255122142,
    "y2": 0.0820658508147611,
    "y3": 0.172164356942968
  },
  {
    "x": "2006-08-28",
    "y1": 3.78627475142884,
    "y2": 0.188393944163731,
    "y3": 0.171312905584441
  },
  {
    "x": "2006-09-04",
    "y1": 3.77379509917195,
    "y2": 0.0997336080711531,
    "y3": 0.162931445222578
  },
  {
    "x": "2006-09-11",
    "y1": 3.80602354586771,
    "y2": 0.278165465201336,
    "y3": 0.163471577717224
  },
  {
    "x": "2006-09-18",
    "y1": 3.79857130480606,
    "y2": 0.188393944163731,
    "y3": 0.159523134159989
  },
  {
    "x": "2006-09-25",
    "y1": 3.81637267808818,
    "y2": 0.189505129108758,
    "y3": 0.161192824289674
  },
  {
    "x": "2006-10-02",
    "y1": 3.83477486892505,
    "y2": 0.278165465201336,
    "y3": 0.163982276049502
  },
  {
    "x": "2006-10-09",
    "y1": 3.85968804205685,
    "y2": 0.189505129108758,
    "y3": 0.161110361894417
  },
  {
    "x": "2006-10-16",
    "y1": 3.85332904932113,
    "y2": 0.30437250221569,
    "y3": 0.168414833199306
  },
  {
    "x": "2006-10-23",
    "y1": 3.8568811426422,
    "y2": 0.184066855022056,
    "y3": 0.172875706170148
  },
  {
    "x": "2006-10-30",
    "y1": 3.84844503764165,
    "y2": 0.255008966259287,
    "y3": 0.180883684702851
  },
  {
    "x": "2006-11-06",
    "y1": 3.87372828094242,
    "y2": 0.384330187442848,
    "y3": 0.188737161951458
  },
  {
    "x": "2006-11-13",
    "y1": 3.89722063042562,
    "y2": 0.316017231683871,
    "y3": 0.193174991412116
  },
  {
    "x": "2006-11-20",
    "y1": 3.90310808993324,
    "y2": 0.353684147034901,
    "y3": 0.203929183444954
  },
  {
    "x": "2006-11-27",
    "y1": 3.8839840751375,
    "y2": 0.211900361711603,
    "y3": 0.209781731750273
  },
  {
    "x": "2006-12-04",
    "y1": 3.89399155350668,
    "y2": 0.411050679561264,
    "y3": 0.221158779143446
  },
  {
    "x": "2006-12-11",
    "y1": 3.90213144374678,
    "y2": 0.299995351562927,
    "y3": 0.224414560497803
  },
  {
    "x": "2006-12-18",
    "y1": 3.87933312832905,
    "y2": 0.269160273494545,
    "y3": 0.233130104392269
  },
  {
    "x": "2006-12-25",
    "y1": 3.88520945073036,
    "y2": 0.262559725377713,
    "y3": 0.242154798120417
  },
  {
    "x": "2007-01-01",
    "y1": 3.89305942345862,
    "y2": 0.168614620986054,
    "y3": 0.245734471909316
  },
  {
    "x": "2007-01-08",
    "y1": 3.92122829204623,
    "y2": 0.342737723802287,
    "y3": 0.258768065558692
  },
  {
    "x": "2007-01-15",
    "y1": 3.90064750383184,
    "y2": 0.160995538980976,
    "y3": 0.257398145299555
  },
  {
    "x": "2007-01-22",
    "y1": 3.89419378399174,
    "y2": 0.160995538980976,
    "y3": 0.260461241845046
  },
  {
    "x": "2007-01-29",
    "y1": 3.91077767172689,
    "y2": 0.269534564911264,
    "y3": 0.260029696830542
  },
  {
    "x": "2007-02-05",
    "y1": 3.90429116381324,
    "y2": 0.365934216146359,
    "y3": 0.268906710429674
  },
  {
    "x": "2007-02-12",
    "y1": 3.91912557820954,
    "y2": 0.494327067370394,
    "y3": 0.284147807342755
  },
  {
    "x": "2007-02-19",
    "y1": 3.92665270369534,
    "y2": 0.374372927711601,
    "y3": 0.288958180468269
  },
  {
    "x": "2007-02-26",
    "y1": 3.86816592704842,
    "y2": 0.178702479215845,
    "y3": 0.288418047973623
  },
  {
    "x": "2007-03-05",
    "y1": 3.87642185983057,
    "y2": 0.437977692945952,
    "y3": 0.295098307510136
  },
  {
    "x": "2007-03-12",
    "y1": 3.87018528408798,
    "y2": 0.417916800389274,
    "y3": 0.306790804778497
  },
  {
    "x": "2007-03-19",
    "y1": 3.90233064935587,
    "y2": 0.401854926866308,
    "y3": 0.314133102808848
  },
  {
    "x": "2007-03-26",
    "y1": 3.89118699076854,
    "y2": 0.300334555740946,
    "y3": 0.309933321223753
  },
  {
    "x": "2007-04-02",
    "y1": 3.91171035407488,
    "y2": 0.432771690908727,
    "y3": 0.315771044184996
  },
  {
    "x": "2007-04-09",
    "y1": 3.92004585335179,
    "y2": 0.497665467042082,
    "y3": 0.322970110185355
  },
  {
    "x": "2007-04-16",
    "y1": 3.93387040449745,
    "y2": 0.466371663475867,
    "y3": 0.335693675273568
  },
  {
    "x": "2007-04-23",
    "y1": 3.94606965705539,
    "y2": 0.51225820385487,
    "y3": 0.340754051488248
  },
  {
    "x": "2007-04-30",
    "y1": 3.95191193893074,
    "y2": 0.403536975205615,
    "y3": 0.345931132670383
  },
  {
    "x": "2007-05-07",
    "y1": 3.94805138180241,
    "y2": 0.476135437775226,
    "y3": 0.356279890884417
  },
  {
    "x": "2007-05-14",
    "y1": 3.94657999387539,
    "y2": 0.405803387555169,
    "y3": 0.36344207399329
  },
  {
    "x": "2007-05-21",
    "y1": 3.94608750436429,
    "y2": 0.42349318340023,
    "y3": 0.376186002113998
  },
  {
    "x": "2007-05-28",
    "y1": 3.96827200444783,
    "y2": 0.416892635283398,
    "y3": 0.379893747688054
  },
  {
    "x": "2007-06-04",
    "y1": 3.9528239861384,
    "y2": 0.322947530891739,
    "y3": 0.387991347283592
  },
  {
    "x": "2007-06-11",
    "y1": 3.97348421332273,
    "y2": 0.292782528355081,
    "y3": 0.394580696752297
  },
  {
    "x": "2007-06-18",
    "y1": 3.95911262279261,
    "y2": 0.289394727674014,
    "y3": 0.395573704890435
  },
  {
    "x": "2007-06-25",
    "y1": 3.96462449618832,
    "y2": 0.346065891669754,
    "y3": 0.394580288666605
  },
  {
    "x": "2007-07-02",
    "y1": 3.98893277082085,
    "y2": 0.346065891669754,
    "y3": 0.387167229881573
  },
  {
    "x": "2007-07-09",
    "y1": 4.00411740920064,
    "y2": 0.257405555577176,
    "y3": 0.381318861274851
  },
  {
    "x": "2007-07-16",
    "y1": 3.99695084017819,
    "y2": 0.257405555577176,
    "y3": 0.385254015092918
  },
  {
    "x": "2007-07-23",
    "y1": 3.95030695609321,
    "y2": 0.205422971334261,
    "y3": 0.373626279012333
  },
  {
    "x": "2007-07-30",
    "y1": 3.93040640406501,
    "y2": 0.294083307426838,
    "y3": 0.367434604364211
  },
  {
    "x": "2007-08-06",
    "y1": 3.94380208055207,
    "y2": 0.267362815308422,
    "y3": 0.360709998786317
  },
  {
    "x": "2007-08-13",
    "y1": 3.9281393741232,
    "y2": 0.179119045104032,
    "y3": 0.354649223254471
  },
  {
    "x": "2007-08-20",
    "y1": 3.95674578253799,
    "y2": 0.158283076117891,
    "y3": 0.34092479251493
  },
  {
    "x": "2007-08-27",
    "y1": 3.96437967193211,
    "y2": 0.213694984481255,
    "y3": 0.326726268386888
  },
  {
    "x": "2007-09-03",
    "y1": 3.95257077217188,
    "y2": 0.180874228818686,
    "y3": 0.312451396654029
  },
  {
    "x": "2007-09-10",
    "y1": 3.96678910680298,
    "y2": 0.269534564911264,
    "y3": 0.300315214706849
  },
  {
    "x": "2007-09-17",
    "y1": 3.99332072293875,
    "y2": 0.240929258959694,
    "y3": 0.292184828894553
  },
  {
    "x": "2007-09-24",
    "y1": 4.00465637841788,
    "y2": 0.330912815629077,
    "y3": 0.284923697787246
  },
  {
    "x": "2007-10-01",
    "y1": 4.03383278721276,
    "y2": 0.31319459077373,
    "y3": 0.280293257948174
  },
  {
    "x": "2007-10-08",
    "y1": 4.04295399004472,
    "y2": 0.31319459077373,
    "y3": 0.274778328316849
  },
  {
    "x": "2007-10-15",
    "y1": 4.01425505734637,
    "y2": 0.311871370196924,
    "y3": 0.269527265062525
  },
  {
    "x": "2007-10-22",
    "y1": 4.04325520113452,
    "y2": 0.417916800389274,
    "y3": 0.274275728537402
  },
  {
    "x": "2007-10-29",
    "y1": 4.04546259133832,
    "y2": 0.401854926866308,
    "y3": 0.279729348462963
  },
  {
    "x": "2007-11-05",
    "y1": 3.98054612131873,
    "y2": 0.269534564911264,
    "y3": 0.278736340324826
  },
  {
    "x": "2007-11-12",
    "y1": 3.98408503356006,
    "y2": 0.269534564911264,
    "y3": 0.274909773986901
  },
  {
    "x": "2007-11-19",
    "y1": 3.96867502433503,
    "y2": 0.201514277706877,
    "y3": 0.267682193288757
  },
  {
    "x": "2007-11-26",
    "y1": 3.99346122970387,
    "y2": 0.388994891833524,
    "y3": 0.274261660101575
  },
  {
    "x": "2007-12-03",
    "y1": 4.01044756239411,
    "y2": 0.29003809183168,
    "y3": 0.2758932869143
  },
  {
    "x": "2007-12-10",
    "y1": 3.98442547790461,
    "y2": 0.217926265805265,
    "y3": 0.27651845163785
  },
  {
    "x": "2007-12-17",
    "y1": 4.00576673319095,
    "y2": 0.302355320573833,
    "y3": 0.2769320522952
  },
  {
    "x": "2007-12-24",
    "y1": 3.99925481102167,
    "y2": 0.231413209336602,
    "y3": 0.275134571996609
  },
  {
    "x": "2007-12-31",
    "y1": 3.93576159703681,
    "y2": 0.222376430004782,
    "y3": 0.277297441241646
  },
  {
    "x": "2008-01-07",
    "y1": 3.90992566648342,
    "y2": 0.183509731697804,
    "y3": 0.278558774020642
  },
  {
    "x": "2008-01-14",
    "y1": 3.86897387083495,
    "y2": 0.170726186907339,
    "y3": 0.276410334141946
  },
  {
    "x": "2008-01-21",
    "y1": 3.86306790924316,
    "y2": 0.161498966607454,
    "y3": 0.275441571031384
  },
  {
    "x": "2008-01-28",
    "y1": 3.90053681048963,
    "y2": 0.0842376004176029,
    "y3": 0.266176722806701
  },
  {
    "x": "2008-02-04",
    "y1": 3.85557459808216,
    "y2": 0.0728386305148765,
    "y3": 0.257772191384461
  },
  {
    "x": "2008-02-11",
    "y1": 3.86292863433341,
    "y2": 0.0728386305148765,
    "y3": 0.24486848212875
  },
  {
    "x": "2008-02-18",
    "y1": 3.85498223465047,
    "y2": 0.0728386305148765,
    "y3": 0.232850684115808
  },
  {
    "x": "2008-02-25",
    "y1": 3.84114581559288,
    "y2": 0.153329031966931,
    "y3": 0.224857406175468
  },
  {
    "x": "2008-03-03",
    "y1": 3.8151759674139,
    "y2": 0.153329031966931,
    "y3": 0.216930289263968
  },
  {
    "x": "2008-03-10",
    "y1": 3.8151759674139,
    "y2": 0.0599589688462875,
    "y3": 0.199032397686819
  },
  {
    "x": "2008-03-17",
    "y1": 3.83579532270539,
    "y2": 0.155500781569773,
    "y3": 0.186714690421992
  },
  {
    "x": "2008-03-24",
    "y1": 3.83715478883977,
    "y2": 0.0668404454771954,
    "y3": 0.176579984450289
  },
  {
    "x": "2008-03-31",
    "y1": 3.88571352903187,
    "y2": 0.0906266932849622,
    "y3": 0.167634590868974
  },
  {
    "x": "2008-04-07",
    "y1": 3.85166010348653,
    "y2": 0.0668404454771954,
    "y3": 0.16090089925749
  },
  {
    "x": "2008-04-14",
    "y1": 3.90088201077548,
    "y2": 0.185887577494372,
    "y3": 0.150745533540532
  },
  {
    "x": "2008-04-21",
    "y1": 3.90918838213294,
    "y2": 0.216751447804534,
    "y3": 0.147081201339175
  },
  {
    "x": "2008-04-28",
    "y1": 3.93150023601191,
    "y2": 0.299695494468192,
    "y3": 0.151169662772321
  },
  {
    "x": "2008-05-05",
    "y1": 3.91879531155635,
    "y2": 0.300477103832229,
    "y3": 0.151075751935241
  },
  {
    "x": "2008-05-12",
    "y1": 3.95286989588176,
    "y2": 0.25068346604663,
    "y3": 0.152039264770742
  },
  {
    "x": "2008-05-19",
    "y1": 3.91958196953956,
    "y2": 0.255360640417325,
    "y3": 0.153688475291369
  },
  {
    "x": "2008-05-26",
    "y1": 3.95148402287466,
    "y2": 0.239298766894358,
    "y3": 0.156477927051197
  },
  {
    "x": "2008-06-02",
    "y1": 3.93241690515311,
    "y2": 0.183181346960824,
    "y3": 0.157100685053871
  },
  {
    "x": "2008-06-09",
    "y1": 3.92431039000748,
    "y2": 0.151857412893506,
    "y3": 0.156618607368174
  },
  {
    "x": "2008-06-16",
    "y1": 3.90458746798289,
    "y2": 0.169770979754449,
    "y3": 0.160895276335016
  },
  {
    "x": "2008-06-23",
    "y1": 3.86699111798195,
    "y2": 0.110071647066181,
    "y3": 0.162756927162581
  },
  {
    "x": "2008-06-30",
    "y1": 3.83665380003601,
    "y2": 0.14266005849519,
    "y3": 0.166247998561597
  },
  {
    "x": "2008-07-07",
    "y1": 3.83384812571082,
    "y2": 0.0994026735944394,
    "y3": 0.167576200715575
  },
  {
    "x": "2008-07-14",
    "y1": 3.85336504768195,
    "y2": 0.110246132504042,
    "y3": 0.165422055742431
  },
  {
    "x": "2008-07-21",
    "y1": 3.86552127808692,
    "y2": 0.0648431813122143,
    "y3": 0.160997763209695
  },
  {
    "x": "2008-07-28",
    "y1": 3.8657073529854,
    "y2": 0.0648431813122143,
    "y3": 0.161241973832991
  },
  {
    "x": "2008-08-04",
    "y1": 3.91033821568408,
    "y2": 0.114698387069265,
    "y3": 0.159201854107966
  },
  {
    "x": "2008-08-11",
    "y1": 3.92625301636376,
    "y2": 0.132416611924613,
    "y3": 0.162480662430337
  },
  {
    "x": "2008-08-18",
    "y1": 3.91083619680973,
    "y2": 0.132416611924613,
    "y3": 0.164570158362319
  },
  {
    "x": "2008-08-25",
    "y1": 3.89129350134335,
    "y2": 0.185887577494372,
    "y3": 0.170522514963178
  },
  {
    "x": "2008-09-01",
    "y1": 3.8441386153032,
    "y2": 0.153503517404792,
    "y3": 0.168903311958699
  },
  {
    "x": "2008-09-08",
    "y1": 3.84652798752103,
    "y2": 0.177717642853849,
    "y3": 0.166951621711165
  },
  {
    "x": "2008-09-15",
    "y1": 3.85211329255025,
    "y2": 0.134460257953099,
    "y3": 0.15868985988541
  },
  {
    "x": "2008-09-22",
    "y1": 3.81228752257692,
    "y2": 0.0648431813122143,
    "y3": 0.14690816375941
  },
  {
    "x": "2008-09-29",
    "y1": 3.70421912107097,
    "y2": 0.053999722402612,
    "y3": 0.137073976577209
  },
  {
    "x": "2008-10-06",
    "y1": 3.55125540931209,
    "y2": 0.129780396826601,
    "y3": 0.130794964397672
  },
  {
    "x": "2008-10-13",
    "y1": 3.58870897366218,
    "y2": 0.135796821554394,
    "y3": 0.125619867130674
  },
  {
    "x": "2008-10-20",
    "y1": 3.49564467355507,
    "y2": 0.0865230119258504,
    "y3": 0.120786950378926
  },
  {
    "x": "2008-10-27",
    "y1": 3.60448272351955,
    "y2": 0.0498489483249017,
    "y3": 0.115686527150495
  },
  {
    "x": "2008-11-03",
    "y1": 3.56174474226233,
    "y2": 0.0498489483249017,
    "y3": 0.109690425579018
  },
  {
    "x": "2008-11-10",
    "y1": 3.48249862905764,
    "y2": 0.041120060734023,
    "y3": 0.10624284626241
  },
  {
    "x": "2008-11-17",
    "y1": 3.39514654933148,
    "y2": 0.126320189214144,
    "y3": 0.105425852798358
  },
  {
    "x": "2008-11-24",
    "y1": 3.50438191132086,
    "y2": 0.143917678225709,
    "y3": 0.107651603029921
  },
  {
    "x": "2008-12-01",
    "y1": 3.48728084226258,
    "y2": 0.143917678225709,
    "y3": 0.109335180316005
  },
  {
    "x": "2008-12-08",
    "y1": 3.5080916173121,
    "y2": 0.0693533467458928,
    "y3": 0.109560688587689
  },
  {
    "x": "2008-12-15",
    "y1": 3.5234091156471,
    "y2": 0.0552573421331315,
    "y3": 0.109081396628734
  },
  {
    "x": "2008-12-22",
    "y1": 3.50162331911901,
    "y2": 0.0552573421331315,
    "y3": 0.106109344381928
  },
  {
    "x": "2008-12-29",
    "y1": 3.56825990642157,
    "y2": 0.143917678225709,
    "y3": 0.106684397696983
  },
  {
    "x": "2009-01-05",
    "y1": 3.53112007970322,
    "y2": 0.0552573421331315,
    "y3": 0.102826434207408
  },
  {
    "x": "2009-01-12",
    "y1": 3.50423010796459,
    "y2": 0.129933691988843,
    "y3": 0.100028739932132
  },
  {
    "x": "2009-01-19",
    "y1": 3.47020218823009,
    "y2": 0.126320189214144,
    "y3": 0.0986695735225996
  },
  {
    "x": "2009-01-26",
    "y1": 3.46961327535978,
    "y2": 0.126320189214144,
    "y3": 0.0960997008406143
  },
  {
    "x": "2009-02-02",
    "y1": 3.54770075288014,
    "y2": 0.142283691297605,
    "y3": 0.0964908725078396
  },
  {
    "x": "2009-02-09",
    "y1": 3.51167033465485,
    "y2": 0.0376598531215662,
    "y3": 0.0951317060983072
  },
  {
    "x": "2009-02-16",
    "y1": 3.4509740145136,
    "y2": 0.035833632437214,
    "y3": 0.0942234016000373
  },
  {
    "x": "2009-02-23",
    "y1": 3.40699073945863,
    "y2": 0.123340565992306,
    "y3": 0.0939014100583226
  },
  {
    "x": "2009-03-02",
    "y1": 3.34603301409292,
    "y2": 0.122091046576697,
    "y3": 0.0932161213094377
  },
  {
    "x": "2009-03-09",
    "y1": 3.45242094701514,
    "y2": 0.129378180995719,
    "y3": 0.0953588797629311
  },
  {
    "x": "2009-03-16",
    "y1": 3.47042305636286,
    "y2": 0.0501631475925702,
    "y3": 0.0953745897263145
  },
  {
    "x": "2009-03-23",
    "y1": 3.53076186143133,
    "y2": 0.114604956381648,
    "y3": 0.0986123901291519
  },
  {
    "x": "2009-03-30",
    "y1": 3.58038006384401,
    "y2": 0.197166703562691,
    "y3": 0.106414722270585
  },
  {
    "x": "2009-04-06",
    "y1": 3.59929036124001,
    "y2": 0.165872899996476,
    "y3": 0.108392357809702
  },
  {
    "x": "2009-04-13",
    "y1": 3.61171360469631,
    "y2": 0.229477665230827,
    "y3": 0.112670357159958
  },
  {
    "x": "2009-04-20",
    "y1": 3.62439693142781,
    "y2": 0.209416772674149,
    "y3": 0.11594531188238
  },
  {
    "x": "2009-04-27",
    "y1": 3.63909920290145,
    "y2": 0.29092123419583,
    "y3": 0.127023706254877
  },
  {
    "x": "2009-05-04",
    "y1": 3.65061621627423,
    "y2": 0.180494864118399,
    "y3": 0.13328558235414
  },
  {
    "x": "2009-05-11",
    "y1": 3.61676918616982,
    "y2": 0.123000223305307,
    "y3": 0.136672726412749
  },
  {
    "x": "2009-05-18",
    "y1": 3.62383407065189,
    "y2": 0.158013682838471,
    "y3": 0.137377526643387
  },
  {
    "x": "2009-05-25",
    "y1": 3.6724862333542,
    "y2": 0.216370045728865,
    "y3": 0.145433161823173
  },
  {
    "x": "2009-06-01",
    "y1": 3.71480648367427,
    "y2": 0.212929871574994,
    "y3": 0.149582970802481
  },
  {
    "x": "2009-06-08",
    "y1": 3.71987834656097,
    "y2": 0.181636068008779,
    "y3": 0.152348764742213
  },
  {
    "x": "2009-06-15",
    "y1": 3.70302334478455,
    "y2": 0.156580497150552,
    "y3": 0.153861780139033
  },
  {
    "x": "2009-06-22",
    "y1": 3.70890579438555,
    "y2": 0.309760142308094,
    "y3": 0.162235602689558
  },
  {
    "x": "2009-06-29",
    "y1": 3.68622083184762,
    "y2": 0.331770907398444,
    "y3": 0.176941155403402
  },
  {
    "x": "2009-07-06",
    "y1": 3.6636828195827,
    "y2": 0.442344483127479,
    "y3": 0.197266697937915
  },
  {
    "x": "2009-07-13",
    "y1": 3.73804370970197,
    "y2": 0.451069682469644,
    "y3": 0.213653153761782
  },
  {
    "x": "2009-07-20",
    "y1": 3.78010326424798,
    "y2": 0.533108227882111,
    "y3": 0.234204012827052
  },
  {
    "x": "2009-07-27",
    "y1": 3.78648184738887,
    "y2": 0.42741160855516,
    "y3": 0.249105684205024
  },
  {
    "x": "2009-08-03",
    "y1": 3.79747502403785,
    "y2": 0.491722152112897,
    "y3": 0.271183634431041
  },
  {
    "x": "2009-08-10",
    "y1": 3.79011095431219,
    "y2": 0.62024561384136,
    "y3": 0.296465667304026
  },
  {
    "x": "2009-08-17",
    "y1": 3.80792996622583,
    "y2": 0.730396029765925,
    "y3": 0.323127133614188
  },
  {
    "x": "2009-08-24",
    "y1": 3.81182426828042,
    "y2": 0.575129150426455,
    "y3": 0.343589946135687
  },
  {
    "x": "2009-08-31",
    "y1": 3.80690010726749,
    "y2": 0.53735229043621,
    "y3": 0.358983677395956
  },
  {
    "x": "2009-09-07",
    "y1": 3.83767110368383,
    "y2": 0.557699670769811,
    "y3": 0.376397822300739
  },
  {
    "x": "2009-09-14",
    "y1": 3.86264116832731,
    "y2": 0.492235827021305,
    "y3": 0.386463551942013
  },
  {
    "x": "2009-09-21",
    "y1": 3.84297734443143,
    "y2": 0.476173953498338,
    "y3": 0.40124750641101
  },
  {
    "x": "2009-09-28",
    "y1": 3.82250319140183,
    "y2": 0.475918410542053,
    "y3": 0.418893415772847
  },
  {
    "x": "2009-10-05",
    "y1": 3.86701736158468,
    "y2": 0.551974254558133,
    "y3": 0.43859144435883
  },
  {
    "x": "2009-10-12",
    "y1": 3.87520704189362,
    "y2": 0.661177943348803,
    "y3": 0.460831839239827
  },
  {
    "x": "2009-10-19",
    "y1": 3.87412670154113,
    "y2": 0.576266165503054,
    "y3": 0.47899865393623
  },
  {
    "x": "2009-10-26",
    "y1": 3.82336712408651,
    "y2": 0.527401143841321,
    "y3": 0.496286907727857
  },
  {
    "x": "2009-11-02",
    "y1": 3.85628953732441,
    "y2": 0.508162454172861,
    "y3": 0.513866005578973
  },
  {
    "x": "2009-11-09",
    "y1": 3.88253404270397,
    "y2": 0.599999606410932,
    "y3": 0.528377978784115
  },
  {
    "x": "2009-11-16",
    "y1": 3.8724597558751,
    "y2": 0.585386319248905,
    "y3": 0.541058749376638
  },
  {
    "x": "2009-11-23",
    "y1": 3.86891830393669,
    "y2": 0.644042498748318,
    "y3": 0.55114365015768
  },
  {
    "x": "2009-11-30",
    "y1": 3.89506360508236,
    "y2": 0.723063540434435,
    "y3": 0.564743343055919
  },
  {
    "x": "2009-12-07",
    "y1": 3.8932224954678,
    "y2": 0.676353460416454,
    "y3": 0.571905604682637
  },
  {
    "x": "2009-12-14",
    "y1": 3.90298361706272,
    "y2": 0.656292567859776,
    "y3": 0.583349652647867
  },
  {
    "x": "2009-12-21",
    "y1": 3.93644219487446,
    "y2": 0.491931329623133,
    "y3": 0.583360111523379
  },
  {
    "x": "2009-12-28",
    "y1": 3.92920585071296,
    "y2": 0.425269130767711,
    "y3": 0.573611287369697
  },
  {
    "x": "2010-01-04",
    "y1": 3.95036796939082,
    "y2": 0.552482584361372,
    "y3": 0.564715615099469
  },
  {
    "x": "2010-01-11",
    "y1": 3.93777505103591,
    "y2": 0.422556667904626,
    "y3": 0.557086990973378
  },
  {
    "x": "2010-01-18",
    "y1": 3.90162980935004,
    "y2": 0.473507388274048,
    "y3": 0.55389474586527
  },
  {
    "x": "2010-01-25",
    "y1": 3.87535664782482,
    "y2": 0.463415116071049,
    "y3": 0.549180518130332
  },
  {
    "x": "2010-02-01",
    "y1": 3.8724554066739,
    "y2": 0.420346402578672,
    "y3": 0.5455860469082
  },
  {
    "x": "2010-02-08",
    "y1": 3.89226275506549,
    "y2": 0.435134215839225,
    "y3": 0.543534060025244
  },
  {
    "x": "2010-02-15",
    "y1": 3.91989694698455,
    "y2": 0.419502118080283,
    "y3": 0.540713245402156
  },
  {
    "x": "2010-02-22",
    "y1": 3.91739675440259,
    "y2": 0.376926529581314,
    "y3": 0.531960859153315
  },
  {
    "x": "2010-03-01",
    "y1": 3.95675325789472,
    "y2": 0.376926529581314,
    "y3": 0.51774828846494
  },
  {
    "x": "2010-03-08",
    "y1": 3.9745106085595,
    "y2": 0.394644754436661,
    "y3": 0.50866721791162
  },
  {
    "x": "2010-03-15",
    "y1": 3.9773615247597,
    "y2": 0.420353339806904,
    "y3": 0.5033148277099
  },
  {
    "x": "2010-03-22",
    "y1": 3.98608789108653,
    "y2": 0.491295451044134,
    "y3": 0.502471477553463
  },
  {
    "x": "2010-03-29",
    "y1": 3.98919845113004,
    "y2": 0.52106630447702,
    "y3": 0.498524812456768
  },
  {
    "x": "2010-04-05",
    "y1": 4.01062124205874,
    "y2": 0.600957055670561,
    "y3": 0.499303349277851
  },
  {
    "x": "2010-04-12",
    "y1": 4.0217090195678,
    "y2": 0.402635114951556,
    "y3": 0.487232980088012
  },
  {
    "x": "2010-04-19",
    "y1": 4.04141267512413,
    "y2": 0.376926529581314,
    "y3": 0.469926129545356
  },
  {
    "x": "2010-04-26",
    "y1": 4.01415738844186,
    "y2": 0.331686066486094,
    "y3": 0.452692759848839
  },
  {
    "x": "2010-05-03",
    "y1": 3.93470393158416,
    "y2": 0.346065891669754,
    "y3": 0.437181426039337
  },
  {
    "x": "2010-05-10",
    "y1": 3.97054820028024,
    "y2": 0.401276322116154,
    "y3": 0.432648675663988
  },
  {
    "x": "2010-05-17",
    "y1": 3.92034897421488,
    "y2": 0.250825922526088,
    "y3": 0.423926515251907
  },
  {
    "x": "2010-05-24",
    "y1": 3.93291043543106,
    "y2": 0.304980256371845,
    "y3": 0.411551398852431
  },
  {
    "x": "2010-05-31",
    "y1": 3.9161317711043,
    "y2": 0.205422971334261,
    "y3": 0.400694714023913
  },
  {
    "x": "2010-06-07",
    "y1": 3.92714047104225,
    "y2": 0.205422971334261,
    "y3": 0.387290493176923
  },
  {
    "x": "2010-06-14",
    "y1": 3.95664659882368,
    "y2": 0.294083307426838,
    "y3": 0.378823902744713
  },
  {
    "x": "2010-06-21",
    "y1": 3.91927536904854,
    "y2": 0.178702479215845,
    "y3": 0.366741706576571
  },
  {
    "x": "2010-06-28",
    "y1": 3.86004841734984,
    "y2": 0.222376430004782,
    "y3": 0.356103817284849
  },
  {
    "x": "2010-07-05",
    "y1": 3.91008207759056,
    "y2": 0.246943412210469,
    "y3": 0.347475881991358
  },
  {
    "x": "2010-07-12",
    "y1": 3.90216024794247,
    "y2": 0.179119045104032,
    "y3": 0.337585507767494
  },
  {
    "x": "2010-07-19",
    "y1": 3.94365535812758,
    "y2": 0.183586691681771,
    "y3": 0.327918515872517
  },
  {
    "x": "2010-07-26",
    "y1": 3.93714722198922,
    "y2": 0.223211034104346,
    "y3": 0.319346829855901
  },
  {
    "x": "2010-08-02",
    "y1": 3.95212483331782,
    "y2": 0.223211034104346,
    "y3": 0.309489714570774
  },
  {
    "x": "2010-08-09",
    "y1": 3.90187729163867,
    "y2": 0.222376430004782,
    "y3": 0.296043763518806
  },
  {
    "x": "2010-08-16",
    "y1": 3.9047666807075,
    "y2": 0.222376430004782,
    "y3": 0.281109269795194
  },
  {
    "x": "2010-08-23",
    "y1": 3.89277906425612,
    "y2": 0.222376430004782,
    "y3": 0.262180238511905
  },
  {
    "x": "2010-08-30",
    "y1": 3.92998142563999,
    "y2": 0.179119045104032,
    "y3": 0.251004435019529
  },
  {
    "x": "2010-09-06",
    "y1": 3.93388964297351,
    "y2": 0.180499937401967,
    "y3": 0.241183105410562
  },
  {
    "x": "2010-09-13",
    "y1": 3.96650091602391,
    "y2": 0.203091090102762,
    "y3": 0.234753356591395
  },
  {
    "x": "2010-09-20",
    "y1": 3.99483464244485,
    "y2": 0.180499937401967,
    "y3": 0.226475058878006
  },
  {
    "x": "2010-09-27",
    "y1": 3.99043774890627,
    "y2": 0.203091090102762,
    "y3": 0.216565797277336
  },
  {
    "x": "2010-10-04",
    "y1": 4.00358123181648,
    "y2": 0.262559725377713,
    "y3": 0.217152487419917
  },
  {
    "x": "2010-10-11",
    "y1": 4.0314174579317,
    "y2": 0.385995108703037,
    "y3": 0.221203230036477
  },
  {
    "x": "2010-10-18",
    "y1": 4.03571914377642,
    "y2": 0.494327067370394,
    "y3": 0.235648434838284
  },
  {
    "x": "2010-10-25",
    "y1": 4.04702031896275,
    "y2": 0.521432027001305,
    "y3": 0.251448887621636
  },
  {
    "x": "2010-11-01",
    "y1": 4.0755637445964,
    "y2": 0.479947242186734,
    "y3": 0.260742084359631
  },
  {
    "x": "2010-11-08",
    "y1": 4.0520001574451,
    "y2": 0.376422316484286,
    "y3": 0.270628076223053
  },
  {
    "x": "2010-11-15",
    "y1": 4.05196447982036,
    "y2": 0.401854926866308,
    "y3": 0.279602001066129
  },
  {
    "x": "2010-11-22",
    "y1": 4.05849313637413,
    "y2": 0.388994891833524,
    "y3": 0.286704575047282
  },
  {
    "x": "2010-11-29",
    "y1": 4.08094275328134,
    "y2": 0.378698427924258,
    "y3": 0.296683544188293
  },
  {
    "x": "2010-12-06",
    "y1": 4.09872426594971,
    "y2": 0.281794166464094,
    "y3": 0.301593917927409
  },
  {
    "x": "2010-12-13",
    "y1": 4.10078297655134,
    "y2": 0.275193618347262,
    "y3": 0.304193047139555
  },
  {
    "x": "2010-12-20",
    "y1": 4.10934536174828,
    "y2": 0.26990885004818,
    "y3": 0.306527937936747
  },
  {
    "x": "2010-12-27",
    "y1": 4.10456970898629,
    "y2": 0.298967519892765,
    "y3": 0.310357492431146
  },
  {
    "x": "2011-01-03",
    "y1": 4.12353023191638,
    "y2": 0.29625505702968,
    "y3": 0.314051423782391
  },
  {
    "x": "2011-01-10",
    "y1": 4.14281504510229,
    "y2": 0.354337904816748,
    "y3": 0.320649497522989
  },
  {
    "x": "2011-01-17",
    "y1": 4.11894831240521,
    "y2": 0.178702479215845,
    "y3": 0.32062866922858
  },
  {
    "x": "2011-01-24",
    "y1": 4.11796295935381,
    "y2": 0.29625505702968,
    "y3": 0.326416425209965
  },
  {
    "x": "2011-01-31",
    "y1": 4.14863416641653,
    "y2": 0.537313774713097,
    "y3": 0.343127559440482
  },
  {
    "x": "2011-02-07",
    "y1": 4.16312876500476,
    "y2": 0.402356037696933,
    "y3": 0.35422036445523
  },
  {
    "x": "2011-02-14",
    "y1": 4.17185292721388,
    "y2": 0.523015955679112,
    "y3": 0.370216607734048
  },
  {
    "x": "2011-02-21",
    "y1": 4.15318643583076,
    "y2": 0.423597867762293,
    "y3": 0.378268514853277
  },
  {
    "x": "2011-02-28",
    "y1": 4.15448805679526,
    "y2": 0.580382488205475,
    "y3": 0.387987883828399
  },
  {
    "x": "2011-03-07",
    "y1": 4.12968805665498,
    "y2": 0.476135437775226,
    "y3": 0.38707830234864
  },
  {
    "x": "2011-03-14",
    "y1": 4.10319670380935,
    "y2": 0.358569186140758,
    "y3": 0.378935160305613
  },
  {
    "x": "2011-03-21",
    "y1": 4.14079222051753,
    "y2": 0.463275402742442,
    "y3": 0.378101568333398
  },
  {
    "x": "2011-03-28",
    "y1": 4.1577586879183,
    "y2": 0.562879081314997,
    "y3": 0.387424406574934
  },
  {
    "x": "2011-04-04",
    "y1": 4.15446783064132,
    "y2": 0.446605688697993,
    "y3": 0.389661944666518
  },
  {
    "x": "2011-04-11",
    "y1": 4.14879601847828,
    "y2": 0.430543815175026,
    "y3": 0.391739390833593
  },
  {
    "x": "2011-04-18",
    "y1": 4.16887451366805,
    "y2": 0.361907585812445,
    "y3": 0.390899848728002
  },
  {
    "x": "2011-04-25",
    "y1": 4.18780256335911,
    "y2": 0.50634411623482,
    "y3": 0.402127346216539
  },
  {
    "x": "2011-05-02",
    "y1": 4.17180140108411,
    "y2": 0.354288503807368,
    "y3": 0.406082090489544
  },
  {
    "x": "2011-05-09",
    "y1": 4.17212320224501,
    "y2": 0.496047652325554,
    "y3": 0.417389030603413
  },
  {
    "x": "2011-05-16",
    "y1": 4.1632315036927,
    "y2": 0.487803726957967,
    "y3": 0.426830840956673
  },
  {
    "x": "2011-05-23",
    "y1": 4.16092710719855,
    "y2": 0.487803726957967,
    "y3": 0.436408274453087
  },
  {
    "x": "2011-05-30",
    "y1": 4.1380156723524,
    "y2": 0.422518152181514,
    "y3": 0.439817286821326
  },
  {
    "x": "2011-06-06",
    "y1": 4.10542978989078,
    "y2": 0.332085216002756,
    "y3": 0.447486423660671
  },
  {
    "x": "2011-06-13",
    "y1": 4.09512238323378,
    "y2": 0.346065891669754,
    "y3": 0.449976965392675
  },
  {
    "x": "2011-06-20",
    "y1": 4.10903799213626,
    "y2": 0.250825922526088,
    "y3": 0.435652572783324
  },
  {
    "x": "2011-06-27",
    "y1": 4.17053324573693,
    "y2": 0.315328448886661,
    "y3": 0.431301193342811
  },
  {
    "x": "2011-07-04",
    "y1": 4.18607996535334,
    "y2": 0.315328448886661,
    "y3": 0.420916818003188
  },
  {
    "x": "2011-07-11",
    "y1": 4.16159931512441,
    "y2": 0.259577305180018,
    "y3": 0.412715789874074
  },
  {
    "x": "2011-07-18",
    "y1": 4.18634303441923,
    "y2": 0.348237641272595,
    "y3": 0.401108547527431
  },
  {
    "x": "2011-07-25",
    "y1": 4.15050662843749,
    "y2": 0.294083307426838,
    "y3": 0.392005941010011
  },
  {
    "x": "2011-08-01",
    "y1": 4.06925151113682,
    "y2": 0.183509731697804,
    "y3": 0.383252968287863
  },
  {
    "x": "2011-08-08",
    "y1": 4.05960460068847,
    "y2": 0.224548179607624,
    "y3": 0.371316607131122
  },
  {
    "x": "2011-08-15",
    "y1": 3.99336009559993,
    "y2": 0.127468802006589,
    "y3": 0.349546093165702
  },
  {
    "x": "2011-08-22",
    "y1": 4.05229239011451,
    "y2": 0.185681481300646,
    "y3": 0.336499882795835
  },
  {
    "x": "2011-08-29",
    "y1": 4.05248594232527,
    "y2": 0.0970211452080681,
    "y3": 0.319823749297487
  },
  {
    "x": "2011-09-05",
    "y1": 4.0475107626105,
    "y2": 0.0820658508147611,
    "y3": 0.305831662547603
  },
  {
    "x": "2011-09-12",
    "y1": 4.11003940696076,
    "y2": 0.15150415668229,
    "y3": 0.288089664569976
  },
  {
    "x": "2011-09-19",
    "y1": 4.05700217070062,
    "y2": 0.0820658508147611,
    "y3": 0.274478531920346
  },
  {
    "x": "2011-09-26",
    "y1": 4.02968690845809,
    "y2": 0.170726186907339,
    "y3": 0.258212458649435
  },
  {
    "x": "2011-10-03",
    "y1": 4.05616293640297,
    "y2": 0.170726186907339,
    "y3": 0.242358581646904
  },
  {
    "x": "2011-10-10",
    "y1": 4.13219092461576,
    "y2": 0.20129779446789,
    "y3": 0.2280332850224
  },
  {
    "x": "2011-10-17",
    "y1": 4.1207996786288,
    "y2": 0.189505129108758,
    "y3": 0.216382633868762
  },
  {
    "x": "2011-10-24",
    "y1": 4.15859738660644,
    "y2": 0.273078698649475,
    "y3": 0.213432308001098
  },
  {
    "x": "2011-10-31",
    "y1": 4.13996486671547,
    "y2": 0.112637458375312,
    "y3": 0.201760886336376
  },
  {
    "x": "2011-11-07",
    "y1": 4.13721003075591,
    "y2": 0.20129779446789,
    "y3": 0.199284479933466
  },
  {
    "x": "2011-11-14",
    "y1": 4.0975460083574,
    "y2": 0.170726186907339,
    "y3": 0.1920543668345
  },
  {
    "x": "2011-11-21",
    "y1": 4.04662667298932,
    "y2": 0.161498966607454,
    "y3": 0.184362892720539
  },
  {
    "x": "2011-11-28",
    "y1": 4.1225714453365,
    "y2": 0.207898342584722,
    "y3": 0.181778944590775
  },
  {
    "x": "2011-12-05",
    "y1": 4.13015450485236,
    "y2": 0.205567002631725,
    "y3": 0.174645412658731
  },
  {
    "x": "2011-12-12",
    "y1": 4.09557754878964,
    "y2": 0.112637458375312,
    "y3": 0.165573120206155
  },
  {
    "x": "2011-12-19",
    "y1": 4.12035314040307,
    "y2": 0.112637458375312,
    "y3": 0.16202950654003
  },
  {
    "x": "2011-12-26",
    "y1": 4.11520161488304,
    "y2": 0.0842376004176029,
    "y3": 0.155013977580529
  },
  {
    "x": "2012-01-02",
    "y1": 4.14171451085776,
    "y2": 0.196013026168808,
    "y3": 0.15844118878864
  },
  {
    "x": "2012-01-09",
    "y1": 4.15534463536928,
    "y2": 0.205567002631725,
    "y3": 0.159435464855194
  },
  {
    "x": "2012-01-16",
    "y1": 4.1833930630599,
    "y2": 0.189505129108758,
    "y3": 0.164059664050229
  },
  {
    "x": "2012-01-23",
    "y1": 4.1941046926502,
    "y2": 0.189505129108758,
    "y3": 0.169431627964929
  },
  {
    "x": "2012-01-30",
    "y1": 4.22574264040061,
    "y2": 0.30437250221569,
    "y3": 0.177075045241599
  },
  {
    "x": "2012-02-06",
    "y1": 4.22513003281724,
    "y2": 0.290796923504822,
    "y3": 0.187511598876102
  },
  {
    "x": "2012-02-13",
    "y1": 4.24162525590408,
    "y2": 0.442344483127479,
    "y3": 0.201092513687109
  },
  {
    "x": "2012-02-20",
    "y1": 4.24568042620278,
    "y2": 0.411050679561264,
    "y3": 0.213108738319805
  },
  {
    "x": "2012-02-27",
    "y1": 4.24987779150224,
    "y2": 0.385995108703037,
    "y3": 0.222343604031562
  },
  {
    "x": "2012-03-05",
    "y1": 4.25396024145455,
    "y2": 0.494327067370394,
    "y3": 0.237584700944644
  },
  {
    "x": "2012-03-12",
    "y1": 4.27635391818036,
    "y2": 0.504108363313202,
    "y3": 0.24913618417783
  },
  {
    "x": "2012-03-19",
    "y1": 4.28049756293364,
    "y2": 0.401477887342513,
    "y3": 0.26357820562619
  },
  {
    "x": "2012-03-26",
    "y1": 4.28820641684334,
    "y2": 0.329256464296697,
    "y3": 0.269976139117631
  },
  {
    "x": "2012-04-02",
    "y1": 4.28462568986171,
    "y2": 0.229811582221178,
    "y3": 0.272930408883323
  },
  {
    "x": "2012-04-09",
    "y1": 4.2621715681688,
    "y2": 0.311871370196924,
    "y3": 0.280449029062796
  },
  {
    "x": "2012-04-16",
    "y1": 4.2585585046152,
    "y2": 0.272247027774349,
    "y3": 0.283666463322277
  },
  {
    "x": "2012-04-23",
    "y1": 4.2814717346703,
    "y2": 0.401854926866308,
    "y3": 0.293480859534007
  },
  {
    "x": "2012-04-30",
    "y1": 4.24469998141969,
    "y2": 0.376422316484286,
    "y3": 0.306670102439455
  },
  {
    "x": "2012-05-07",
    "y1": 4.2370824479622,
    "y2": 0.427698096332083,
    "y3": 0.322423134337294
  },
  {
    "x": "2012-05-14",
    "y1": 4.18424006987336,
    "y2": 0.411636222809116,
    "y3": 0.338793065456869
  },
  {
    "x": "2012-05-21",
    "y1": 4.20537876312065,
    "y2": 0.363853954439839,
    "y3": 0.347185111870421
  },
  {
    "x": "2012-05-28",
    "y1": 4.17364339894886,
    "y2": 0.315311801240007,
    "y3": 0.352672351800835
  },
  {
    "x": "2012-06-04",
    "y1": 4.21402219777356,
    "y2": 0.327439515371857,
    "y3": 0.35956907111399
  },
  {
    "x": "2012-06-11",
    "y1": 4.21905299357899,
    "y2": 0.207594720937102,
    "y3": 0.360473550705407
  },
  {
    "x": "2012-06-18",
    "y1": 4.22588252320633,
    "y2": 0.327439515371857,
    "y3": 0.361626901363216
  },
  {
    "x": "2012-06-25",
    "y1": 4.24062109094703,
    "y2": 0.497665467042082,
    "y3": 0.371970328540079
  },
  {
    "x": "2012-07-02",
    "y1": 4.24139791902797,
    "y2": 0.360794997530586,
    "y3": 0.367892854260234
  },
  {
    "x": "2012-07-09",
    "y1": 4.23157263325678,
    "y2": 0.29625505702968,
    "y3": 0.362153073133655
  },
  {
    "x": "2012-07-16",
    "y1": 4.23735920774252,
    "y2": 0.29625505702968,
    "y3": 0.357666070549987
  },
  {
    "x": "2012-07-23",
    "y1": 4.24856832766703,
    "y2": 0.294083307426838,
    "y3": 0.347653882552809
  },
  {
    "x": "2012-07-30",
    "y1": 4.25188459396104,
    "y2": 0.250825922526088,
    "y3": 0.334989760513454
  },
  {
    "x": "2012-08-06",
    "y1": 4.26972893063706,
    "y2": 0.275193618347262,
    "y3": 0.328675547063691
  },
  {
    "x": "2012-08-13",
    "y1": 4.28817731238497,
    "y2": 0.353373236584505,
    "y3": 0.329881385678081
  },
  {
    "x": "2012-08-20",
    "y1": 4.28596705731885,
    "y2": 0.523015955679112,
    "y3": 0.344541604350978
  },
  {
    "x": "2012-08-27",
    "y1": 4.28504514471604,
    "y2": 0.405803387555169,
    "y3": 0.34923820521889
  },
  {
    "x": "2012-09-03",
    "y1": 4.30769296595341,
    "y2": 0.42349318340023,
    "y3": 0.356800513000184
  },
  {
    "x": "2012-09-10",
    "y1": 4.32284719608866,
    "y2": 0.51225820385487,
    "y3": 0.362320676849613
  },
  {
    "x": "2012-09-17",
    "y1": 4.32159403875404,
    "y2": 0.403536975205615,
    "y3": 0.363676409785679
  },
  {
    "x": "2012-09-24",
    "y1": 4.30155291205697,
    "y2": 0.32823229919082,
    "y3": 0.358703119928616
  },
  {
    "x": "2012-10-01",
    "y1": 4.30795807504642,
    "y2": 0.390958914070751,
    "y3": 0.357669254491698
  },
  {
    "x": "2012-10-08",
    "y1": 4.27859766139013,
    "y2": 0.358569186140758,
    "y3": 0.357405016076744
  },
  {
    "x": "2012-10-15",
    "y1": 4.26595357531042,
    "y2": 0.294083307426838,
    "y3": 0.356343591386085
  },
  {
    "x": "2012-10-22",
    "y1": 4.26007453360632,
    "y2": 0.224105430407672,
    "y3": 0.351176887137876
  },
  {
    "x": "2012-10-29",
    "y1": 4.25812668693737,
    "y2": 0.133716093912205,
    "y3": 0.347482955786631
  },
  {
    "x": "2012-11-05",
    "y1": 4.23221910790458,
    "y2": 0.133716093912205,
    "y3": 0.337796784713648
  },
  {
    "x": "2012-11-12",
    "y1": 4.21440755961233,
    "y2": 0.0948493956052264,
    "y3": 0.317655981141806
  },
  {
    "x": "2012-11-19",
    "y1": 4.25426561708417,
    "y2": 0.224548179607624,
    "y3": 0.310843640245657
  },
  {
    "x": "2012-11-26",
    "y1": 4.26889051930366,
    "y2": 0.135887843515046,
    "y3": 0.302825279569926
  },
  {
    "x": "2012-12-03",
    "y1": 4.25819371397374,
    "y2": 0.135887843515046,
    "y3": 0.294806918894194
  },
  {
    "x": "2012-12-10",
    "y1": 4.25594056732377,
    "y2": 0.0948493956052264,
    "y3": 0.284845223303114
  },
  {
    "x": "2012-12-17",
    "y1": 4.27266032929379,
    "y2": 0.183509731697804,
    "y3": 0.281479413761699
  },
  {
    "x": "2012-12-24",
    "y1": 4.25256772748987,
    "y2": 0.183509731697804,
    "y3": 0.276895219429226
  },
  {
    "x": "2012-12-31",
    "y1": 4.30031605476569,
    "y2": 0.234879724475786,
    "y3": 0.27097054382379
  },
  {
    "x": "2013-01-07",
    "y1": 4.30804416532015,
    "y2": 0.22796223523457,
    "y3": 0.256217857801563
  },
  {
    "x": "2013-01-14",
    "y1": 4.31094920477314,
    "y2": 0.22796223523457,
    "y3": 0.247325800185533
  },
  {
    "x": "2013-01-21",
    "y1": 4.31573433647174,
    "y2": 0.163937613238556,
    "y3": 0.23434802167745
  },
  {
    "x": "2013-01-28",
    "y1": 4.32506539777048,
    "y2": 0.371402371890248,
    "y3": 0.227305230079219
  },
  {
    "x": "2013-02-04",
    "y1": 4.32971137275633,
    "y2": 0.411050679561264,
    "y3": 0.227680915297001
  },
  {
    "x": "2013-02-11",
    "y1": 4.32913524166048,
    "y2": 0.405666731277816,
    "y3": 0.231552636901351
  },
  {
    "x": "2013-02-18",
    "y1": 4.31967105721979,
    "y2": 0.322676831245609,
    "y3": 0.228138532760094
  },
  {
    "x": "2013-02-25",
    "y1": 4.32217591888293,
    "y2": 0.463033263804179,
    "y3": 0.233361736643265
  },
  {
    "x": "2013-03-04",
    "y1": 4.34572047685395,
    "y2": 0.394720308045202,
    "y3": 0.238393586674183
  },
  {
    "x": "2013-03-11",
    "y1": 4.34716912512838,
    "y2": 0.329256464296697,
    "y3": 0.243651138368634
  },
  {
    "x": "2013-03-18",
    "y1": 4.34591643796752,
    "y2": 0.31319459077373,
    "y3": 0.25262506321171
  },
  {
    "x": "2013-03-25",
    "y1": 4.35285635153647,
    "y2": 0.223211034104346,
    "y3": 0.257099810221317
  },
  {
    "x": "2013-04-01",
    "y1": 4.33337371279857,
    "y2": 0.306586601897842,
    "y3": 0.267686670535948
  },
  {
    "x": "2013-04-08",
    "y1": 4.36180499278455,
    "y2": 0.388994891833524,
    "y3": 0.275909006147243
  },
  {
    "x": "2013-04-15",
    "y1": 4.33482737737448,
    "y2": 0.210307183800187,
    "y3": 0.2796299731615
  },
  {
    "x": "2013-04-22",
    "y1": 4.35765912407731,
    "y2": 0.29625505702968,
    "y3": 0.287648333837232
  },
  {
    "x": "2013-04-29",
    "y1": 4.38796165353547,
    "y2": 0.29003809183168,
    "y3": 0.297407768648555
  },
  {
    "x": "2013-05-06",
    "y1": 4.40511363446339,
    "y2": 0.281794166464094,
    "y3": 0.302321990386869
  },
  {
    "x": "2013-05-13",
    "y1": 4.42326827982587,
    "y2": 0.275193618347262,
    "y3": 0.306906184719342
  },
  {
    "x": "2013-05-20",
    "y1": 4.41188490744528,
    "y2": 0.275193618347262,
    "y3": 0.308921879412916
  },
  {
    "x": "2013-05-27",
    "y1": 4.41095115496083,
    "y2": 0.358569186140758,
    "y3": 0.315452226958225
  },
  {
    "x": "2013-06-03",
    "y1": 4.41480254545776,
    "y2": 0.294083307426838,
    "y3": 0.318758280567839
  },
  {
    "x": "2013-06-10",
    "y1": 4.40164111075631,
    "y2": 0.294083307426838,
    "y3": 0.325265565277253
  },
  {
    "x": "2013-06-17",
    "y1": 4.38227236668323,
    "y2": 0.267362815308422,
    "y3": 0.320063587448162
  },
  {
    "x": "2013-06-24",
    "y1": 4.39597405705481,
    "y2": 0.25299767212893,
    "y3": 0.312160937076545
  },
  {
    "x": "2013-07-01",
    "y1": 4.41834381620048,
    "y2": 0.207594720937102,
    "y3": 0.302257336559509
  },
  {
    "x": "2013-07-08",
    "y1": 4.45303396196718,
    "y2": 0.432771690908727,
    "y3": 0.307762079542665
  },
  {
    "x": "2013-07-15",
    "y1": 4.4495701582649,
    "y2": 0.42741160855516,
    "y3": 0.305980996780214
  },
  {
    "x": "2013-07-22",
    "y1": 4.45669183646361,
    "y2": 0.479947242186734,
    "y3": 0.310242343487291
  },
  {
    "x": "2013-07-29",
    "y1": 4.47784511438112,
    "y2": 0.537313774713097,
    "y3": 0.320645209008111
  },
  {
    "x": "2013-08-05",
    "y1": 4.46985507219039,
    "y2": 0.61167629177169,
    "y3": 0.335569294058009
  },
  {
    "x": "2013-08-12",
    "y1": 4.45419158763872,
    "y2": 0.580382488205475,
    "y3": 0.353427866763065
  },
  {
    "x": "2013-08-19",
    "y1": 4.46946035490131,
    "y2": 0.476135437775226,
    "y3": 0.361905308556934
  },
  {
    "x": "2013-08-26",
    "y1": 4.45089178722802,
    "y2": 0.38023579849948,
    "y3": 0.361467353890232
  },
  {
    "x": "2013-09-02",
    "y1": 4.4704300686389,
    "y2": 0.463275402742442,
    "y3": 0.374115764837345
  },
  {
    "x": "2013-09-09",
    "y1": 4.48741633963519,
    "y2": 0.364318602740598,
    "y3": 0.377518942122891
  },
  {
    "x": "2013-09-16",
    "y1": 4.50153442360567,
    "y2": 0.356074677373012,
    "y3": 0.380820771399957
  },
  {
    "x": "2013-09-23",
    "y1": 4.50335180059882,
    "y2": 0.46666658125467,
    "y3": 0.390064392139486
  },
  {
    "x": "2013-09-30",
    "y1": 4.51026950228022,
    "y2": 0.344189360957098,
    "y3": 0.393514179269978
  },
  {
    "x": "2013-10-07",
    "y1": 4.50609909119428,
    "y2": 0.428618415725666,
    "y3": 0.401185419138898
  },
  {
    "x": "2013-10-14",
    "y1": 4.5383812918832,
    "y2": 0.425230615044599,
    "y3": 0.40451849058409
  },
  {
    "x": "2013-10-21",
    "y1": 4.54581051971242,
    "y2": 0.333857816088936,
    "y3": 0.406507216017195
  },
  {
    "x": "2013-10-28",
    "y1": 4.54040394567947,
    "y2": 0.333857816088936,
    "y3": 0.4084959414503
  },
  {
    "x": "2013-11-04",
    "y1": 4.53968746686595,
    "y2": 0.422518152181514,
    "y3": 0.416253708293955
  },
  {
    "x": "2013-11-11",
    "y1": 4.55671631961686,
    "y2": 0.422518152181514,
    "y3": 0.424729732296584
  },
  {
    "x": "2013-11-18",
    "y1": 4.55814130065846,
    "y2": 0.580382488205475,
    "y3": 0.443369120660002
  },
  {
    "x": "2013-11-25",
    "y1": 4.57523698587732,
    "y2": 0.46666658125467,
    "y3": 0.4450638651773
  },
  {
    "x": "2013-12-02",
    "y1": 4.57588481796704,
    "y2": 0.331686066486094,
    "y3": 0.440277588073846
  },
  {
    "x": "2013-12-09",
    "y1": 4.56073657530814,
    "y2": 0.331686066486094,
    "y3": 0.432864529288814
  },
  {
    "x": "2013-12-16",
    "y1": 4.58667028515242,
    "y2": 0.53526602479057,
    "y3": 0.432762141792688
  },
  {
    "x": "2013-12-23",
    "y1": 4.59930192720879,
    "y2": 0.430543815175026,
    "y3": 0.423705517962855
  },
  {
    "x": "2013-12-30",
    "y1": 4.59336444277378,
    "y2": 0.430543815175026,
    "y3": 0.416213584311332
  },
  {
    "x": "2014-01-06",
    "y1": 4.6037131105831,
    "y2": 0.417683780142242,
    "y3": 0.413291001429683
  },
  {
    "x": "2014-01-13",
    "y1": 4.60920100703449,
    "y2": 0.533108227882111,
    "y3": 0.420934622898815
  },
  {
    "x": "2014-01-20",
    "y1": 4.59266525191889,
    "y2": 0.487803726957967,
    "y3": 0.422161039109591
  },
  {
    "x": "2014-01-27",
    "y1": 4.58678127923313,
    "y2": 0.420346402578672,
    "y3": 0.424962429101494
  },
  {
    "x": "2014-02-03",
    "y1": 4.59213718171965,
    "y2": 0.399104572513312,
    "y3": 0.42711392385851
  },
  {
    "x": "2014-02-10",
    "y1": 4.62077609825232,
    "y2": 0.379260767280763,
    "y3": 0.422743633159814
  },
  {
    "x": "2014-02-17",
    "y1": 4.62534491193122,
    "y2": 0.333857816088936,
    "y3": 0.422227055916406
  },
  {
    "x": "2014-02-24",
    "y1": 4.63583181309693,
    "y2": 0.333857816088936,
    "y3": 0.41748902593457
  },
  {
    "x": "2014-03-03",
    "y1": 4.64235440227548,
    "y2": 0.333857816088936,
    "y3": 0.412920385986786
  },
  {
    "x": "2014-03-10",
    "y1": 4.62140982197278,
    "y2": 0.422518152181514,
    "y3": 0.417353402791415
  },
  {
    "x": "2014-03-17",
    "y1": 4.62880373949311,
    "y2": 0.496047652325554,
    "y3": 0.425462894603246
  },
  {
    "x": "2014-03-24",
    "y1": 4.60050441398682,
    "y2": 0.422518152181514,
    "y3": 0.425462894603246
  },
  {
    "x": "2014-03-31",
    "y1": 4.59375960997093,
    "y2": 0.373170851300665,
    "y3": 0.422995529559204
  },
  {
    "x": "2014-04-07",
    "y1": 4.56274982963024,
    "y2": 0.250825922526088,
    "y3": 0.406517701275234
  },
  {
    "x": "2014-04-14",
    "y1": 4.58669895607884,
    "y2": 0.304980256371845,
    "y3": 0.398433385031093
  },
  {
    "x": "2014-04-21",
    "y1": 4.58182534763784,
    "y2": 0.259577305180018,
    "y3": 0.394827946965789
  },
  {
    "x": "2014-04-28",
    "y1": 4.59368625584555,
    "y2": 0.205422971334261,
    "y3": 0.388514792208198
  },
  {
    "x": "2014-05-05",
    "y1": 4.58106960985793,
    "y2": 0.205422971334261,
    "y3": 0.372022639535382
  },
  {
    "x": "2014-05-12",
    "y1": 4.58566699881297,
    "y2": 0.283395793579518,
    "y3": 0.364665238455607
  },
  {
    "x": "2014-05-19",
    "y1": 4.60894480682043,
    "y2": 0.354337904816748,
    "y3": 0.360854942937693
  },
  {
    "x": "2014-05-26",
    "y1": 4.62251686522693,
    "y2": 0.317143051462591,
    "y3": 0.35582790650371
  },
  {
    "x": "2014-06-02",
    "y1": 4.64108552868965,
    "y2": 0.317143051462591,
    "y3": 0.345029647682734
  },
  {
    "x": "2014-06-09",
    "y1": 4.63859790888058,
    "y2": 0.26567756872417,
    "y3": 0.333923339771044
  },
  {
    "x": "2014-06-16",
    "y1": 4.65191147830025,
    "y2": 0.354337904816748,
    "y3": 0.330622914882948
  },
  {
    "x": "2014-06-23",
    "y1": 4.65875439559301,
    "y2": 0.354337904816748,
    "y3": 0.32838458149812
  },
  {
    "x": "2014-06-30",
    "y1": 4.67876380831279,
    "y2": 0.445021760020186,
    "y3": 0.331672631135091
  },
  {
    "x": "2014-07-07",
    "y1": 4.66306139239322,
    "y2": 0.356361423927608,
    "y3": 0.332797811527025
  },
  {
    "x": "2014-07-14",
    "y1": 4.66683439767338,
    "y2": 0.35095010413568,
    "y3": 0.333652425929362
  },
  {
    "x": "2014-07-21",
    "y1": 4.670762549165,
    "y2": 0.35095010413568,
    "y3": 0.334507040331699
  },
  {
    "x": "2014-07-28",
    "y1": 4.64898063801003,
    "y2": 0.294083307426838,
    "y3": 0.328085298093966
  },
  {
    "x": "2014-08-04",
    "y1": 4.65317573915587,
    "y2": 0.294083307426838,
    "y3": 0.31798708084903
  },
  {
    "x": "2014-08-11",
    "y1": 4.67468853412679,
    "y2": 0.262289768043103,
    "y3": 0.309975661642109
  },
  {
    "x": "2014-08-18",
    "y1": 4.69117695074427,
    "y2": 0.262289768043103,
    "y3": 0.304431607479231
  },
  {
    "x": "2014-08-25",
    "y1": 4.70036936167709,
    "y2": 0.262289768043103,
    "y3": 0.305004799755082
  },
  {
    "x": "2014-09-01",
    "y1": 4.70094353804688,
    "y2": 0.262289768043103,
    "y3": 0.302870275338645
  },
  {
    "x": "2014-09-08",
    "y1": 4.69760508313547,
    "y2": 0.35095010413568,
    "y3": 0.307438915286428
  },
  {
    "x": "2014-09-15",
    "y1": 4.70027386786829,
    "y2": 0.294083307426838,
    "y3": 0.311871932091057
  },
  {
    "x": "2014-09-22",
    "y1": 4.68551334455179,
    "y2": 0.294083307426838,
    "y3": 0.316304948895686
  },
  {
    "x": "2014-09-29",
    "y1": 4.67740867150087,
    "y2": 0.294083307426838,
    "y3": 0.316839324588052
  },
  {
    "x": "2014-10-06",
    "y1": 4.63286068092257,
    "y2": 0.179119045104032,
    "y3": 0.308078381602416
  },
  {
    "x": "2014-10-13",
    "y1": 4.6286980773285,
    "y2": 0.222376430004782,
    "y3": 0.303340050529525
  },
  {
    "x": "2014-10-20",
    "y1": 4.68160014393909,
    "y2": 0.255710134992015,
    "y3": 0.300268404705997
  },
  {
    "x": "2014-10-27",
    "y1": 4.71438988381727,
    "y2": 0.300334555740946,
    "y3": 0.302001254056835
  },
  {
    "x": "2014-11-03",
    "y1": 4.71477633408022,
    "y2": 0.29003809183168,
    "y3": 0.298786263407582
  },
  {
    "x": "2014-11-10",
    "y1": 4.72686697494037,
    "y2": 0.210307183800187,
    "y3": 0.291584727356754
  },
  {
    "x": "2014-11-17",
    "y1": 4.73207758966856,
    "y2": 0.298967519892765,
    "y3": 0.284282015350383
  },
  {
    "x": "2014-11-24",
    "y1": 4.74876763106135,
    "y2": 0.298967519892765,
    "y3": 0.281412320148641
  },
  {
    "x": "2014-12-01",
    "y1": 4.74649906745078,
    "y2": 0.298967519892765,
    "y3": 0.278813190936495
  },
  {
    "x": "2014-12-08",
    "y1": 4.71990085415358,
    "y2": 0.255710134992015,
    "y3": 0.274051192479312
  },
  {
    "x": "2014-12-15",
    "y1": 4.74392092094285,
    "y2": 0.298967519892765,
    "y3": 0.274295403102608
  },
  {
    "x": "2014-12-22",
    "y1": 4.75262536455255,
    "y2": 0.394720308045202,
    "y3": 0.279327253133526
  },
  {
    "x": "2014-12-29",
    "y1": 4.73597212169457,
    "y2": 0.329256464296697,
    "y3": 0.282675587946206
  },
  {
    "x": "2015-01-05",
    "y1": 4.7311612166459,
    "y2": 0.432771690908727,
    "y3": 0.291199684089487
  },
  {
    "x": "2015-01-12",
    "y1": 4.71634639798665,
    "y2": 0.300334555740946,
    "y3": 0.293101923474379
  },
  {
    "x": "2015-01-19",
    "y1": 4.7429950550072,
    "y2": 0.49013822343509,
    "y3": 0.304494346243979
  },
  {
    "x": "2015-01-26",
    "y1": 4.71721894223047,
    "y2": 0.281794166464094,
    "y3": 0.301036549360399
  },
  {
    "x": "2015-02-02",
    "y1": 4.74076889055013,
    "y2": 0.376422316484286,
    "y3": 0.305153499813272
  },
  {
    "x": "2015-02-09",
    "y1": 4.77226706618504,
    "y2": 0.382295145140255,
    "y3": 0.309564091698943
  },
  {
    "x": "2015-02-16",
    "y1": 4.78496269437833,
    "y2": 0.366233271617288,
    "y3": 0.313171589908465
  },
  {
    "x": "2015-02-23",
    "y1": 4.78648804057388,
    "y2": 0.345157740227205,
    "y3": 0.321473524664624
  },
  {
    "x": "2015-03-02",
    "y1": 4.77920296935765,
    "y2": 0.283395793579518,
    "y3": 0.324524492843361
  },
  {
    "x": "2015-03-09",
    "y1": 4.76791695871913,
    "y2": 0.35095010413568,
    "y3": 0.329286491300544
  },
  {
    "x": "2015-03-16",
    "y1": 4.79966321955516,
    "y2": 0.348237641272595,
    "y3": 0.331681645577126
  },
  {
    "x": "2015-03-23",
    "y1": 4.77276540577664,
    "y2": 0.205422971334261,
    "y3": 0.327450889552255
  },
  {
    "x": "2015-03-30",
    "y1": 4.77189031259958,
    "y2": 0.250825922526088,
    "y3": 0.32947682648855
  },
  {
    "x": "2015-04-06",
    "y1": 4.79420285181018,
    "y2": 0.30769271923493,
    "y3": 0.329913086455659
  },
  {
    "x": "2015-04-13",
    "y1": 4.78135854055876,
    "y2": 0.205422971334261,
    "y3": 0.325235859027733
  },
  {
    "x": "2015-04-20",
    "y1": 4.81385574090247,
    "y2": 0.354337904816748,
    "y3": 0.328004378273933
  },
  {
    "x": "2015-04-27",
    "y1": 4.79683127544313,
    "y2": 0.26567756872417,
    "y3": 0.32850274996054
  },
  {
    "x": "2015-05-04",
    "y1": 4.79646360539525,
    "y2": 0.354337904816748,
    "y3": 0.331271269206739
  },
  {
    "x": "2015-05-11",
    "y1": 4.80540530401351,
    "y2": 0.354337904816748,
    "y3": 0.329252149045317
  },
  {
    "x": "2015-05-18",
    "y1": 4.81354069716663,
    "y2": 0.26567756872417,
    "y3": 0.32607320426669
  },
  {
    "x": "2015-05-25",
    "y1": 4.80974256171458,
    "y2": 0.294083307426838,
    "y3": 0.319138785092596
  },
  {
    "x": "2015-06-01",
    "y1": 4.80943293351015,
    "y2": 0.205422971334261,
    "y3": 0.314393205872262
  },
  {
    "x": "2015-06-08",
    "y1": 4.80600785697506,
    "y2": 0.294083307426838,
    "y3": 0.304590460071849
  },
  {
    "x": "2015-06-15",
    "y1": 4.81905450049225,
    "y2": 0.370454502556672,
    "y3": 0.309023476876478
  },
  {
    "x": "2015-06-22",
    "y1": 4.81192332316667,
    "y2": 0.281794166464094,
    "y3": 0.304292069375468
  },
  {
    "x": "2015-06-29",
    "y1": 4.79788933681949,
    "y2": 0.275193618347262,
    "y3": 0.298936993035819
  },
  {
    "x": "2015-07-06",
    "y1": 4.79559161607814,
    "y2": 0.521432027001305,
    "y3": 0.30669693080502
  },
  {
    "x": "2015-07-13",
    "y1": 4.83809915616738,
    "y2": 0.568607578279312,
    "y3": 0.317869422707625
  },
  {
    "x": "2015-07-20",
    "y1": 4.81477727792271,
    "y2": 0.26567756872417,
    "y3": 0.316983511464857
  },
  {
    "x": "2015-07-27",
    "y1": 4.82256914002643,
    "y2": 0.205422971334261,
    "y3": 0.309707154824787
  },
  {
    "x": "2015-08-03",
    "y1": 4.80604513009643,
    "y2": 0.205422971334261,
    "y3": 0.30256642132787
  },
  {
    "x": "2015-08-10",
    "y1": 4.80697705395865,
    "y2": 0.294083307426838,
    "y3": 0.306999438132499
  },
  {
    "x": "2015-08-17",
    "y1": 4.73919101775095,
    "y2": 0.222376430004782,
    "y3": 0.305576963506433
  },
  {
    "x": "2015-08-24",
    "y1": 4.76517460143092,
    "y2": 0.222376430004782,
    "y3": 0.301311149044926
  },
  {
    "x": "2015-08-31",
    "y1": 4.73526773784259,
    "y2": 0.140252346797054,
    "y3": 0.298052617818066
  },
  {
    "x": "2015-09-07",
    "y1": 4.76481989163338,
    "y2": 0.209786290853871,
    "y3": 0.290825037119922
  },
  {
    "x": "2015-09-14",
    "y1": 4.76583395055025,
    "y2": 0.135887843515046,
    "y3": 0.284335550859466
  },
  {
    "x": "2015-09-21",
    "y1": 4.73668058909075,
    "y2": 0.0948493956052264,
    "y3": 0.27136112539889
  },
  {
    "x": "2015-09-28",
    "y1": 4.74122124526407,
    "y2": 0.227260642470709,
    "y3": 0.265007262281588
  },
  {
    "x": "2015-10-05",
    "y1": 4.76728245358021,
    "y2": 0.156318531233479,
    "y3": 0.259539310407053
  },
  {
    "x": "2015-10-12",
    "y1": 4.77892101547213,
    "y2": 0.299995351562927,
    "y3": 0.259834912613857
  },
  {
    "x": "2015-10-19",
    "y1": 4.80862822497706,
    "y2": 0.211335015470349,
    "y3": 0.260130514820662
  },
  {
    "x": "2015-10-26",
    "y1": 4.81297853228162,
    "y2": 0.277273880053781,
    "y3": 0.259290043452009
  },
  {
    "x": "2015-11-02",
    "y1": 4.83145394503205,
    "y2": 0.294992104909129,
    "y3": 0.255516923569632
  },
  {
    "x": "2015-11-09",
    "y1": 4.78885920673502,
    "y2": 0.227260642470709,
    "y3": 0.252790247369963
  },
  {
    "x": "2015-11-16",
    "y1": 4.82478541501781,
    "y2": 0.287700662771397,
    "y3": 0.253415599591169
  },
  {
    "x": "2015-11-23",
    "y1": 4.82921253591336,
    "y2": 0.277404198862132,
    "y3": 0.241214208184211
  },
  {
    "x": "2015-11-30",
    "y1": 4.83208917022075,
    "y2": 0.180499937401967,
    "y3": 0.221808826140344
  },
  {
    "x": "2015-12-07",
    "y1": 4.79148457266083,
    "y2": 0.135887843515046,
    "y3": 0.215319339879887
  },
  {
    "x": "2015-12-14",
    "y1": 4.78937852230149,
    "y2": 0.140252346797054,
    "y3": 0.212060808653027
  },
  {
    "x": "2015-12-21",
    "y1": 4.81485244396432,
    "y2": 0.269160273494545,
    "y3": 0.215247673761041
  },
  {
    "x": "2015-12-28",
    "y1": 4.80671534233238,
    "y2": 0.135887843515046,
    "y3": 0.207337900565452
  },
  {
    "x": "2016-01-04",
    "y1": 4.73406695482542,
    "y2": 0.0820658508147611,
    "y3": 0.200322371605951
  },
  {
    "x": "2016-01-11",
    "y1": 4.70064268009759,
    "y2": 0.161498966607454,
    "y3": 0.197278498436084
  },
  {
    "x": "2016-01-18",
    "y1": 4.72353720772533,
    "y2": 0.161498966607454,
    "y3": 0.198340829426604
  },
  {
    "x": "2016-01-25",
    "y1": 4.72849672110957,
    "y2": 0.132353014472515,
    "y3": 0.194469165607536
  },
  {
    "x": "2016-02-01",
    "y1": 4.67413764743588,
    "y2": 0.0646686958743536,
    "y3": 0.190908208225502
  },
  {
    "x": "2016-02-08",
    "y1": 4.66826335270992,
    "y2": 0.0646686958743536,
    "y3": 0.189399173238958
  },
  {
    "x": "2016-02-15",
    "y1": 4.70674635774638,
    "y2": 0.166383179073381,
    "y3": 0.186355300069092
  },
  {
    "x": "2016-02-22",
    "y1": 4.72584756160677,
    "y2": 0.0954410678361506,
    "y3": 0.183311426899225
  },
  {
    "x": "2016-02-29",
    "y1": 4.75341550100398,
    "y2": 0.106454461701679,
    "y3": 0.173634382406163
  },
  {
    "x": "2016-03-07",
    "y1": 4.76008288744336,
    "y2": 0.106454461701679,
    "y3": 0.168390354717729
  },
  {
    "x": "2016-03-14",
    "y1": 4.77001865314586,
    "y2": 0.124172686557026,
    "y3": 0.160735295042892
  },
  {
    "x": "2016-03-21",
    "y1": 4.76539990432249,
    "y2": 0.195114797794257,
    "y3": 0.155741429687148
  },
  {
    "x": "2016-03-28",
    "y1": 4.79494636688926,
    "y2": 0.300477103832229,
    "y3": 0.159402252755224
  },
  {
    "x": "2016-04-04",
    "y1": 4.78195428682709,
    "y2": 0.300477103832229,
    "y3": 0.160041074808266
  },
  {
    "x": "2016-04-11",
    "y1": 4.79999919889008,
    "y2": 0.232164148073252,
    "y3": 0.157779072268822
  },
  {
    "x": "2016-04-18",
    "y1": 4.79352110901494,
    "y2": 0.166700304324747,
    "y3": 0.157089090614961
  },
  {
    "x": "2016-04-25",
    "y1": 4.76684683616012,
    "y2": 0.139972096477593,
    "y3": 0.157293303263088
  },
  {
    "x": "2016-05-02",
    "y1": 4.75863809207517,
    "y2": 0.183229481378343,
    "y3": 0.159442159992153
  },
  {
    "x": "2016-05-09",
    "y1": 4.75473620112151,
    "y2": 0.178998200054333,
    "y3": 0.154934056320142
  },
  {
    "x": "2016-05-16",
    "y1": 4.76573310656644,
    "y2": 0.370637605705422,
    "y3": 0.166671544429661
  },
  {
    "x": "2016-05-23",
    "y1": 4.8001052372016,
    "y2": 0.25068346604663,
    "y3": 0.175102425191254
  },
  {
    "x": "2016-05-30",
    "y1": 4.80193355777143,
    "y2": 0.326963654916485,
    "y3": 0.183375659606706
  },
  {
    "x": "2016-06-06",
    "y1": 4.79222793904775,
    "y2": 0.205567002631725,
    "y3": 0.185579061407919
  },
  {
    "x": "2016-06-13",
    "y1": 4.77298000722626,
    "y2": 0.278165465201336,
    "y3": 0.19286968394436
  },
  {
    "x": "2016-06-20",
    "y1": 4.75373973126924,
    "y2": 0.265305430168552,
    "y3": 0.20290152065907
  },
  {
    "x": "2016-06-27",
    "y1": 4.7865754366867,
    "y2": 0.361739034742053,
    "y3": 0.217755037602455
  },
  {
    "x": "2016-07-04",
    "y1": 4.80594584057008,
    "y2": 0.158104704799122,
    "y3": 0.217341113888742
  },
  {
    "x": "2016-07-11",
    "y1": 4.82063892265771,
    "y2": 0.248023127791248,
    "y3": 0.224970216886497
  },
  {
    "x": "2016-07-18",
    "y1": 4.83466994997651,
    "y2": 0.146219388383209,
    "y3": 0.226958463220574
  },
  {
    "x": "2016-07-25",
    "y1": 4.84682049518764,
    "y2": 0.141988107059199,
    "y3": 0.22873514548845
  },
  {
    "x": "2016-08-01",
    "y1": 4.858247994246,
    "y2": 0.227260642470709,
    "y3": 0.233889543284134
  },
  {
    "x": "2016-08-08",
    "y1": 4.86050230352583,
    "y2": 0.339213724027943,
    "y3": 0.241094489595818
  },
  {
    "x": "2016-08-15",
    "y1": 4.86155138843881,
    "y2": 0.222376430004782,
    "y3": 0.237189455904446
  },
  {
    "x": "2016-08-22",
    "y1": 4.85783650685847,
    "y2": 0.222376430004782,
    "y3": 0.233284422213073
  },
  {
    "x": "2016-08-29",
    "y1": 4.86377259726271,
    "y2": 0.222376430004782,
    "y3": 0.23279503630965
  },
  {
    "x": "2016-09-05",
    "y1": 4.84015505247135,
    "y2": 0.273365186426398,
    "y3": 0.238128280414732
  },
  {
    "x": "2016-09-12",
    "y1": 4.8633040473526,
    "y2": 0.323151850504976,
    "y3": 0.247287268116101
  },
  {
    "x": "2016-09-19",
    "y1": 4.87496947994894,
    "y2": 0.221631479379615,
    "y3": 0.249207368016165
  },
  {
    "x": "2016-09-26",
    "y1": 4.87614744724857,
    "y2": 0.211335015470349,
    "y3": 0.250824208786966
  },
  {
    "x": "2016-10-03",
    "y1": 4.87245766982834,
    "y2": 0.405666731277816,
    "y3": 0.252575665065586
  },
  {
    "x": "2016-10-10",
    "y1": 4.85767425445206,
    "y2": 0.432771690908727,
    "y3": 0.26168007630869
  },
  {
    "x": "2016-10-17",
    "y1": 4.86596700818382,
    "y2": 0.437977692945952,
    "y3": 0.267230778210164
  },
  {
    "x": "2016-10-24",
    "y1": 4.85316604079736,
    "y2": 0.417916800389274,
    "y3": 0.277848268098041
  },
  {
    "x": "2016-10-31",
    "y1": 4.825472937049,
    "y2": 0.358597541965557,
    "y3": 0.281869871936252
  },
  {
    "x": "2016-11-07",
    "y1": 4.86327035215419,
    "y2": 0.568607578279312,
    "y3": 0.29703497934179
  },
  {
    "x": "2016-11-14",
    "y1": 4.87938609242833,
    "y2": 0.376422316484286,
    "y3": 0.297769143428902
  },
  {
    "x": "2016-11-21",
    "y1": 4.89393274547593,
    "y2": 0.356361423927608,
    "y3": 0.307681979385326
  },
  {
    "x": "2016-11-28",
    "y1": 4.86739595263506,
    "y2": 0.223211034104346,
    "y3": 0.306441374700981
  },
  {
    "x": "2016-12-05",
    "y1": 4.90332872996333,
    "y2": 0.363853954439839,
    "y3": 0.317323103003813
  },
  {
    "x": "2016-12-12",
    "y1": 4.90198060915334,
    "y2": 0.358569186140758,
    "y3": 0.328152156957891
  },
  {
    "x": "2016-12-19",
    "y1": 4.90667603551978,
    "y2": 0.354337904816748,
    "y3": 0.334506020075193
  },
  {
    "x": "2016-12-26",
    "y1": 4.89210998379944,
    "y2": 0.207594720937102,
    "y3": 0.327925069920651
  },
  {
    "x": "2017-01-02",
    "y1": 4.91773451723049,
    "y2": 0.30769271923493,
    "y3": 0.332190884382158
  },
  {
    "x": "2017-01-09",
    "y1": 4.9273450010924,
    "y2": 0.35095010413568,
    "y3": 0.338619568088703
  },
  {
    "x": "2017-01-16",
    "y1": 4.92397405847411,
    "y2": 0.262289768043103,
    "y3": 0.340615234990619
  },
  {
    "x": "2017-01-23",
    "y1": 4.94295577613054,
    "y2": 0.382295145140255,
    "y3": 0.346061732926312
  },
  {
    "x": "2017-01-30",
    "y1": 4.94401397563703,
    "y2": 0.366233271617288,
    "y3": 0.348215803981927
  },
  {
    "x": "2017-02-06",
    "y1": 4.95590079353313,
    "y2": 0.537313774713097,
    "y3": 0.363999918748602
  },
  {
    "x": "2017-02-13",
    "y1": 4.97411632011644,
    "y2": 0.466371663475867,
    "y3": 0.376751751148877
  },
  {
    "x": "2017-02-20",
    "y1": 4.97526899429041,
    "y2": 0.327439515371857,
    "y3": 0.37284039035358
  },
  {
    "x": "2017-02-27",
    "y1": 4.97962119137684,
    "y2": 0.442033572677083,
    "y3": 0.373303484441997
  },
  {
    "x": "2017-03-06",
    "y1": 4.97808475744058,
    "y2": 0.431737108767817,
    "y3": 0.37299145523309
  },
  {
    "x": "2017-03-13",
    "y1": 4.98478414817712,
    "y2": 0.51225820385487,
    "y3": 0.37770852540637
  },
  {
    "x": "2017-03-20",
    "y1": 4.97253880575635,
    "y2": 0.492197311298193,
    "y3": 0.384388513873002
  },
  {
    "x": "2017-03-27",
    "y1": 4.9867785894253,
    "y2": 0.476135437775226,
    "y3": 0.379764906847798
  },
  {
    "x": "2017-04-03",
    "y1": 4.98103913294784,
    "y2": 0.292782528355081,
    "y3": 0.375582917441338
  },
  {
    "x": "2017-04-10",
    "y1": 4.96867735951084,
    "y2": 0.302808506769003,
    "y3": 0.372905271583407
  },
  {
    "x": "2017-04-17",
    "y1": 4.98682850443562,
    "y2": 0.346065891669754,
    "y3": 0.379048014461678
  },
  {
    "x": "2017-04-24",
    "y1": 5.01002271463997,
    "y2": 0.289394727674014,
    "y3": 0.375325053123386
  },
  {
    "x": "2017-05-01",
    "y1": 5.0188112945162,
    "y2": 0.289394727674014,
    "y3": 0.371866330200049
  },
  {
    "x": "2017-05-08",
    "y1": 5.0221666495261,
    "y2": 0.289394727674014,
    "y3": 0.368619171342912
  },
  {
    "x": "2017-05-15",
    "y1": 5.01603556389853,
    "y2": 0.275123780432523,
    "y3": 0.371995624317684
  },
  {
    "x": "2017-05-22",
    "y1": 5.03682714501412,
    "y2": 0.407376585660307,
    "y3": 0.376979817638952
  },
  {
    "x": "2017-05-29",
    "y1": 5.05222278736699,
    "y2": 0.407376585660307,
    "y3": 0.379801141715184
  },
  {
    "x": "2017-06-05",
    "y1": 5.03670058782939,
    "y2": 0.403536975205615,
    "y3": 0.386863502073309
  },
  {
    "x": "2017-06-12",
    "y1": 5.02765405421479,
    "y2": 0.381442864447659,
    "y3": 0.386820888038679
  },
  {
    "x": "2017-06-19",
    "y1": 5.04610247201699,
    "y2": 0.381442864447659,
    "y3": 0.387581367680198
  },
  {
    "x": "2017-06-26",
    "y1": 5.02617827455878,
    "y2": 0.346065891669754,
    "y3": 0.378018973528031
  },
  {
    "x": "2017-07-03",
    "y1": 5.02824004825033,
    "y2": 0.346065891669754,
    "y3": 0.372003684937725
  },
  {
    "x": "2017-07-10",
    "y1": 5.05414417020145,
    "y2": 0.448653438620519,
    "y3": 0.378064381100158
  },
  {
    "x": "2017-07-17",
    "y1": 5.06606973699133,
    "y2": 0.423597867762293,
    "y3": 0.377142595854419
  },
  {
    "x": "2017-07-24",
    "y1": 5.06402366063914,
    "y2": 0.403536975205615,
    "y3": 0.375732589176309
  },
  {
    "x": "2017-07-31",
    "y1": 5.06039679363562,
    "y2": 0.523015955679112,
    "y3": 0.376270476767521
  },
  {
    "x": "2017-08-07",
    "y1": 5.04543983831699,
    "y2": 0.407376585660307,
    "y3": 0.372029440485626
  },
  {
    "x": "2017-08-14",
    "y1": 5.03904171010235,
    "y2": 0.381442864447659,
    "y3": 0.367294811819248
  },
  {
    "x": "2017-08-21",
    "y1": 5.04694167250255,
    "y2": 0.346065891669754,
    "y3": 0.369958979984982
  },
  {
    "x": "2017-08-28",
    "y1": 5.07402429099062,
    "y2": 0.374615066649864,
    "y3": 0.373549307979025
  },
  {
    "x": "2017-09-04",
    "y1": 5.06234810098846,
    "y2": 0.292782528355081,
    "y3": 0.370885139813291
  },
  {
    "x": "2017-09-11",
    "y1": 5.07622823259629,
    "y2": 0.292782528355081,
    "y3": 0.371054529847345
  },
  {
    "x": "2017-09-18",
    "y1": 5.07288630927948,
    "y2": 0.310500753210429,
    "y3": 0.372109831124165
  },
  {
    "x": "2017-09-25",
    "y1": 5.08362863062497,
    "y2": 0.407376585660307,
    "y3": 0.37800892402348
  },
  {
    "x": "2017-10-02",
    "y1": 5.09813306344326,
    "y2": 0.403988784979239,
    "y3": 0.384452174250816
  },
  {
    "x": "2017-10-09",
    "y1": 5.10050320029683,
    "y2": 0.286682264810929,
    "y3": 0.378417458208347
  },
  {
    "x": "2017-10-16",
    "y1": 5.10402283466169,
    "y2": 0.401276322116154,
    "y3": 0.378112445031139
  },
  {
    "x": "2017-10-23",
    "y1": 5.11491579263682,
    "y2": 0.286682264810929,
    "y3": 0.372269709511405
  },
  {
    "x": "2017-10-30",
    "y1": 5.12434389690243,
    "y2": 0.401276322116154,
    "y3": 0.37326138239483
  },
  {
    "x": "2017-11-06",
    "y1": 5.12234816627034,
    "y2": 0.375342600903507,
    "y3": 0.372956369217622
  },
  {
    "x": "2017-11-13",
    "y1": 5.12706604228949,
    "y2": 0.302808506769003,
    "y3": 0.370793499972584
  },
  {
    "x": "2017-11-20",
    "y1": 5.14274839668567,
    "y2": 0.378055063766592,
    "y3": 0.372392958577426
  },
  {
    "x": "2017-11-27",
    "y1": 5.13671423409442,
    "y2": 0.286682264810929,
    "y3": 0.364294399886947
  },
  {
    "x": "2017-12-04",
    "y1": 5.13561753207278,
    "y2": 0.375342600903507,
    "y3": 0.361881636544007
  },
  {
    "x": "2017-12-11",
    "y1": 5.14972555404004,
    "y2": 0.375342600903507,
    "y3": 0.360471917828902
  },
  {
    "x": "2017-12-18",
    "y1": 5.15309607417376,
    "y2": 0.312615986023576,
    "y3": 0.349951919346125
  },
  {
    "x": "2017-12-25",
    "y1": 5.14496817910881,
    "y2": 0.375342600903507,
    "y3": 0.348350220108285
  },
  {
    "x": "2018-01-01",
    "y1": 5.17874432637228,
    "y2": 0.479947242186734,
    "y3": 0.353275438995239
  },
  {
    "x": "2018-01-08",
    "y1": 5.19618970607592,
    "y2": 0.448653438620519,
    "y3": 0.358404816342777
  },
  {
    "x": "2018-01-15",
    "y1": 5.20656282289509,
    "y2": 0.423597867762293,
    "y3": 0.360853956398399
  },
  {
    "x": "2018-01-22",
    "y1": 5.22965188581501,
    "y2": 0.403536975205615,
    "y3": 0.366391678740925
  },
  {
    "x": "2018-01-29",
    "y1": 5.19436971975748,
    "y2": 0.312615986023576,
    "y3": 0.36738335162435
  },
  {
    "x": "2018-02-05",
    "y1": 5.14376034515154,
    "y2": 0.346065891669754,
    "y3": 0.369161608547317
  },
  {
    "x": "2018-02-12",
    "y1": 5.19685227895686,
    "y2": 0.403988784979239,
    "y3": 0.368992218513263
  },
  {
    "x": "2018-02-19",
    "y1": 5.21037811979453,
    "y2": 0.286682264810929,
    "y3": 0.363126892504848
  },
  {
    "x": "2018-02-26",
    "y1": 5.199540476157,
    "y2": 0.257405555577176,
    "y3": 0.36166305704316
  },
  {
    "x": "2018-03-05",
    "y1": 5.24127998602903,
    "y2": 0.387475101682648,
    "y3": 0.360972996021485
  },
  {
    "x": "2018-03-12",
    "y1": 5.23085520037671,
    "y2": 0.374615066649864,
    "y3": 0.365369636113431
  },
  {
    "x": "2018-03-19",
    "y1": 5.1654554474805,
    "y2": 0.346065891669754,
    "y3": 0.362609114591111
  },
  {
    "x": "2018-03-26",
    "y1": 5.17557751447755,
    "y2": 0.346065891669754,
    "y3": 0.361145279129424
  },
  {
    "x": "2018-04-02",
    "y1": 5.15457639916854,
    "y2": 0.346065891669754,
    "y3": 0.363308148374461
  },
  {
    "x": "2018-04-09",
    "y1": 5.18227516937602,
    "y2": 0.346065891669754,
    "y3": 0.361708689769619
  },
  {
    "x": "2018-04-16",
    "y1": 5.1878305268245,
    "y2": 0.257405555577176,
    "y3": 0.360244854307932
  },
  {
    "x": "2018-04-23",
    "y1": 5.18414600407488,
    "y2": 0.257405555577176,
    "y3": 0.354348002041615
  },
  {
    "x": "2018-04-30",
    "y1": 5.19676157122058,
    "y2": 0.346065891669754,
    "y3": 0.352884166579928
  },
  {
    "x": "2018-05-07",
    "y1": 5.22356738934743,
    "y2": 0.383951496472636,
    "y3": 0.356450942102381
  },
  {
    "x": "2018-05-14",
    "y1": 5.21701047638506,
    "y2": 0.371091461439852,
    "y3": 0.356238385129198
  },
  {
    "x": "2018-05-21",
    "y1": 5.2278218143971,
    "y2": 0.371091461439852,
    "y3": 0.350795596091854
  },
  {
    "x": "2018-05-28",
    "y1": 5.24402875681403,
    "y2": 0.345157740227205,
    "y3": 0.345620811172188
  },
  {
    "x": "2018-06-04",
    "y1": 5.25609861430728,
    "y2": 0.431737108767817,
    "y3": 0.346027773222464
  },
  {
    "x": "2018-06-11",
    "y1": 5.26929199451079,
    "y2": 0.431737108767817,
    "y3": 0.347437779900574
  },
  {
    "x": "2018-06-18",
    "y1": 5.26237778950096,
    "y2": 0.343076772675239,
    "y3": 0.348960819233158
  },
  {
    "x": "2018-06-25",
    "y1": 5.23865176657285,
    "y2": 0.346065891669754,
    "y3": 0.348960819233157
  },
  {
    "x": "2018-07-02",
    "y1": 5.26236457919853,
    "y2": 0.397559462187583,
    "y3": 0.348639353093575
  },
  {
    "x": "2018-07-09",
    "y1": 5.28026037289569,
    "y2": 0.373635250382648,
    "y3": 0.352987002372161
  },
  {
    "x": "2018-07-16",
    "y1": 5.2795218346972,
    "y2": 0.297013809679091,
    "y3": 0.354967415077256
  },
  {
    "x": "2018-07-23",
    "y1": 5.26893639297319,
    "y2": 0.257405555577176,
    "y3": 0.348463937771983
  },
  {
    "x": "2018-07-30",
    "y1": 5.27857653716895,
    "y2": 0.257405555577176,
    "y3": 0.342603462218348
  },
  {
    "x": "2018-08-06",
    "y1": 5.2820455673506,
    "y2": 0.381442864447659,
    "y3": 0.344372310857243
  },
  {
    "x": "2018-08-13",
    "y1": 5.27913965257793,
    "y2": 0.346065891669754,
    "y3": 0.344372310857243
  },
  {
    "x": "2018-08-20",
    "y1": 5.29572670827388,
    "y2": 0.257405555577176,
    "y3": 0.339939294052615
  },
  {
    "x": "2018-08-27",
    "y1": 5.31631070911402,
    "y2": 0.32823229919082,
    "y3": 0.339047614428668
  },
  {
    "x": "2018-09-03",
    "y1": 5.2907852170389,
    "y2": 0.257405555577176,
    "y3": 0.339047614428668
  },
  {
    "x": "2018-09-10",
    "y1": 5.30438843821444,
    "y2": 0.346065891669754,
    "y3": 0.343480631233297
  },
  {
    "x": "2018-09-17",
    "y1": 5.30150704461186,
    "y2": 0.346065891669754,
    "y3": 0.343480631233297
  },
  {
    "x": "2018-09-24",
    "y1": 5.30894293223484,
    "y2": 0.416099851464435,
    "y3": 0.345088048982887
  },
  {
    "x": "2018-10-01",
    "y1": 5.27689114487614,
    "y2": 0.250825922526088,
    "y3": 0.339074772037199
  },
  {
    "x": "2018-10-08",
    "y1": 5.23945621863507,
    "y2": 0.201514277706877,
    "y3": 0.33059591285055
  },
  {
    "x": "2018-10-15",
    "y1": 5.23307219129978,
    "y2": 0.222376430004782,
    "y3": 0.324456847339429
  },
  {
    "x": "2018-10-22",
    "y1": 5.1952390999648,
    "y2": 0.183509731697804,
    "y3": 0.312045478485928
  },
  {
    "x": "2018-10-29",
    "y1": 5.22171806102103,
    "y2": 0.224548179607624,
    "y3": 0.301686032027919
  },
  {
    "x": "2018-11-05",
    "y1": 5.2285020401183,
    "y2": 0.217926265805265,
    "y3": 0.29542850668442
  },
  {
    "x": "2018-11-12",
    "y1": 5.20703154811044,
    "y2": 0.135887843515046,
    "y3": 0.284919604276684
  },
  {
    "x": "2018-11-19",
    "y1": 5.16441349180915,
    "y2": 0.0997840756701084,
    "y3": 0.270030834950811
  },
  {
    "x": "2018-11-26",
    "y1": 5.22084254329739,
    "y2": 0.227260642470709,
    "y3": 0.262712104555214
  },
  {
    "x": "2018-12-03",
    "y1": 5.17155694671961,
    "y2": 0.0997840756701084,
    "y3": 0.252850617854765
  },
  {
    "x": "2018-12-10",
    "y1": 5.16315003869507,
    "y2": 0.170726186907339,
    "y3": 0.248516649421273
  },
  {
    "x": "2018-12-17",
    "y1": 5.07955890430069,
    "y2": 0.0728386305148765,
    "y3": 0.239288303168158
  },
  {
    "x": "2018-12-24",
    "y1": 5.1192762851662,
    "y2": 0.172897936510181,
    "y3": 0.228861056771284
  },
  {
    "x": "2018-12-31",
    "y1": 5.14271608689696,
    "y2": 0.20129779446789,
    "y3": 0.221622651911191
  },
  {
    "x": "2019-01-07",
    "y1": 5.17723529666047,
    "y2": 0.112637458375312,
    "y3": 0.214384247051097
  },
  {
    "x": "2019-01-14",
    "y1": 5.20387956739214,
    "y2": 0.176645094075975,
    "y3": 0.206804886795355
  },
  {
    "x": "2019-01-21",
    "y1": 5.2049456059061,
    "y2": 0.176645094075975,
    "y3": 0.202766863720295
  },
  {
    "x": "2019-01-28",
    "y1": 5.21876447407597,
    "y2": 0.255008966259287,
    "y3": 0.198214017449772
  },
  {
    "x": "2019-02-04",
    "y1": 5.2234906155916,
    "y2": 0.20129779446789,
    "y3": 0.190975612589679
  },
  {
    "x": "2019-02-11",
    "y1": 5.24736087898194,
    "y2": 0.265305430168552,
    "y3": 0.183435891524884
  },
  {
    "x": "2019-02-18",
    "y1": 5.25473867030491,
    "y2": 0.265305430168552,
    "y3": 0.184159866907008
  },
  {
    "x": "2019-02-25",
    "y1": 5.26374693306298,
    "y2": 0.166348630166709,
    "y3": 0.182401584529999
  },
  {
    "x": "2019-03-04",
    "y1": 5.23909896311683,
    "y2": 0.152755641268058,
    "y3": 0.178920545093163
  },
  {
    "x": "2019-03-11",
    "y1": 5.2769478217052,
    "y2": 0.255008966259287,
    "y3": 0.182495506821237
  },
  {
    "x": "2019-03-18",
    "y1": 5.27098311004215,
    "y2": 0.20350765599095,
    "y3": 0.181443480640403
  },
  {
    "x": "2019-03-25",
    "y1": 5.2823207581716,
    "y2": 0.30437250221569,
    "y3": 0.185765792460925
  },
  {
    "x": "2019-04-01",
    "y1": 5.30940853846133,
    "y2": 0.273078698649475,
    "y3": 0.192625335217646
  },
  {
    "x": "2019-04-08",
    "y1": 5.31513621080769,
    "y2": 0.141988107059199,
    "y3": 0.194735536787101
  },
  {
    "x": "2019-04-15",
    "y1": 5.31687714561758,
    "y2": 0.227260642470709,
    "y3": 0.194735536787101
  },
  {
    "x": "2019-04-22",
    "y1": 5.33542412359265,
    "y2": 0.288332505347391,
    "y3": 0.204162958270965
  },
  {
    "x": "2019-04-29",
    "y1": 5.33758459912383,
    "y2": 0.339213724027943,
    "y3": 0.212587335126995
  },
  {
    "x": "2019-05-06",
    "y1": 5.30732246553812,
    "y2": 0.227260642470709,
    "y3": 0.220308435724787
  },
  {
    "x": "2019-05-13",
    "y1": 5.29460793732457,
    "y2": 0.224548179607624,
    "y3": 0.222890947879659
  },
  {
    "x": "2019-05-20",
    "y1": 5.27167247128973,
    "y2": 0.183509731697804,
    "y3": 0.222001544741154
  },
  {
    "x": "2019-05-27",
    "y1": 5.24759762145664,
    "y2": 0.170726186907339,
    "y3": 0.224905981167756
  },
  {
    "x": "2019-06-03",
    "y1": 5.28636649087408,
    "y2": 0.142424096399896,
    "y3": 0.223194931283952
  },
  {
    "x": "2019-06-10",
    "y1": 5.29341368193407,
    "y2": 0.0970211452080681,
    "y3": 0.219213733840556
  },
  {
    "x": "2019-06-17",
    "y1": 5.3235611809884,
    "y2": 0.146219388383209,
    "y3": 0.213774254946753
  },
  {
    "x": "2019-06-24",
    "y1": 5.32039003478337,
    "y2": 0.146219388383209,
    "y3": 0.211020334642518
  },
  {
    "x": "2019-07-01",
    "y1": 5.33981860551494,
    "y2": 0.268271612790713,
    "y3": 0.211168643773627
  },
  {
    "x": "2019-07-08",
    "y1": 5.34990825606719,
    "y2": 0.442344483127479,
    "y3": 0.220020596421573
  },
  {
    "x": "2019-07-15",
    "y1": 5.33806354961793,
    "y2": 0.411050679561264,
    "y3": 0.232255698891301
  },
  {
    "x": "2019-07-22",
    "y1": 5.36061555929042,
    "y2": 0.521432027001305,
    "y3": 0.250689518177963
  },
  {
    "x": "2019-07-29",
    "y1": 5.32146406872198,
    "y2": 0.277273880053781,
    "y3": 0.251802763867688
  },
  {
    "x": "2019-08-05",
    "y1": 5.31585071345564,
    "y2": 0.349872342623392,
    "y3": 0.25912099819931
  },
  {
    "x": "2019-08-12",
    "y1": 5.30791645155561,
    "y2": 0.337012307590609,
    "y3": 0.260752988468056
  },
  {
    "x": "2019-08-19",
    "y1": 5.28965145748104,
    "y2": 0.419775878903429,
    "y3": 0.268087847480753
  },
  {
    "x": "2019-08-26",
    "y1": 5.31688521993133,
    "y2": 0.318471918313756,
    "y3": 0.276912038043481
  },
  {
    "x": "2019-09-02",
    "y1": 5.33449065207013,
    "y2": 0.401477887342513,
    "y3": 0.285622900287071
  },
  {
    "x": "2019-09-09",
    "y1": 5.34357858273298,
    "y2": 0.402356037696933,
    "y3": 0.291324076904549
  },
  {
    "x": "2019-09-16",
    "y1": 5.33635806991737,
    "y2": 0.523015955679112,
    "y3": 0.300514188487107
  },
  {
    "x": "2019-09-23",
    "y1": 5.31442566310902,
    "y2": 0.466371663475867,
    "y3": 0.312469739537365
  },
  {
    "x": "2019-09-30",
    "y1": 5.31982142244082,
    "y2": 0.442033572677083,
    "y3": 0.323344009190838
  },
  {
    "x": "2019-10-07",
    "y1": 5.32916312021253,
    "y2": 0.370454502556672,
    "y3": 0.332691247733781
  },
  {
    "x": "2019-10-14",
    "y1": 5.33319685963078,
    "y2": 0.275193618347262,
    "y3": 0.337914619305777
  },
  {
    "x": "2019-10-21",
    "y1": 5.35218187946917,
    "y2": 0.26990885004818,
    "y3": 0.344288856988192
  },
  {
    "x": "2019-10-28",
    "y1": 5.36956368046206,
    "y2": 0.26990885004818,
    "y3": 0.352933242230197
  },
  {
    "x": "2019-11-04",
    "y1": 5.3801652706016,
    "y2": 0.327439515371857,
    "y3": 0.36199424857963
  },
  {
    "x": "2019-11-11",
    "y1": 5.38789602158703,
    "y2": 0.28000799289845,
    "y3": 0.368683678805392
  },
  {
    "x": "2019-11-18",
    "y1": 5.38544307554773,
    "y2": 0.348237641272595,
    "y3": 0.372681980229486
  },
  {
    "x": "2019-11-25",
    "y1": 5.40253132629217,
    "y2": 0.348237641272595,
    "y3": 0.367976638136742
  },
  {
    "x": "2019-12-02",
    "y1": 5.40149970845643,
    "y2": 0.405803387555169,
    "y3": 0.367714273536437
  },
  {
    "x": "2019-12-09",
    "y1": 5.41055063381568,
    "y2": 0.346065891669754,
    "y3": 0.358945966769859
  },
  {
    "x": "2019-12-16",
    "y1": 5.43231167468575,
    "y2": 0.327439515371857,
    "y3": 0.361454248535763
  },
  {
    "x": "2019-12-23",
    "y1": 5.44146131307151,
    "y2": 0.327439515371857,
    "y3": 0.360332607173186
  },
  {
    "x": "2019-12-30",
    "y1": 5.4430323146102,
    "y2": 0.257405555577176,
    "y3": 0.356352269572515
  },
  {
    "x": "2020-01-06",
    "y1": 5.46055751794954,
    "y2": 0.275123780432523,
    "y3": 0.349119664648969
  },
  {
    "x": "2020-01-13",
    "y1": 5.48344489939764,
    "y2": 0.428959886497219,
    "y3": 0.354644063058143
  },
  {
    "x": "2020-01-20",
    "y1": 5.47556006148734,
    "y2": 0.275123780432523,
    "y3": 0.348326357712643
  },
  {
    "x": "2020-01-27",
    "y1": 5.45795712986352,
    "y2": 0.346065891669754,
    "y3": 0.345511850411284
  },
  {
    "x": "2020-02-03",
    "y1": 5.49834307038812,
    "y2": 0.442033572677083,
    "y3": 0.341462731261183
  },
  {
    "x": "2020-02-10",
    "y1": 5.52047107897813,
    "y2": 0.479947242186734,
    "y3": 0.342141510196726
  },
  {
    "x": "2020-02-17",
    "y1": 5.50458504576177,
    "y2": 0.448653438620519,
    "y3": 0.342472503493898
  },
  {
    "x": "2020-02-24",
    "y1": 5.39920100582388,
    "y2": 0.257405555577176,
    "y3": 0.336820056144923
  },
  {
    "x": "2020-03-02",
    "y1": 5.40016396177036,
    "y2": 0.294083307426838,
    "y3": 0.337764540598902
  },
  {
    "x": "2020-03-09",
    "y1": 5.31845089323429,
    "y2": 0.222376430004782,
    "y3": 0.335387919596732
  },
  {
    "x": "2020-03-16",
    "y1": 5.19205406203262,
    "y2": 0.153329031966931,
    "y3": 0.32955892869267
  },
  {
    "x": "2020-03-23",
    "y1": 5.28259233527159,
    "y2": 0.185681481300646,
    "y3": 0.322471026989109
  },
  {
    "x": "2020-03-30",
    "y1": 5.26535783012693,
    "y2": 0.0842376004176029,
    "y3": 0.312682507365067
  },
  {
    "x": "2020-04-06",
    "y1": 5.37121589646147,
    "y2": 0.141988107059199,
    "y3": 0.302370030654397
  },
  {
    "x": "2020-04-13",
    "y1": 5.43211669899908,
    "y2": 0.223211034104346,
    "y3": 0.296118700295984
  },
  {
    "x": "2020-04-20",
    "y1": 5.43031093425743,
    "y2": 0.19649054198593,
    "y3": 0.285653058017523
  },
  {
    "x": "2020-04-27",
    "y1": 5.42688638517505,
    "y2": 0.318471918313756,
    "y3": 0.284273359349723
  },
  {
    "x": "2020-05-04",
    "y1": 5.48689488092077,
    "y2": 0.445021760020186,
    "y3": 0.290152471582139
  },
  {
    "x": "2020-05-11",
    "y1": 5.47519035366706,
    "y2": 0.445021760020186,
    "y3": 0.296031583814556
  },
  {
    "x": "2020-05-18",
    "y1": 5.50958252457894,
    "y2": 0.537313774713097,
    "y3": 0.310026994771352
  },
  {
    "x": "2020-05-25",
    "y1": 5.52730773032064,
    "y2": 0.448653438620519,
    "y3": 0.318703477680751
  },
  {
    "x": "2020-06-01",
    "y1": 5.56147152360063,
    "y2": 0.423597867762293,
    "y3": 0.318435376744005
  },
  {
    "x": "2020-06-08",
    "y1": 5.53851771580415,
    "y2": 0.398776187776332,
    "y3": 0.324617997111196
  },
  {
    "x": "2020-06-15",
    "y1": 5.57578100112178,
    "y2": 0.61167629177169,
    "y3": 0.337898517116292
  },
  {
    "x": "2020-06-22",
    "y1": 5.55678863139376,
    "y2": 0.580382488205475,
    "y3": 0.344815962892712
  },
  {
    "x": "2020-06-29",
    "y1": 5.60295036279597,
    "y2": 0.621768563974688,
    "y3": 0.35190702898211
  },
  {
    "x": "2020-07-06",
    "y1": 5.64309783596847,
    "y2": 0.568646094002425,
    "y3": 0.357906661751205
  },
  {
    "x": "2020-07-13",
    "y1": 5.63233723874576,
    "y2": 0.506529706890555,
    "y3": 0.370362869316874
  },
  {
    "x": "2020-07-20",
    "y1": 5.61900693276637,
    "y2": 0.50634411623482,
    "y3": 0.380975909757273
  },
  {
    "x": "2020-07-27",
    "y1": 5.65587687570588,
    "y2": 0.545358296993569,
    "y3": 0.397125003106712
  },
  {
    "x": "2020-08-03",
    "y1": 5.68060505369409,
    "y2": 0.559067276903488,
    "y3": 0.41741191535354
  },
  {
    "x": "2020-08-10",
    "y1": 5.6813606027536,
    "y2": 0.457546905778127,
    "y3": 0.431005186577414
  },
  {
    "x": "2020-08-17",
    "y1": 5.7079049390712,
    "y2": 0.53735229043621,
    "y3": 0.453660921078345
  },
  {
    "x": "2020-08-24",
    "y1": 5.74183676996922,
    "y2": 0.512296719577983,
    "y3": 0.472176351704284
  },
  {
    "x": "2020-08-31",
    "y1": 5.70913224667013,
    "y2": 0.52106630447702,
    "y3": 0.487069115222918
  },
  {
    "x": "2020-09-07",
    "y1": 5.66850864534269,
    "y2": 0.465586865673891,
    "y3": 0.500523931407316
  },
  {
    "x": "2020-09-14",
    "y1": 5.66295566660904,
    "y2": 0.420346402578672,
    "y3": 0.505617655620561
  },
  {
    "x": "2020-09-21",
    "y1": 5.67409957224549,
    "y2": 0.420346402578672,
    "y3": 0.504383887748486
  },
  {
    "x": "2020-09-28",
    "y1": 5.68889400846012,
    "y2": 0.425041943636226,
    "y3": 0.503384896929288
  },
  {
    "x": "2020-10-05",
    "y1": 5.73448497983609,
    "y2": 0.402635114951556,
    "y3": 0.496650963941211
  },
  {
    "x": "2020-10-12",
    "y1": 5.74239686342317,
    "y2": 0.379638992444399,
    "y3": 0.493200241632404
  },
  {
    "x": "2020-10-19",
    "y1": 5.7318344963177,
    "y2": 0.379638992444399,
    "y3": 0.49100229786651
  },
  {
    "x": "2020-10-26",
    "y1": 5.67670157482531,
    "y2": 0.420346402578672,
    "y3": 0.492080808606627
  },
  {
    "x": "2020-11-02",
    "y1": 5.76684798236861,
    "y2": 0.471687129218044,
    "y3": 0.485081350478944
  },
  {
    "x": "2020-11-09",
    "y1": 5.76130454797608,
    "y2": 0.383026793125466,
    "y3": 0.475213565724944
  },
  {
    "x": "2020-11-16",
    "y1": 5.76347540416569,
    "y2": 0.383026793125466,
    "y3": 0.463276477182483
  },
  {
    "x": "2020-11-23",
    "y1": 5.79307310798997,
    "y2": 0.607559969069269,
    "y3": 0.465222170935825
  },
  {
    "x": "2020-11-30",
    "y1": 5.81424171711133,
    "y2": 0.610441890107132,
    "y3": 0.470417780096654
  },
  {
    "x": "2020-12-07",
    "y1": 5.80731306220728,
    "y2": 0.770569202046589,
    "y3": 0.483629034387243
  },
  {
    "x": "2020-12-14",
    "y1": 5.83783281461003,
    "y2": 0.82881470223075,
    "y3": 0.497801854649102
  },
  {
    "x": "2020-12-21",
    "y1": 5.84168137271182,
    "y2": 0.69176973686822,
    "y3": 0.504436977647338
  },
  {
    "x": "2020-12-28",
    "y1": 5.84820628980332,
    "y2": 0.755374502102571,
    "y3": 0.51932835746356
  },
  {
    "x": "2021-01-04",
    "y1": 5.87254624739712,
    "y2": 0.634839676641753,
    "y3": 0.524202726773837
  },
  {
    "x": "2021-01-11",
    "y1": 5.85713337284912,
    "y2": 0.517863128859625,
    "y3": 0.524481047237919
  },
  {
    "x": "2021-01-18",
    "y1": 5.89902740449219,
    "y2": 0.665237026509719,
    "y3": 0.531689583339554
  },
  {
    "x": "2021-01-25",
    "y1": 5.8641483479413,
    "y2": 0.528413859302182,
    "y3": 0.534830933020969
  },
  {
    "x": "2021-02-01",
    "y1": 5.92425300570411,
    "y2": 0.608830270027173,
    "y3": 0.544255126393394
  },
  {
    "x": "2021-02-08",
    "y1": 5.94151374091093,
    "y2": 0.513569385817764,
    "y3": 0.548916275555349
  },
  {
    "x": "2021-02-15",
    "y1": 5.92583425169117,
    "y2": 0.495646267575548,
    "y3": 0.552446491752315
  },
  {
    "x": "2021-02-22",
    "y1": 5.87667123176226,
    "y2": 0.509045254394362,
    "y3": 0.557766998724455
  },
  {
    "x": "2021-03-01",
    "y1": 5.85603812039015,
    "y2": 0.503278241706934,
    "y3": 0.563948961187582
  },
  {
    "x": "2021-03-08",
    "y1": 5.8869750637579,
    "y2": 0.511217003997204,
    "y3": 0.570527861765222
  },
  {
    "x": "2021-03-15",
    "y1": 5.87912061825876,
    "y2": 0.414617905614357,
    "y3": 0.570241436917006
  },
  {
    "x": "2021-03-22",
    "y1": 5.87333110824849,
    "y2": 0.425269130767711,
    "y3": 0.56792053699449
  },
  {
    "x": "2021-03-29",
    "y1": 5.89931382275995,
    "y2": 0.414617905614357,
    "y3": 0.569500092618934
  },
  {
    "x": "2021-04-05",
    "y1": 5.93047677819349,
    "y2": 0.384847052181471,
    "y3": 0.569591105571735
  },
  {
    "x": "2021-04-12",
    "y1": 5.94142262924727,
    "y2": 0.432336130469704,
    "y3": 0.560829913641756
  },
  {
    "x": "2021-04-19",
    "y1": 5.9388942052387,
    "y2": 0.43817298107187,
    "y3": 0.552216468189993
  },
  {
    "x": "2021-04-26",
    "y1": 5.9350324218178,
    "y2": 0.473507388274048,
    "y3": 0.537363377501366
  },
  {
    "x": "2021-05-03",
    "y1": 5.91996085548277,
    "y2": 0.463415116071049,
    "y3": 0.519093398193381
  },
  {
    "x": "2021-05-10",
    "y1": 5.89652759950899,
    "y2": 0.420346402578672,
    "y3": 0.505522231478904
  },
  {
    "x": "2021-05-17",
    "y1": 5.89958119781618,
    "y2": 0.399104572513312,
    "y3": 0.487708734999441
  },
  {
    "x": "2021-05-24",
    "y1": 5.92019957814068,
    "y2": 0.355847187612562,
    "y3": 0.473759110547981
  },
  {
    "x": "2021-05-31",
    "y1": 5.92498183446957,
    "y2": 0.336570278952021,
    "y3": 0.464694468052601
  },
  {
    "x": "2021-06-07",
    "y1": 5.94343562343861,
    "y2": 0.402635114951556,
    "y3": 0.451564372474693
  },
  {
    "x": "2021-06-14",
    "y1": 5.94066080832332,
    "y2": 0.402635114951556,
    "y3": 0.445275435257162
  },
  {
    "x": "2021-06-21",
    "y1": 5.96418189388062,
    "y2": 0.491295451044134,
    "y3": 0.43939869430801
  },
  {
    "x": "2021-06-28",
    "y1": 5.98360618782503,
    "y2": 0.52106630447702,
    "y3": 0.439773540240973
  },
  {
    "x": "2021-07-05",
    "y1": 5.9878816460199,
    "y2": 0.404976299304823,
    "y3": 0.435240041827436
  },
  {
    "x": "2021-07-12",
    "y1": 5.99001200128414,
    "y2": 0.475918410542053,
    "y3": 0.433583699634821
  },
  {
    "x": "2021-07-19",
    "y1": 5.99705390098506,
    "y2": 0.475918410542053,
    "y3": 0.432215708076577
  },
  {
    "x": "2021-07-26",
    "y1": 5.99203872236227,
    "y2": 0.657306430095002,
    "y3": 0.439520179381467
  },
  {
    "x": "2021-07-28",
    "y1": 5.9920389869671,
    "y2": 0.425230615044599,
    "y3": 0.440050814852979
  },
  {
    "x": "2021-08-02",
    "y1": 5.99699582794612,
    "y2": 0.437945793940385,
    "y3": 0.440684648011612
  },
  {
    "x": "2021-08-09",
    "y1": 5.99971465988579,
    "y2": 0.432661025641303,
    "y3": 0.44158680401296
  },
  {
    "x": "2021-08-16",
    "y1": 5.98886264937868,
    "y2": 0.379260767280763,
    "y3": 0.441307489767924
  },
  {
    "x": "2021-08-23",
    "y1": 6.01705493104506,
    "y2": 0.420346402578672,
    "y3": 0.440708003373373
  }
]

const data = bubbleData.map(dataPoint => {return {...dataPoint, x: new Date(dataPoint.x)}})

ReactDOM.render(
  <React.StrictMode>
    <App data={data}/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
